import { Link, useParams, useNavigate, useLocation } from "react-router-dom";
import React, { useEffect, useRef, useState, useCallback } from "react";
import { putAxiosResponse, getAxiosResponse , postAxiosResponse, downloadFile, postAxiosFormDataResponse} from "../services/authApiRoutes/APImethods";
import APIUrls from "../services/APIUrls";
import { compareDates, dateConvertToTimeStamp, dateInUTC, decodeHtml, generateRelativeDateString, getLatestdate, humanize, utcDateTimeWithTimeZone } from "../services/Util";
import jQuery from "jquery";
import { dateFormat, transformBlankToNull, encodeString } from "../services/Util";
import $ from "jquery";
import { useSelector } from 'react-redux';
import "react-tuby/css/main.css";
import { Player } from "react-tuby";
import FileDownloadMenuItems from "../components/project/FileDownloadMenuItems";
import InContextUtil from "../services/InContextUtil";
import DiscussionOverviewPopup from "../components/project/projectDetail/DiscussionOverviewPopup";
import { RotatingLines } from "react-loader-spinner";
import Constants from "../Constants";
import {getPhaseById,getPhaseByStepAndPhaseNumber,getStepByPhaseId } from "../services/WorkflowUtils";
import { ConditionalBlock } from "../ConditionalBlock";
import SuccessMessage from "../components/SuccessMessage";
import { useTranslation } from "react-i18next";
import ExternalLinks from "./ExternalLinks";
import UploadReviseTranslation from "../components/project/projectDetail/UploadReviseTranslation";
import TimeCode from "./TimeCode";
import Calendar from "react-calendar";
import FileDragUpload from "../components/global/FileDragUpload";
import {AiqeToolTipIcon, calenderIcon, FileIcon, LockIcon, UnlockIcon} from "../AppIcons";
import { diff_match_patch } from 'diff-match-patch';
import {isAllowedToEditSegmentAsync} from "../components/project/ProjectUtil";
import ReactTooltip from "react-tooltip";
import ApproveAssetPopup from "../components/icr/ApproveAssetPopup";



let iframeLoadCount = 0;
let targetAssetInfo = {}

export default function InContextPreview(){  
    const location = useLocation();
    const state = location.state; 
    const [userAccess,setUserAccess] = useState('')
    const [canEditLockedTus,setCanEditLockedTus] = useState(false)
    const [phaseRevisionTask,setPhaseRevisionTask] = useState({})
    const [assigneeStatus,setAssigneeStatus] =useState(false)
    const [inProgressStatus,setInProgressStatus]=useState(false) 
    const [lastUpdateTime,setLastUpdatedTime]=useState(new Date())        
    const revisionFileRef = useRef(null)
    const [revisionSelectedFile, setRevisionSelectedFile] = useState(null);
    const [revisionDocumentFileId, setRevisionDocumentFileId] = useState(null);
    const [isSubmittingRevisionRequest, setIsSubmittingRevisionRequest] = useState(false);
    const [isLineByLineTabStatus, setIsLineByLineTabStatus] = useState(false);
    const accountPermission = useSelector(
        (updateCustomerBootstrapData) => updateCustomerBootstrapData.customer_bootstrap_data,
      ).value;
    const [isAdvanceWorkflow,setIsAdvanceWorkflow] = useState(false);

    useEffect(()=>{
        if(state !== null && state.access){
          setUserAccess(state.access)
        }
      },[state])
    $(document).on("click",".head-switch",function() {
        if ($(this).is(":checked")) {
          $('body').addClass("color-contrast");
         } else {
            $('body').removeClass("color-contrast");
        }
  })
  $(document).on("click",".right-hamburger-menu",function() {
     $('.header .right-logo').toggleClass('show-flex')
  });

  


        let menuHtml = `<div id='contextMenu' class='icr-options'>
                                    <ul class='icr-options-list'>
                                        <li class="hide feedback-option">
                                            <button aria-label='provide feedback' id='provide-feedback' aria-expanded='false'>Provide Feedback</button>
                                            <div class='provide-feedback-form hide' id='provide-feedback-container'>
                                                <h4>Provide Feedback</h4>
                                                
                                                <div class='flex wrap-dropdown'>
                                                    <div class='global-dropdown-block flex-center mar-bot20'>
                                                    <div class='head flex-center'>
                                                    <label>Category</label>
                                                    <span>Optional</span>
                                                    </div>
                                                    <select id='category-options-for-feedback'
                                                    aria-label="Category (Optional)"
                                                    ></select>
                                                    </div>
                                                    <div class='global-dropdown-block flex-center mar-bot20'>
                                                        <div class='head flex-center'>                                                            
                                                            <label>Severity</label>
                                                        <span>Optional</span>
                                                        </div>
                                                        <select id='severity-options-for-feedback'
                                                        aria-label="Severity (Optional)"
                                                        ></select>
                                                        
                                                    </div>
                                               
                                                <div class='form-group w-d100'>
                                                    <div class='form-text'>
                                                    <div class='head flex-center'>
                                                        <label>Description</label>                                                        
                                                    </div>
                                                    <textarea aria-label="Description" aria-required='true' id="feeback-comment" class='textarea' placeholder='5000 characters limit'></textarea>
                                                    <div role="alert" id='feedback-submit-error-message' class="error" style="display: none;">Please provide the Description</div>
                                                    </div>
                                                </div>
                                                <div class='modal-footer flex justify-end'>
                                                    <button aria-label='cancel' class='btn btn-bold' id='provide-feedback-cancel'>Cancel</button>
                                                    <button aria-label='submit' class='btn btn-bold active' id='provide-feedback-submit'>Submit</button>
                                                </div>
                                            </div>
                                        </li>
                                        <li class="hide edit-option">
                                            <button aria-label='Edit Translation' id='edit-tu' aria-expanded='false'>Edit Translation</button>
                                            <div class='provide-feedback-form save-edit hide' id='edit-tu-container'>
                                                <h4>Save Edit</h4>
                                                <div class='flex wrap-dropdown'>
                                                    <div class='global-dropdown-block flex-center'>
                                                    <div class='head flex-center'>
                                                    <label>Category</label>
                                                    <span>Optional</span>
                                                    </div>
                                                    <select id='category-options-for-edit-translation'
                                                    aria-label="Category (Optional)"
                                                    ></select>
                                                    </div>
                                                    <div class='global-dropdown-block flex-center'>
                                                        <div class='head flex-center'>
                                                        <label>Severity</label>
                                                        <span>Optional</span>
                                                            
                                                        </div>
                                                        <div class='global-dropdown-select'>                                                        
                                                        <select id='severity-options-for-edit-translation'
                                                        aria-label="Severity (Optional)"
                                                        ></select>
                                                        </div>
                                                    </div>
                                                </div>                                                
                                                <div class='modal-footer flex justify-end'>
                                                    <button aria-label='cancel' class='btn btn-bold' id='edit-tu-cancel'>Cancel</button>
                                                    <button aria-label='submit' class='btn btn-bold active' id='edit-tu-submit'>Submit</button>
                                                </div>
                                            </div>
                                        </li>
                                        <li class="hide bookmark-option">
                                            <button aria-label='bookmark' id='bookmark'>Bookmark</button>                                                                                        
                                        </li>
                                        <li>
                                            <button aria-label='show history' id='show-history'>Show History</button>                                                                                        
                                        </li>
                                        <li class="hide remove-bookmark-option">
                                            <button aria-label='Remove Bookmark' id='remove-bookmark'>Remove Bookmark</button>                                                                                        
                                        </li>
                                        <li>
                                            <button aria-label='close menu' id='close-tu-menu'>Close Menu</button>                                                                                        
                                        </li>
                                    </ul>
                                </div>`
   
   
   
      $(function ($) {
        $("#line-by-line-view-content .relative").on("scroll", function () {
            $("#line-by-line-view-content .relative").scrollTop($(this).scrollTop());
        });
      });

    const { t } = useTranslation();
    const translate = t;
    const param = useParams();
                    useState({});    
    const [translationUnits, setTranslationUnits] = useState([])
    const translationUnitId = useRef();    
    const [translationUnitForHistory,setTranslationUnitForHistory] = useState();       
    const sourceLanguage = useRef(null)
    const targetLanguage = useRef(null)
    const currentTranslationUnitId = useRef();      
    const feedbackCategoryList = useRef();  
    const feedbackSeverityList = useRef();    
    const currentSelectedTUHtml = useRef();
    const [sourcePreviewToggleButtonText , setSourcePreviewToggleButtonText] = useState("Hide Source Preview");
    const [numberOfTUPages , setNumberOfTUPages] = useState(1);
    const [filterForTUs , setFilterForTUs] = useState("ALL");
    const [showDowloadOptions, setShowDowloadOptions] = useState(false);
    const [showReviewers, setShowReviewers] = useState(false);
    const [showBulkSearch, setShowBulkSearch] = useState(false);
    const [textToBeSearched, setTextToBeSearched] = useState(false);
    const [matchCount, setMatchCount] = useState(0);
    const [QACount,setQACount] = useState(0);
    const [TmCount,setTmCount] = useState(0);
    const [aipeLeveragedCount,setAipeLeveragedCount] = useState(0);
    const [lockedTuCount,setLockedTuCount] = useState(0);
    const [feedbackCount,setfeedbackCount] = useState(0);
    const [editCount, setEditCount] = useState(0);
    const [commentedThisRevisionCount, setCommentedThisRevisionCount] = useState(0);
    const [uncommittedEditsCount, setUncommittedEditsCount] = useState(0);
    const [downloadMenuItems, setDownloadMenuItems] = useState([]);
    const targetAssetData = useRef({});
    const [assetName, setAssetName] = useState([]); 
    const [showActionDropdown, setShowActionDropdown] = useState(false);    
    const projectAssetFileIdForBookmark = useRef();
    const [allowedToEditSegments,setAllowedToEditSegments] = useState(true);        
    const isFileInReviewableState = useRef();        
    const actionList = useRef([]);
    const isRevisionAllowed  = useRef(false)
    const [currentPhase,setCurrentPhase] = useState({})
    const [isPreviewAvailable,setIsPreviewAvailable] = useState(true)
    const navigate = useNavigate();
    const [popUpValue,setPopUpValue ] = useState(null);
    const [messageAndEventList, setMessageAndEventList] = useState([]);  
    const [previewAvailable, setPreviewAvailable ] = useState(true);
    const [sourcePreviewAvailable, setSourcePreviewAvailable ] = useState(false);
    const [videoPreview, setVideoPreview ] = useState(false);
    const [dueDate, setDueDate ] = useState();
    const [assignees, setAssignees] = useState();
    const [videoStreamUrl, setVideoStreamUrl] = useState();    
    const [subtitleLanguage, setSubtitleLanguage] = useState();   
    const [subtitleData, setSubtitleData] = useState();    
    const [refreshVideoStatus, setRefreshVideoStatus] = useState(false); 
    const [commentId, setcommentId] = useState("");   
    const currentPage = useRef(1);
    const searchTextValue = useRef("");   
    const showRefreshPreview  = useRef(false);   
    const [loaderState, setLoaderState] = useState(false); 
    const [actionLoaded, setActionLoaded] = useState(false); 
    const [frameLoaded, setFrameLoaded] = useState(false); 
    const isImageProject = useRef(false);    
    const [refreshInProgress, setRefreshInProgress] = useState(false);    
    const [workflowStatus, setWorkflowStatus] = useState();
    const [assetMovebackMessage, setAssetMovebackMessage] = useState();
    const projectAssetFileIdRef = useRef();
    const [externalAsset, setExternalAsset] = useState({});
    const [successMessage,setSuccessMessage] = useState("");
    const [trgPreviewUrl, setTrgPreviewUrl] = useState(null);
    const [srcPreviewUrl, setSrcPreviewUrl] = useState(null);
    const [revisionDueDate, setRevisionDueDate] = useState(null);
    const [revisionDescription, setRevisionDescription] = useState("");
    const [dueDateCalendarExpanded, setDueDateCalendarExpanded] = useState(false);
    const [viewType,setViewType] = useState('month')
    const [showCalendar, setShowCalendar] = useState(false);
    const [nextAriaLabel, setNextAriaLabel] = useState(Constants.CALENDAR_NAVIGATION_ARIA_LABEL.NEXT_MONTH);
    const [prevAriaLabel, setPrevAriaLabel] = useState(Constants.CALENDAR_NAVIGATION_ARIA_LABEL.PREV_MONTH);
    const [next2AriaLabel, setNext2AriaLabel] = useState(Constants.CALENDAR_NAVIGATION_ARIA_LABEL.NEXT_YEAR);
    const [prev2AriaLabel, setPrev2AriaLabel] = useState(Constants.CALENDAR_NAVIGATION_ARIA_LABEL.PREV_YEAR);

    const [options, setOptions] = useState({});
    const [asset,setAsset] = useState({})

    const [sourcePreviewBundle,setSourcePreviewBundle] = useState([])
    const [targetPreviewBundle,setTargetPreviewBundle] = useState([])
    const [userAssigneeStatusData,setUserAssigneeStatus] = useState([])

    const currentUser = useSelector(store => store.customer_bootstrap_data).value.user;
    


    const custBootstrapDataRedux = useSelector(store => store?.customer_bootstrap_data)?.value;
    const userTimeZone = custBootstrapDataRedux?.user?.timeZone;

    
    let parentHttpDomain = `${process.env.REACT_APP_BACKEND_SERVER}`;


    function getProjectFileTranslationUnitsUrl(assetId,page,filterForTUs, searchTextParam){
        let serachTextToPass =  searchTextValue?.current         
        if(searchTextParam || searchTextParam === ""){
            serachTextToPass = searchTextParam;
            searchTextValue.current = searchTextParam;
        }        
       return APIUrls.PROJECT_TRANSLATED_FILE_TRANSLATION_UNITS(assetId, page, filterForTUs, serachTextToPass)
    }

    
    const handleClickKeydown = event => {
        if (event.key === Constants.ENTER) {
            handleClick(event);
        }
    }
    const handleClick = event => {             
        if(currentTranslationUnitId.current!==event?.currentTarget?.id){
            jQuery("#contextMenu").remove();         
            if(jQuery("span#"+currentTranslationUnitId.current).attr("edit-mode")){
                jQuery("span#"+currentTranslationUnitId.current).removeAttr("edit-mode");   
            }      
            jQuery("#"+currentTranslationUnitId.current+" > .tu-html").html(currentSelectedTUHtml.current);           
        }
        $('.linebykeydown').attr('aria-expanded', 'true');
        currentTranslationUnitId.current = event?.currentTarget?.id;        
        let selector = jQuery("#"+event?.currentTarget?.id);        
        if(jQuery("#"+event?.currentTarget?.id+" > .tu-html").has("span[contenteditable=true]").length === 0){    
            currentSelectedTUHtml.current = jQuery("#"+event?.currentTarget?.id+" > .tu-html").html();                   
        }        
        if(!jQuery("span#"+currentTranslationUnitId.current).attr("edit-mode")){
            jQuery("#contextMenu").remove(); 
            selector.after(menuHtml);          
        }
        else{        
        if(selector.has("span[contenteditable=true]")){            
            jQuery("#edit-tu").trigger("click");
        }
    }
        checkForEditableOptions();   
        if(selector.hasClass("bookmark")){
            jQuery(".bookmark-option").addClass("hide");            
            jQuery(".remove-bookmark-option").removeClass("hide");        
        }
        if(selector.attr("locked") === "true" && !canEditLockedTus){
            jQuery(".edit-option").addClass("hide");
        }
        jQuery(document).mouseup(function (e) {
            var bannerCont = jQuery(".outsideContext");
            if (!bannerCont.is(e.target) && bannerCont.has(e.target).length === 0) {                
                if(jQuery("#"+currentTranslationUnitId.current).attr("contenteditable")){
                    jQuery("#"+currentTranslationUnitId.current+" > .tu-html").html(currentSelectedTUHtml.current);         
                }                            
                jQuery("span#"+currentTranslationUnitId.current).removeAttr("edit-mode");
                jQuery("#"+currentTranslationUnitId.current+" > .tu-html").html(currentSelectedTUHtml.current);  
                jQuery("#contextMenu").remove(); 
                $('.linebykeydown').attr('aria-expanded', 'false');
            }
          });
      };
      jQuery(document).on("keydown", '.linebykeydown', function (event) {
         if (event.key === Constants.ESCAPE) {
            jQuery("#contextMenu").remove(); 
            jQuery(event.target).trigger('focus') ;
            $('.linebykeydown').attr('aria-expanded', 'false');
         }
      })
      jQuery(document).on("keydown", '#contextMenu', function (event) {
        if (event.key === Constants.ESCAPE) {
            jQuery(event.target).closest('.outsideContext').children().first().attr('aria-expanded', 'false');
            jQuery(event.target).closest('.outsideContext').children().first().trigger('focus');
            jQuery("#contextMenu").remove(); 
            $('.linebykeydown').attr('aria-expanded', 'false');
        }
        if (document.activeElement.id === 'provide-feedback') {
          if (event.key === Constants.TAB && event.shiftKey) {
            event.preventDefault();
            jQuery(event.target).closest('.outsideContext').children().first().trigger('focus');            
            jQuery("#contextMenu").remove();  
            $('.linebykeydown').attr('aria-expanded', 'false');
          }
      }
      if (document.activeElement.id === 'close-tu-menu') {
         if (event.key === Constants.TAB && !event.shiftKey) {
            event.preventDefault();
            jQuery(event.target).closest('.outsideContext').children().first().trigger('focus');            
            jQuery("#contextMenu").remove();  
            $('.linebykeydown').attr('aria-expanded', 'false');
          }
       }
      })

    function isRevisionPhaseAssignedToCustomer(task) {
        if ((task?.type?.originalEnum === "REVISE_PROJECT_ASSETS")
            && (task?.assigneeUser !== '')
            && (task?.assigneeUser.userId === currentUser.userId)
            && (targetAssetData.current.status === "IN_REVISION")) {
            return true;
        }
        return false;
    }

      function checkForEditableOptions(){            
        if(isFileInReviewableState.current){
            if(!allowedToEditSegments){            
                jQuery(".feedback-option").removeClass("hide");   
                jQuery(".bookmark-option").removeClass("hide");        
            }
            else{            
                jQuery(".feedback-option").removeClass("hide");
                jQuery(".edit-option").removeClass("hide");
                jQuery(".bookmark-option").removeClass("hide");
            }
        }
        
        
      }
      $(document).on("click",".clickActionDropdown",function() {
        $(this).addClass('clickActive')
        $(document).mouseup(function(e) {
            var bannerCont = $('.button-dropdown');
            if (!bannerCont.is(e.target) && bannerCont.has(e.target).length === 0) {
             setShowActionDropdown(false)
              $('.button-dropdown .clickActionDropdown').removeClass('clickActive')
            }
          });
     });
     const actionEscFocus = (event) => {
        if (event.key === Constants.ESCAPE) {
            setShowActionDropdown(false)
          $(".clickActive").trigger("focus");
          $('.button-dropdown .clickActionDropdown').removeClass('clickActive')
        }
        if (event.key === Constants.TAB && event.shiftKey && event.target.ariaExpanded === 'true') {
          setTimeout(() => {
            $(".clickActive").trigger("focus");
            $('.button-dropdown .clickActionDropdown').removeClass('clickActive')
          });
          setShowActionDropdown(false)
        }
      }
      const actionModalFocus = (event) => {
        if (event.key === Constants.ESCAPE) {
            setShowActionDropdown(false)
          $(".clickActive").trigger("focus");
          $('.button-dropdown .clickActionDropdown').removeClass('clickActive')
        }
        if ($(document.activeElement).is('li:first-child a')) {
          if (event.key === Constants.TAB && event.shiftKey) {
            event.preventDefault();
            setShowActionDropdown(false)
            $(".clickActive").trigger("focus");
            $('.button-dropdown .clickActionDropdown').removeClass('clickActive')
          }
      }
      if ($(document.activeElement).is('li:last-child a')) {
          if (event.key === Constants.TAB && !event.shiftKey) {
            event.preventDefault();
            setShowActionDropdown(false)
            $(".clickActive").trigger("focus");
            $('.button-dropdown .clickActionDropdown').removeClass('clickActive')
          }
       }
      }

      $(document).on("click",".downloadLangdoc",function() {
        $(this).addClass('clickActive')
        $(document).mouseup(function(e) {
            var bannerCont = $('.outsideClick');
            if (!bannerCont.is(e.target) && bannerCont.has(e.target).length === 0) {
                setShowDowloadOptions(false)
                $('.downloadLangdoc').removeClass('clickActive')
            }
          });
     });

     const handleEscFocus = (event) => {
        if (event.key === Constants.ESCAPE) {
          setShowDowloadOptions(false)
          $(".clickActive").trigger("focus");
          $('.downloadLangdoc').removeClass('clickActive')
        }
        if (event.key === Constants.TAB && event.shiftKey && event.target.ariaExpanded === 'true') {
            $(".clickActive").trigger("focus");
            $('.downloadLangdoc').removeClass('clickActive')
            setShowDowloadOptions(false)
        }
        
      }

      const handleModalFocus = (event) => {
        if (event.key === Constants.ESCAPE) {
            setShowDowloadOptions(false)
          $(".clickActive").trigger("focus");
          $('.downloadLangdoc').removeClass('clickActive')
        }
        if ($(document.activeElement).is('li:first-child a')) {
          if (event.key === Constants.TAB && event.shiftKey) {
            event.preventDefault();
            setShowDowloadOptions(false)
            $(".clickActive").trigger("focus");
            $('.downloadLangdoc').removeClass('clickActive')
          }
      }
      if ($(document.activeElement).is('li:last-child a')) {
          if (event.key === Constants.TAB && !event.shiftKey) {
            event.preventDefault();
            setShowDowloadOptions(false)
            $(".clickActive").trigger("focus");
            $('.downloadLangdoc').removeClass('clickActive')
          }
      }
      }

      $(".multipleUser").on("keydown", function (e) {
        $(document).mouseup(function(e) {
            var bannerCont = $('.discussion-box.download-dropdown');
            if (!bannerCont.is(e.target) && bannerCont.has(e.target).length === 0) {
                setShowReviewers(false);
                $('.multipleUser').removeAttr("aria-labelledby");
            }
          });
         if (e.key === Constants.ESCAPE) {
             setShowReviewers(false)
             $(".multipleUser").trigger("focus");
             $('.multipleUser').removeAttr("aria-labelledby");
            }
          if (e.key === Constants.TAB) {
            setShowReviewers(false)
            $(".multipleUser").trigger("focus");
            $('.multipleUser').removeAttr("aria-labelledby");
        }
      });
      
     

      jQuery(document).on("keydown", '#provide-feedback-container', function (event) {
        if (event.key === Constants.ESCAPE) {
            jQuery("#provide-feedback-container").addClass("hide"); 
            jQuery(event.target).closest('.outsideContext').children().first().attr('aria-expanded', 'false');
            jQuery(event.target).closest('.outsideContext').children().first().trigger('focus');            
            jQuery("#contextMenu").remove();  
            $('#provide-feedback').attr('aria-expanded', function(index, attr){
                return attr === 'true' ? 'false': 'true';
            }); 
        }
        if (document.activeElement.id === 'category-options-for-feedback') {
          if (event.key === Constants.TAB && event.shiftKey) {
            event.preventDefault();
            jQuery("#provide-feedback-container").addClass("hide");
            jQuery(event.target).closest('.outsideContext').children().first().trigger('focus');            
            jQuery("#contextMenu").remove();  
            $('#provide-feedback').attr('aria-expanded', function(index, attr){
                return attr === 'true' ? 'false': 'true';
            }); 
          }
      }
      if (document.activeElement.id === 'provide-feedback-submit') {
         if (event.key === Constants.TAB && !event.shiftKey) {
            event.preventDefault();
            jQuery("#provide-feedback-container").addClass("hide");
            jQuery(event.target).closest('.outsideContext').children().first().attr('aria-expanded', 'false');
            jQuery(event.target).closest('.outsideContext').children().first().trigger('focus');            
            jQuery("#contextMenu").remove();  
            $('#provide-feedback').attr('aria-expanded', function(index, attr){
                return attr === 'true' ? 'false': 'true';
            }); 
          }
       }
      })

      jQuery(document).on("keydown", '#edit-tu-container', function (event) {        
        if (event.key === Constants.ESCAPE) {            
            jQuery("#"+currentTranslationUnitId.current+" > .tu-html").html(currentSelectedTUHtml.current);   
            jQuery("span#"+currentTranslationUnitId.current).removeAttr("edit-mode");                  
            jQuery(event.target).closest('.outsideContext').children().first().trigger('focus');            
            jQuery("#contextMenu").remove();  
            $('#edit-tu').attr('aria-expanded', function(index, attr){
                return attr === 'true' ? 'false': 'true';
            }); 
        }
        if (document.activeElement.id === 'category-options-for-edit-translation') {
          if (event.key === Constants.TAB && event.shiftKey) {
            event.preventDefault();        
            jQuery("#"+currentTranslationUnitId.current+" > .tu-html").html(currentSelectedTUHtml.current);  
            jQuery("span#"+currentTranslationUnitId.current).removeAttr("edit-mode");                   
            jQuery(event.target).closest('.outsideContext').children().first().trigger('focus');            
            jQuery("#contextMenu").remove();  
            $('#edit-tu').attr('aria-expanded', function(index, attr){
                return attr === 'true' ? 'false': 'true';
            }); 
          }
      }
      if (document.activeElement.id === 'edit-tu-submit') {
         if (event.key === Constants.TAB && !event.shiftKey) {
            event.preventDefault();            
            jQuery("#"+currentTranslationUnitId.current+" > .tu-html").html(currentSelectedTUHtml.current);   
            jQuery("span#"+currentTranslationUnitId.current).removeAttr("edit-mode");                  
            jQuery(event.target).closest('.outsideContext').children().first().trigger('focus');            
            jQuery("#contextMenu").remove();  
            $('#edit-tu').attr('aria-expanded', function(index, attr){
                return attr === 'true' ? 'false': 'true';
            }); 
          }
       }
      })
      function getFeedbackErrorType(feedbackErrorTypeId){
        return feedbackCategoryList.current.filter(e=> e.id == feedbackErrorTypeId)        
      }

      function bookmarkTU(){
        postAxiosResponse(APIUrls.CUSTOMER_TRANSLATION_UNIT_BOOKMARK(param.id,translationUnitId.current,currentTranslationUnitId.current)).then(res=>{
            jQuery("#contextMenu").remove();
            const bookmarkedTU = res.data.data;            

            jQuery('.bookmark').each(function(i, obj) {
                jQuery(obj).removeClass("bookmark");
            });

            jQuery("span#"+bookmarkedTU?.idForUrl).addClass("bookmark");
            jQuery("span#"+bookmarkedTU?.idForUrl).trigger('focus');
            document.getElementById('target-preview')?.contentWindow
                            .postMessage(JSON.stringify({
                                        data : bookmarkedTU?.docSegPos,
                                        action: "SHOW_BOOMARK"
                            })
                            ,parentHttpDomain);
        }).catch(err=>{
            console.error(err)
        })

    }

      function paginateForTus(page){            
            currentPage.current = page.i+1;
            getAxiosResponse(getProjectFileTranslationUnitsUrl(translationUnitId.current, page.i+1, filterForTUs))
        .then((res)=>{                            
            prepSegmentDataAndSetTranslationUnits(res?.data?.data?.result);            
            getAxiosResponse(APIUrls.BOOKMARKED_TU_FOR_FOR_LINE_BY_LINE(param.id,asset.id)).then((res)=>{
                const bookMarkTUId = res.data.data.idForUrl
                jQuery('.bookmark').each(function(i, obj) {
                    jQuery(obj).removeClass("bookmark");
                });
                jQuery("span#"+bookMarkTUId).addClass("bookmark");
              });            
            sameHeight();

        }).catch(err=>{
            console.error(err)
        })
      }

      function paginateICR(page){
        currentPage.current = page.i+1;
            getAxiosResponse(getProjectFileTranslationUnitsUrl(translationUnitId.current, page.i+1, filterForTUs))
        .then((res)=>{
            let translationUnitList =  res?.data?.data?.result;
            document.getElementById('target-preview')?.contentWindow
                            .postMessage(JSON.stringify({
                                        data : translationUnitList[0].docSegPos,
                                        action: "SCROLL_TO_TU"
                            })
                            ,parentHttpDomain);
            document.getElementById('source-preview')?.contentWindow
                            .postMessage(JSON.stringify({
                                        data : translationUnitList[0].docSegPos,
                                        action: "SCROLL_TO_TU"
                            })
                            ,parentHttpDomain);             
            prepSegmentDataAndSetTranslationUnits(translationUnitList);

        }).catch(err=>{
            console.error(err)
        })
    }

      function navigateBack(){
          $("body").removeClass("modal-open")
        navigate(`/project/${param.id}`,{state:{langCode:param.lang}})
      }

      function refreshVideo(){
        setRefreshVideoStatus(true);
        getAxiosResponse(APIUrls.BRIGHTCOVE_VIDEO_SOURCE(param.id,targetAssetData.current?.assets[0].id)).then(res=>{
            setVideoStreamUrl(res?.data?.data?.body?.assetUrl);
            setRefreshVideoStatus(false);
        }).catch(err=>{
            console.error(err)
        })
      }

      function checkSyncingStatus(){
        setTimeout(function(){
            getAxiosResponse(APIUrls.PROJECT_TRANSLATED_FILE_SYNC(param.id,targetAssetData.current?.id)).then((response2)=>{                
                if(response2.data.data.syncStatus === "IN_REVIEW"){
                        getAxiosResponse(APIUrls.PROJECT_TRANSLATED_ASSETS_BY_LANG(param.id,param.lang,param.phaseId)).then(response3=>{                            
                            response3.data.data.result.forEach(element => {
                                if(element.id === targetAssetData.current.id) {                                   
                                var jsonObject = element.files;  
                                if(videoPreview ){                                       
                                    let subtitleUrl =  APIUrls.SUBTITLE_URL_BUILD(param.id,element.files.FINAL.id);
                                    if(element.files.INTERMEDIATE){
                                        subtitleUrl =  APIUrls.SUBTITLE_URL(param.id,element.files.INTERMEDIATE.id);                                        
                                    }   
                                    getAxiosResponse(`${subtitleUrl}`).then(res=>{                                
                                        setSubtitleData(res?.data);  
                                        setRefreshInProgress(false);                                                                                 
                                    }).catch(err=>{
                                        console.error(err)
                                    })                                          
                                    
                                }                                 
                                for (var prop in jsonObject) {                                                                          
                                    if(prop === "FINAL"){   
                                                                                                                                  
                                            let trgPreviewAssetFile = getTrgPreviewAssetFile(element);                                                                                                                                                                                                
                                            let trgPreviewUrl = trgPreviewAssetFile ? APIUrls.PROJECT_ASSET_PREVIEW_BY_FILE_ID(param.id,trgPreviewAssetFile.asset.id,trgPreviewAssetFile.id,1):null;                                                                                                                                
                                            setTimeout(function(){
                                                setTrgPreviewUrl(`${process.env.REACT_APP_BACKEND_SERVER}/html${trgPreviewUrl}`);
                                                //keeping it intentionally
                                                // jQuery("#target-preview").attr("src",`${process.env.REACT_APP_BACKEND_SERVER}/html${trgPreviewUrl}`)    
                                                setRefreshInProgress(false);
                                            },4000)                                                                                        
                                             navigate(`/project/${param.id}/review/${param.phaseId}/${param.lang}/${jsonObject[prop].documentFile.id}`);
                                      }                                         
                                    }
                                    
                                }                                                                                  
                            })
                    })                        
                }else{
                    checkSyncingStatus();
                }                
            }).catch(err=>{
                console.error(err)
            })
        },5000);        
      }

      function refreshPreview(){        
        setRefreshInProgress(true);        
        getAxiosResponse(APIUrls.CUSTOMER_UNCOMMITTED_TRANSLATION_UNIT_VIEW_BY_PTA(targetAssetData.current?.id)).then(res=>{            
            if(res.data.data.length>0 || videoPreview){                
                putAxiosResponse(APIUrls.PROJECT_TRANSLATED_FILE_COMMIT_EDITS(param.id,param.phaseId) ,transformBlankToNull(targetAssetData.current?.files?.FINAL)).then(response=>{                    
                    checkSyncingStatus();
                })
            }else if(isEloquaProject() && isImageProject.current){
                postAxiosResponse(
                    APIUrls.RETRY_ASSET_SYNC(param.id, param.lang),
                    [targetAssetData.current.id]
                  ).then((res) => {
                    checkSyncingStatus();
                  }).catch(err=>{
                    console.error(err)
                })

            }else{
                setRefreshInProgress(false);
            }
            
        })
      }

      
        
    function toggleSourceViewHideAndShow(){        
        if(jQuery(".icr-content-inner-right").hasClass("w-d100")){            
            jQuery(".icr-content-inner-left").removeClass("w-d0");
            jQuery(".icr-content-inner-right").removeClass("w-d100");  
            setSourcePreviewToggleButtonText("Hide Source Preview");   
            jQuery(".hide-show button").attr('aria-label', 'Hide Source Preview');
            jQuery(".splitter").removeClass("hide");   
        }else{            
            jQuery(".icr-content-inner-left").addClass("w-d0");
            jQuery(".icr-content-inner-right").addClass("w-d100");
            setSourcePreviewToggleButtonText("Show Source Preview");
            jQuery(".hide-show button").attr('aria-label', 'Show Source Preview');
            jQuery(".splitter").addClass("hide");
        }        
    }

    

    function showEditView(){        
        jQuery(".edit-history").removeClass("hide");          
        jQuery(".edit-history-btn").addClass("active");
        jQuery(".feedback-btn").removeClass("active");
        jQuery(".feedback-content").addClass("hide");  
        jQuery(".feedback-btn").attr("aria-label", "feedbacks");
        jQuery(".edit-history-btn").attr("aria-label", "Current tab edit history");
    }

    function showFeedbackView(){        
        jQuery(".feedback-content").removeClass("hide");          
        jQuery(".edit-history").addClass("hide");
        jQuery(".edit-history-btn").removeClass("active");
        jQuery(".feedback-btn").addClass("active");
        jQuery(".feedback-btn").attr("aria-label", "Current tab feedbacks");
        jQuery(".edit-history-btn").attr("aria-label", "edit history");
    }

    function isMarketoProject() {
        return (targetAssetData.current?.assets[0]?.contentType === "MARKETO");
    }

    function isMarketoRestProject() {    		
          return (targetAssetData.current?.assets[0]?.contentType === "MARKETOREST");
    }

    function isEloquaProject() {
        return (targetAssetData.current?.assets[0]?.contentType === "ELOQUA");
    }

    function isExactTargetProject() {
        return (targetAssetData.current?.assets[0]?.contentType === "EXACTTARGET");
    }
    
    function prepSegmentDataAndSetTranslationUnits(translationUnits){                
        translationUnits?.forEach(function(segment) {
            segment.translations[segment.translations.length-1].tokenizedText = InContextUtil.tokenizeSegmentContent(segment.translations[segment.translations.length-1].rawText, targetAssetData.current?.assets[0]?.contentType);
            if(isMarketoProject()) {
                InContextUtil.annotateMarketoSegment(segment);
            } else if(isMarketoRestProject()) {
                InContextUtil.annotateMarketoRestSegment(segment);
            } else if(isEloquaProject()) {
                InContextUtil.annotateEloquaSegment(segment);
            } else if(isExactTargetProject()) {
                InContextUtil.annotateExactTargetSegment(segment);
            }
        });        
        setTranslationUnits(translationUnits);        

    }

    useEffect(()=>{        
        sameHeight();
    },[translationUnits])
    useEffect(()=>{
        if(!isPreviewAvailable && currentPhase.id){
            var data = {
                   phaseId:param.phaseId, entry:asset, assetData:targetAssetData, phase:currentPhase,langCode:param.lang
              }
               navigate(`/project/${parseInt(param.id)}`,{state:data});
        }
    },[isPreviewAvailable,currentPhase])
    function handlingSearch(event){
        if (event.key===Constants.TAB) {
            $('#textToSearch').removeAttr("aria-labelledby");
        }
    }
    function searchText(){
        document.getElementById('target-preview')?.contentWindow
                            .postMessage(JSON.stringify({
                                        data : textToBeSearched,
                                        action: "TEXT_SEARCH"            
                            })
                            ,parentHttpDomain);                                  
            getAxiosResponse(getProjectFileTranslationUnitsUrl(translationUnitId.current, currentPage.current, filterForTUs, textToBeSearched))
        .then((res)=>{                  
            prepSegmentDataAndSetTranslationUnits(res?.data?.data?.result);      
            setNumberOfTUPages(res?.data?.data?.numOfPages); 
            $('#textToSearch').attr("aria-labelledby", "matchFound");
        }).catch(err=>{
            console.error(err)
        })   
        
    }
     

    function showLineByLineView(){        
        jQuery("#preview-btn").removeClass("active");
        jQuery("#preview-content").addClass("hide");
        jQuery(".zoom.flex-center").addClass("hide");
        jQuery("#line-by-line").addClass("active");
        jQuery("#line-by-line-view-content").removeClass("hide");
        if(!sourcePreviewAvailable){
            jQuery(".icr-content-inner-left").removeClass("w-d0");
            jQuery(".icr-content-inner-right").removeClass("w-d100");  
        }
        getAxiosResponse(getProjectFileTranslationUnitsUrl(translationUnitId.current, currentPage.current, filterForTUs))
        .then((res)=>{
            prepSegmentDataAndSetTranslationUnits(res?.data?.data?.result);
        }).catch(err=>{
            console.error(err)
        })       
    }

    function showPreview(){
        jQuery("#preview-btn").addClass("active");        
        jQuery("#preview-content").removeClass("hide");
        jQuery(".zoom.flex-center").removeClass("hide");
        jQuery("#line-by-line").removeClass("active");
        jQuery("#line-by-line-view-content").addClass("hide");        
        if(!sourcePreviewAvailable){
            jQuery(".icr-content-inner-left").addClass("w-d0");
            jQuery(".icr-content-inner-right").addClass("w-d100");  
        }
    } 

      const isVideoAssetType = (logicalProjectAsset) => {
        // FIXME: This is no robust check. It has been placed as hack for enabling feature          
        var isVideoAsset = false,
          assetDetails = logicalProjectAsset?.assets,
          asset = null;
          if(assetDetails){
            asset = assetDetails[0];
          }                
    
        // this check for external asset -- this is really sloppy
        if (
          assetDetails &&
          asset &&
          asset.parentAssetType &&
          asset.parentAssetType === "VIDEO"
        ) {                        
          isVideoAsset = true;        
        }
        // this is for project created with local source upload
        else if (
          logicalProjectAsset.fileType &&
          logicalProjectAsset.fileType === "MP4"
        ) {
          isVideoAsset = true;
        }

        if(isVideoAsset && logicalProjectAsset.sourceProjectAssetId){                
            let subtitleUrl =  APIUrls.SUBTITLE_URL_BUILD(param.id,logicalProjectAsset.files.FINAL.id);            
            if(logicalProjectAsset.files.INTERMEDIATE){
                subtitleUrl =  APIUrls.SUBTITLE_URL(param.id,logicalProjectAsset.files.INTERMEDIATE.id);
            }                      
            getAxiosResponse(`${process.env.REACT_APP_BACKEND_SERVER}${subtitleUrl}`).then(res=>{                                
                setSubtitleData(res?.data);                
                setSubtitleLanguage(asset.language)                
            if(logicalProjectAsset.files.FINAL.asset.parentAssetUrl){
                 setVideoStreamUrl(logicalProjectAsset?.files?.FINAL?.asset?.parentAssetUrl);
            }else{
                getAxiosResponse(APIUrls.VIDEO_STREAM_URL(param.id,logicalProjectAsset?.files?.FINAL?.id)).then((res)=>{
                    setVideoStreamUrl(res?.data?.data?.body?.streamUrl);
                })                
            }                      
            }).catch(err=>{
                console.error(err)
            })         
        }                            
        return isVideoAsset;
      };

    //need this method for future development

     function displayRefreshPreview(isVideoAsset,translatedAsset) {
        if(isVideoAsset) {
            return true;
        }        
                
        if(translatedAsset?.assets[0]?.contentType === "ELOQUA" && isImageProject.current){                        
            return true;
        }        
        if (translatedAsset?.fileType === "PPTX" || translatedAsset?.fileType === "POTX") {
            return true;
        }

        if(translatedAsset?.files?.FINAL?.asset?.assetType === 'INDESIGN' || translatedAsset?.files?.FINAL?.asset?.assetType === 'PHOTOSHOP'){
            return true;
        }
        return false;
    }

     
      const downloadAttachment = (fileName) => {
        const url = APIUrls.PROJECT_FILE_ATTACHMENT(param.id, targetAssetData.current.id, commentId)
        downloadFile(url, fileName);
    };

      function sendMessage(){
        let message = jQuery("#message").val();
    

        postAxiosFormDataResponse(APIUrls.CUSTOMER_PROJECT_TRANSLATION_TRANSLATED_ASSETS_DISCUSSION(param.id,targetAssetData.current.id,"json"),
        {
            text: message,
            projectTranslationAssetId: targetAssetData.current.id,
            projectId: parseInt(param.id),
            hasDocument: "false"
        }).then(res=>{            
            postAxiosFormDataResponse(APIUrls.CUSTOMER_PROJECT_TRANSLATION_TRANSLATED_ASSETS_DISCUSSION(param.id,targetAssetData.current.id,"htm"),
        {
            text: message
        }).then(res=>{            
            if(res?.data?.data?.statusCodeValue === 200){
                getAxiosResponse(APIUrls.CUSTOMER_PROJECT_TRANSLATION_TRANSLATED_ASSETS_DISCUSSION(param.id,targetAssetData.current.id,"json")).then(res=>{
                    let eventList = res.data?.data?.messageAndEventList;
                    let data = eventList.sort((o1,o2)=>{
                        return new Date(o2.date)-new Date(o1.date);
                    });
                    const commentId = eventList[eventList.length - 1]?.message?.id;
                    setcommentId(commentId);
                    setMessageAndEventList(data);
                    jQuery("#message").val("");
                }) ;
            }
        }).catch(err=>{
            console.error(err)
        })
            
        }) ;
      }

      function revertTranslation(translationId, index){
        postAxiosResponse(APIUrls.TRANSLATION_UNIT_REVERT_TRANSLATION(translationId,index-1)).then(res=>{
            getAxiosResponse(APIUrls.CUSTOMER_TRANSLATION_UNIT(translationId))
                        .then(res=>{
                            const updatedTranslationUnit = transformBlankToNull(res.data.data);                            
                            let latestTranslation = updatedTranslationUnit.translations[updatedTranslationUnit.translations.length-1].rawText;
                            currentSelectedTUHtml.current = latestTranslation;
                            jQuery("#"+currentTranslationUnitId.current+" > .tu-html").html(latestTranslation); 
                            setTranslationUnitForHistory(updatedTranslationUnit);
                            updatePreviewWithEditedSegment(translationId);
                           if(isLineByLineTabStatus)
                           {
                            showLineByLineView();
                           }                          
                        }).catch(err=>{
                            console.error(err)
                        })
        })
      }

      function movebackAsset(){        
        getAxiosResponse(APIUrls.EXISTING_PROJECT_WORKFLOW(param.id, workflowStatus))
                            .then((res)=> {
                                var existingWorkflow = res.data.data;                               
                                for(var workflow in existingWorkflow){                                    
                                    if(existingWorkflow[workflow].displayName[0].code === param.lang){
                                       const workflowResource = existingWorkflow[workflow];
                                       if(workflowResource){                                            
                                            var currentPhase = getPhaseById(targetAssetData.current.currentPhaseId,workflowResource.resource.steps); 
                                            var newPhaseId = getPhaseByStepAndPhaseNumber(getStepByPhaseId(currentPhase.id,workflowResource.resource.steps).stepNumber, currentPhase.returnPhaseNumber || 2,workflowResource.resource.steps).id;                                                                                         
                                            postAxiosResponse(
                                                APIUrls.PROJECT_TRANSLATED_ASSETS_MOVE_BACK(param.id,param.lang,targetAssetData.current.currentPhaseId,newPhaseId),
                                                {values: [targetAssetData.current.id]}                                            
                                            );
                                            jQuery("body").removeClass("modal-open");  
                                            navigate(`/project/${param.id}`,{state:{langCode:param.lang}}) 
                                       }          
                                    }                                  
                                }                                
                            }).catch(err=>{
                                console.error(err)
                            })
      }

    function getRequestRevisionParams () {
        let params = {
            "description": revisionDescription,
            "assetId": targetAssetData.current.id,
            "phaseId": parseInt(param.phaseId),
            "projectId": "",
            "doRequestRevision": "true",
            "hasDocument": !!revisionSelectedFile,
        }
        if (revisionDocumentFileId) {
            params["documentFileId"] = revisionDocumentFileId
        }
        if (revisionDueDate) {
            params["requestDueDate"] = revisionDueDate.getTime();
        }
        return params
    }

    function requestRevision(){
        setIsSubmittingRevisionRequest(true);
        const params = new URLSearchParams(getRequestRevisionParams());

        const url = APIUrls.REVISE_TRANSLATION(param.id,targetAssetData.current.id,"json") + "?" + params.toString();
        const url2 = APIUrls.REVISE_TRANSLATION(param.id,targetAssetData.current.id,"htm") + "?" + params.toString();

        postAxiosResponse(url, {}).then(res=>{
            if(res.status === 200){
                if (revisionSelectedFile) {
                    setRevisionDocumentFileId(res.data.documentFileId);
                    revisionFileRef.current.startUpload();
                } else {
                    postAxiosResponse(url2, {}).then(response => {
                        jQuery("body").removeClass("modal-open");
                        setIsSubmittingRevisionRequest(false);
                        navigate(`/project/${param.id}`);
                    }).catch(err => {
                        console.error(err)
                        setIsSubmittingRevisionRequest(false);
                    });
                }
            }
        }).catch(err=>{
            console.error(err)
            setIsSubmittingRevisionRequest(false);
        })
    }
    
    function uploadEndHandler(response) {
        if(response.status === 200) {
            jQuery("body").removeClass("modal-open");
            setIsSubmittingRevisionRequest(false);
            navigate(`/project/${param.id}`);
        }
    }

    const handleRevisionFileChange = (e) => {
        if (e.target) {
            setRevisionSelectedFile(e.target.files[0])
        }
    };

    jQuery("#approve").unbind().on("click",function(){
        setPopUpValue("approval");   
        jQuery("body").addClass("modal-open-10");
        
      });   
      jQuery(document).on("click","#approve",function() {
        jQuery(this).parents('.button-dropdown').find('.clickActionDropdown').addClass('focusAdd');
        setTimeout(() => {
            jQuery(".first-focus").trigger("focus");
            jQuery(".first-focus").on("keydown", function (e) {
              if (e.key === Constants.TAB) {
                if (e.shiftKey === true) {
                  e.preventDefault();
                  jQuery(".lastClick").trigger("focus");
                }
              }
            });
            jQuery(".inner-lightbox-panel").on("keydown", function (e) {
              if (e.key === Constants.ESCAPE) {
                jQuery("body").removeClass("modal-open-10")
                setShowActionDropdown(false)
                jQuery('.focusAdd').trigger('focus');
                jQuery('.clickActionDropdown').removeClass('focusAdd');
              }
            });
          }, 500);
      });
     
     $(document).on("click",".first-focus",function() {
       $('.focusAdd').trigger('focus');
       $('.clickActionDropdown').removeClass('focusAdd');
     }); 

     
     $(document).on("click",".first-focusEvent",function() {
       $('.focusAdd').trigger('focus');
       $('.clickActionDropdown').removeClass('focusAdd');
     });
     
     jQuery(document).on("click","#revision",function() {
        jQuery(this).parents('.button-dropdown').find('.clickActionDropdown').addClass('focusAdd');
        setTimeout(() => {
            jQuery(".first-focusEvent").trigger("focus");
            jQuery(".first-focusEvent").on("keydown", function (e) {
              if (e.key === Constants.TAB) {
                if (e.shiftKey === true) {
                  e.preventDefault();
                  jQuery(".finshBtn").trigger("focus");
                }
              }
            });
            jQuery(".inner-lightbox-panel").on("keydown", function (e) {
              if (e.key === Constants.ESCAPE) {
                jQuery("body").removeClass("modal-open")
                setShowActionDropdown(false)
                jQuery('.focusAdd').trigger('focus');
                jQuery('.clickActionDropdown').removeClass('focusAdd');
              }
            });
          }, 500);
      });
      const handleKeyFinishflow = (event) => {
        if (event.key === Constants.TAB) {
          if (event.shiftKey === false) {
            event.preventDefault();
            jQuery(".first-focusEvent").trigger("focus");
          }
        }
      };
      const hideKeyFinishEnterflow = (event) => {
        if (event.key === Constants.ENTER) {
            setShowActionDropdown(false)
            jQuery("body").removeClass("modal-open")
            
        }
      };

      jQuery("#revision").unbind().on("click",function(){                
        setPopUpValue("revision");   
        jQuery("body").addClass("modal-open");      
      });      

      jQuery("#moveback").unbind().on("click",function(){                        
        getAxiosResponse(APIUrls.EXISTING_PROJECT_WORKFLOW(param.id, workflowStatus))
                            .then((res)=> {
                                var existingWorkflow = res.data.data;
                                
                                for(var workflow in existingWorkflow){                                      
                                    if(existingWorkflow[workflow].displayName[0].code === param.lang){
                                       const workflowResource = existingWorkflow[workflow];
                                       if(workflowResource){                                            
                                            var currentPhase = getPhaseById(targetAssetData.current.currentPhaseId,workflowResource.resource.steps);                                            
                                            var newPhase = getPhaseByStepAndPhaseNumber(getStepByPhaseId(currentPhase.id,workflowResource.resource.steps).stepNumber, currentPhase.returnPhaseNumber || 2,workflowResource.resource.steps);                                                                                        
                                            setAssetMovebackMessage(`Move this asset back to phase ${newPhase.phaseNumber} ${newPhase.name && "("+newPhase.name+")" } of this workflow?`);                                             			
                                            setPopUpValue("moveback"); 
                                       }          
                                    }                                  
                                }                                
                            }).catch(err=>{
                                console.error(err)
                            })
        jQuery("body").addClass("modal-open");      
      });    
      
    useEffect(()=>{
        if (successMessage !== Constants.BLANK) {
            setTimeout(function () {
              setSuccessMessage(Constants.BLANK);
            }, 5000);
          }
    },[successMessage]);

    function markEditableContent(node) {  
            
        var nonWhitespaceMatcher = /\S/;
        var foundStartMarker = false;
        var foundEndMarker = false;
        
        function getTextNodes(node) {            
            if(node != null) {
                if(jQuery(node).attr("name") === "tu-start") {
                    foundStartMarker = true;
                }
    
                if(jQuery(node).attr("name") === "tu-end") {
                    foundEndMarker = true;
                }
    
                if (node.nodeType == 3) {                
                    if (nonWhitespaceMatcher.test(node.nodeValue)) {
                        if(foundStartMarker == true && foundEndMarker == false) {//do not add the text nodes after tu-end marker (if any)                        
                            const span = document.createElement('span');
                            span.setAttribute('contentEditable',true)                        
                            node.after(span);
                            span.appendChild(node);                           
                        }
                    }
                } else {
                    for (var i = 0, len = node.childNodes.length; i < len; ++i) {
                        getTextNodes(node.childNodes[i]);
                    }
                }
            }
        }    
        getTextNodes(node);        
        
    }
      
    useEffect(()=>{        
        setLoaderState(true);
        iframeLoadCount = 0;        
             
        getAxiosResponse(APIUrls.CUSTOMER_BOOTSTRAP_DATA).then((res) => {
            setOptions(res.data.data);
          }).catch(err=>{
            console.error(err)
          })

            jQuery(document).off("click","#edit-tu").on("click","#edit-tu",function(e){                                   
                jQuery("span#"+currentTranslationUnitId.current).attr("edit-mode","on");        
                
                if(isFileInReviewableState.current 
                    && jQuery("span#"+currentTranslationUnitId.current).has("span[contenteditable]").length === 0
                    ){                                        
                    markEditableContent(jQuery("span#"+currentTranslationUnitId.current).get(0));                                   
                }        
              if(jQuery("span#"+currentTranslationUnitId.current).has("span[contenteditable]").length === 0){
                setTimeout(function(){
                    jQuery("span#"+currentTranslationUnitId.current).trigger("focus"); 
                },10)        
            }
                
                jQuery('#category-options-for-edit-translation').append('<option value="-1" >Category (Optional)</option>');
              
                for (var i = 0; i < feedbackCategoryList?.current?.length; i++) {        
                    jQuery('#category-options-for-edit-translation').append('<option value="' + feedbackCategoryList.current[i].id + '">' + feedbackCategoryList.current[i].errorCategory.name +" : "+ feedbackCategoryList.current[i].name + '</option>');
                 }
        
                 jQuery('#severity-options-for-edit-translation').append('<option value="-1"  >Severity (Optional)</option>');
            
                 for (var j = 0; j < feedbackSeverityList.current.length; j++) {        
                    jQuery('#severity-options-for-edit-translation').append('<option value="' + feedbackSeverityList.current[j].name + '">' + feedbackSeverityList.current[j].name + '</option>');
                 }
                jQuery("#edit-tu-container").removeClass("hide");
                jQuery("#provide-feedback-container").addClass("hide");
                jQuery(document).on("keydown", '.linebykeydown', function (event) {
                    if (event.key === Constants.TAB) {
                       jQuery('#category-options-for-edit-translation').trigger('focus') 
                    }
                 })
             });
              
              jQuery(document).on("click","#provide-feedback",function(e){               
                jQuery('#category-options-for-feedback').append('<option value="-1">Category (Optional)</option>');           
                for (var i = 0; i < feedbackCategoryList?.current?.length; i++) {        
                    jQuery('#category-options-for-feedback').append('<option value="' + feedbackCategoryList.current[i].id + '">' + feedbackCategoryList.current[i].name+" : "+ feedbackCategoryList.current[i].errorCategory.name + '</option>');
                 }
                 jQuery('#severity-options-for-feedback').append('<option value="-1">Severity (Optional)</option>');
            
                 for (var j = 0; j < feedbackSeverityList.current.length; j++) {        
                    jQuery('#severity-options-for-feedback').append('<option value="' + feedbackSeverityList.current[j].name + '">' + feedbackSeverityList.current[j].name + '</option>');
                 }
                jQuery("#provide-feedback-container").removeClass("hide");
                jQuery("#edit-tu-container").addClass("hide");
                
                $('#provide-feedback').attr('aria-expanded', function(index, attr){
                    return attr === 'true' ? 'false': 'true';
                }); 
              });    

        jQuery(document).on("click","#close-tu-menu",function(e){
            $('.linebykeydown').attr('aria-expanded', 'false');
            jQuery(e.target).closest('.outsideContext').children().first().trigger('focus');            
            jQuery("#contextMenu").remove();  
        });      
                                
    
          jQuery(document).on("click","#show-history",function(e){  
            jQuery(e.target).closest('.outsideContext').children().first().addClass('showingHistory');
            setPopUpValue("showHistory")                
            getAxiosResponse(APIUrls.CUSTOMER_TRANSLATION_UNIT(currentTranslationUnitId.current))
                        .then(res=>{
                            setIsLineByLineTabStatus(true);
                            setTranslationUnitForHistory(transformBlankToNull(res.data.data));
                            jQuery("body").addClass("modal-open");    
                            jQuery("#contextMenu").remove(); 
                            jQuery(".icr-right-modal").on("keydown", function (e) {
                                if (e.key === Constants.ESCAPE) {
                                    e.preventDefault();
                                  jQuery("body").removeClass("modal-open")
                                  jQuery('.focusAdd').trigger('focus');
                                  jQuery('.inline-flex').removeClass('focusAdd');
                                  if (jQuery(".showingHistory").length) {
                                      jQuery(".showingHistory").trigger('focus');
                                      jQuery(".showingHistory").removeClass('showingHistory');
                                  }
                                }
                              });
                              setTimeout(() => {
                            if($("button").hasClass("activeClass")){
                                  jQuery(".rightClose").trigger("focus");
                                    jQuery(".edit-history-btn").on("keydown", function (e) {
                                        if (e.key === Constants.TAB) {
                                          if (e.shiftKey === true) {
                                            e.preventDefault();
                                            jQuery(".edit-history li:last-child button").trigger("focus");
                                          }
                                        }
                                      });
                                    
                                    jQuery(".edit-history li:last-child button").on("keydown", function (e) {
                                        if (e.key === Constants.TAB) {
                                          if (e.shiftKey === false) {
                                            e.preventDefault();
                                            $(".edit-history-btn").trigger("focus");
                                          }
                                        }
                                      });
                                    
                             } 
                            else{
                                  jQuery(".rightClose").trigger("focus");
                                    jQuery(".rightClose").on("keydown", function (e) {
                                        if (e.key === Constants.TAB) {
                                          if (e.shiftKey === false) {
                                              e.preventDefault();
                                              jQuery(".edit-history-btn").trigger("focus");
                                           }
                                          }
                                      });
                                     jQuery(".edit-history-btn").on("keydown", function (e) {
                                        if (e.key === Constants.TAB) {
                                          if (e.shiftKey === true) {
                                            e.preventDefault();
                                            jQuery(".rightClose").trigger("focus");
                                          }
                                        }
                                      });   
                               
                            }  
                          }, 100);        
                        }).catch(err=>{
                            console.error(err)
                    })
                  
                       
          }); 
          jQuery(document).off("click","#edit-tu-cancel").on("click","#edit-tu-cancel",function(e){
            jQuery("#"+currentTranslationUnitId.current+" > .tu-html").html(currentSelectedTUHtml.current);                                 
            jQuery("span#"+currentTranslationUnitId.current).removeAttr("edit-mode");            
            $('.linebykeydown').attr('aria-expanded', 'false');
            jQuery(e.target).closest('.outsideContext').children().first().trigger('focus');            
            jQuery("#contextMenu").remove();  
          });
    
          jQuery(document).off("click","#edit-tu-submit").on("click","#edit-tu-submit",function(e){
          if(jQuery("span#"+currentTranslationUnitId.current).length){
            setLoaderState(true) 
            setInProgressStatus(true)         
            let feedbackCategory = jQuery('#category-options-for-edit-translation').find(":selected").val();
            let feedbackSeverity = jQuery('#severity-options-for-edit-translation').find(":selected").val();                               
            let content = jQuery("span#"+currentTranslationUnitId.current+" > .tu-html");                 
            content.find("span[contenteditable=true]").each((index,element)=>{                
                var textInSpan = jQuery(element).text();
                if(textInSpan.trim() === ""){
                    textInSpan = "-";
                }
                jQuery(element).replaceWith(textInSpan);                
            })                        
            content.find("[equiv-text]").each(function(){
            var encodedStr = encodeString($(this).attr("equiv-text"))
                            $(this).attr("equiv-text",encodedStr);
            });
            let errorType = null
            let errorTypeName = null
            let errorCategoryName = null;
            
                errorType = getFeedbackErrorType(feedbackCategory)[0] 
                if(errorType){
                    errorTypeName = errorType.name;        
                    errorCategoryName =errorType.errorCategory.name;                    
                }else{
                    feedbackCategory = null;
                }       
    
                if(feedbackSeverity == -1){
                    feedbackSeverity = null;
                }
              postAxiosResponse(APIUrls.CUSTOMER_TRANSLATION_UNIT_NEW_TRANSLATION(currentTranslationUnitId.current),
                        { content:content.html().replaceAll("<br>","<br/>"),
                            feedbackCategory: feedbackCategory,
                            feedbackSeverity: feedbackSeverity,                    
                            feedback : {
                                severity: feedbackSeverity,
                                categoryType: errorTypeName,
                                category: errorCategoryName
                            }                                
                        }).then((res)=>{
                            jQuery(e.target).closest('.outsideContext').children().first().trigger('focus');
                            jQuery("#contextMenu").remove();                                 
                            if(res.data.code === 400){
                                setLoaderState(false)   
                                setInProgressStatus(false)       
                                jQuery("span#"+currentTranslationUnitId.current).removeAttr("edit-mode");
                                let errorObject = res.data.data.body.errors;                             
                                for (const key in errorObject) {
                                    jQuery("#"+currentTranslationUnitId.current+"-error").append(errorObject[key]);                                                                                               
                                }                                
                            }
                              else{
                                jQuery("#"+currentTranslationUnitId.current+"-error").html("");
                                jQuery("#"+currentTranslationUnitId.current+" > .tu-html").html(content.html());                             
                                currentSelectedTUHtml.current = content.html();                   
                                jQuery("span#"+currentTranslationUnitId.current).removeAttr("edit-mode");                           
                                updatePreviewWithEditedSegment(currentTranslationUnitId.current);
                                getAxiosResponse(APIUrls.CUSTOMER_TRANSLATION_UNIT_SEGMENT_STATUS(projectAssetFileIdRef.current))
                                .then(res=>{                                
                                var previewStatusCount = res?.data?.data;                                                           
                                    if(previewStatusCount){  
                                        setTmCount(previewStatusCount.LEVERAGED_TUS);                                                       
                                        setQACount(previewStatusCount.QA);
                                        setEditCount(previewStatusCount.EDITED);
                                        setfeedbackCount(previewStatusCount.COMMENTED);
                                        setCommentedThisRevisionCount(previewStatusCount.COMMENTED_THIS_REVISION);
                                        setUncommittedEditsCount(previewStatusCount.UNCOMMITTED_EDITS);
                                        setLoaderState(false)   
                                        setInProgressStatus(false)       
                                    }                                           
                                })
                            }    
                        }).catch(err=>{
                                console.error(err)
                                setLoaderState(false)  
                                setInProgressStatus(false)       
                            })                        
                    $('.linebykeydown').attr('aria-expanded', 'false');
                }
          })
        jQuery(document).on("click", "#provide-feedback-cancel",function(e){                  
            jQuery("#provide-feedback-container").addClass("hide"); 
            jQuery(e.target).closest('.outsideContext').children().first().attr('aria-expanded', 'false');
            jQuery(e.target).closest('.outsideContext').children().first().trigger('focus');            
            jQuery("#contextMenu").remove();  
          });
    
          jQuery(document).on("click","#provide-feedback-submit",function(e){ 
            let feedbackCategory = jQuery('#category-options-for-feedback').find(":selected").val();
            let feedbackSeverity = jQuery('#severity-options-for-feedback').find(":selected").val();    
            let comment = jQuery("#feeback-comment").val();     
            let errorType = null        
            let errorTypeName = null
            let errorCategoryName = null; 
            
                errorType = getFeedbackErrorType(feedbackCategory)[0]   
                if(errorType){     
                errorTypeName = errorType.name;        
                errorCategoryName =errorType.errorCategory.name;
                }else{
                    feedbackCategory = null;
                }
                
                if(feedbackSeverity == -1){
                    feedbackSeverity = null;
                }                            
                
                if(comment === null || comment === ""){                    
                    jQuery("#feedback-submit-error-message").show();
                    jQuery(e.target).parent().prev().find('textarea').trigger('focus');
                }else{                                   
                    postAxiosResponse(APIUrls.CUSTOMER_TRANSLATION_UNIT_COMMENT(currentTranslationUnitId.current),
                        { comment:comment,
                            feedbackCategory: feedbackCategory,
                            feedbackSeverity: feedbackSeverity,                    
                            feedback : {
                                severity: feedbackSeverity,
                                categoryType: errorTypeName,
                                category: errorCategoryName
                            }                
                        }).then((res)=>{
                            jQuery(e.target).closest('.outsideContext').children().first().attr('aria-expanded', 'false');
                            jQuery(e.target).closest('.outsideContext').children().first().trigger('focus');
                            jQuery("#contextMenu").remove();
                            getAxiosResponse(APIUrls.CUSTOMER_TRANSLATION_UNIT_SEGMENT_STATUS(projectAssetFileIdRef.current))
                            .then(res=>{
                            var previewStatusCount = res?.data?.data;                           
                            if(previewStatusCount){   
                                setTmCount(previewStatusCount.LEVERAGED_TUS);                                                                                
                                setQACount(previewStatusCount.QA);
                                setEditCount(previewStatusCount.EDITED);
                                setfeedbackCount(previewStatusCount.COMMENTED);
                                setCommentedThisRevisionCount(previewStatusCount.COMMENTED_THIS_REVISION);   
                                setUncommittedEditsCount(previewStatusCount.UNCOMMITTED_EDITS);
                                if(isRevisionAllowed.current && previewStatusCount?.COMMENTED_THIS_REVISION > 0 && !actionList.current.find(action=>(  ["revision","moveback"].includes(action.id))) ){                                    
                                    actionList.current.push({text:"Request Revision", id:"revision"})    
                                }                        
                            }                                           
                            }).catch(err=>{
                                console.error(err)
                            })
                            
                            jQuery("#contextMenu").remove();
                        }).catch(err=>{
                            console.error(err)
                        })
                    }
          });



        jQuery(document).on("click","#bookmark",function(e){
            bookmarkTU();
        });

        jQuery(document).on("click","#remove-bookmark",function(e){            
            postAxiosResponse(APIUrls.CUSTOMER_TRANSLATION_UNIT_REMOVE_BOOKMARK(param.id,translationUnitId.current)).then(res=>{
                jQuery("#contextMenu").remove();                
                jQuery('.bookmark').each(function(i, obj) {
                    jQuery(obj).removeClass("bookmark");
                }); 
                document.getElementById('target-preview')?.contentWindow
                            .postMessage(JSON.stringify({                                        
                                        action: "REMOVE_BOOKMARK"            
                    })
                    ,parentHttpDomain);                                   
            });
        });              

        jQuery("#final-preview").on("click",function(){
            let isChecked = jQuery(this).is(':checked');
            if(isChecked){                          
                document.getElementById('target-preview')?.contentWindow
                                .postMessage(JSON.stringify({                                        
                                            action: "SHOW_FINAL_PREVIEW"            
                                })
                                ,parentHttpDomain);                
            }else{                
                getAxiosResponse(APIUrls.GET_BOOKMARK_ON_TRANSLATION(param.id,projectAssetFileIdForBookmark.current))
                        .then(res=>{
                            let docSegPos = res?.data?.data?.docSegPos;
                            if(docSegPos){                                                        
                                document.getElementById('target-preview')?.contentWindow
                                .postMessage(JSON.stringify({
                                            data : docSegPos,
                                            action: "SHOW_BOOMARK"            
                                })
                                ,parentHttpDomain);
                               
                            }
                            
                        }).catch(err=>{
                            console.error(err)
                        })
               
            }
        });
        function decodeHTML(str) {
            return ("" + str).split("&lt;").join("<").split("&gt;").join(">").split("&#34;").join('"').split("&#39;").join("'").split("&amp;").join("&");
        }
        //Zoom js 
    $(".zoom .button").on("click", function() {        
        var $button = $(this);
        var oldValue = $button.parent().find("input").val();
        if ($button.hasClass("inc")) {
            var newVal = parseFloat(oldValue) + 50;
            $('.dec').removeClass('readonly');
            $('#text-value strong').text(newVal);
            if(oldValue==50){
                var newVal = parseFloat(oldValue) + 25;
                $('#text-value strong').text(newVal);
                $('.icr-content-inner-left, .icr-content-inner-right').addClass('smallscale');
                $('.icr-content-inner-left, .icr-content-inner-right').removeClass('smallestscale');
                $('.inc').attr('aria-label', 'increase font size ' + newVal + '%');
            }
            if(oldValue==75){
                var newVal = parseFloat(oldValue) + 25;
                $('#text-value strong').text(newVal);
                $('.icr-content-inner-left, .icr-content-inner-right').removeClass('smallscale');
                $('.inc').attr('aria-label', 'increase font size ' + newVal + '%');
            }
            if(oldValue==100){
                $('.icr-content-inner-left, .icr-content-inner-right').addClass('large');
                $('.inc').attr('aria-label', 'increase font size ' + newVal + '%');
            }
            if(oldValue==150){
                $('.inc').addClass('readonly');
                $('.icr-content-inner-left, .icr-content-inner-right').removeClass('large')
                $('.icr-content-inner-left, .icr-content-inner-right').addClass('double');
                $('.inc').attr('aria-label', 'increase font size ' + newVal + '%');
              }
          } else {
         // Don't allow decrementing below zero
          if (oldValue > 0) {
            var newVal = parseFloat(oldValue) - 50;
            $('.icr-content-inner-left, .icr-content-inner-right').removeClass('large');
            $('.inc').removeClass('readonly');
            $('#text-value strong').text(newVal);
            $('.dec').attr('aria-label', 'Reduce font size ' + newVal + '%');
            if(oldValue==200){
                $('.icr-content-inner-left, .icr-content-inner-right').removeClass('double');
                $('.icr-content-inner-left, .icr-content-inner-right').addClass('large');
                $('.dec').attr('aria-label', 'Reduce font size ' + newVal + '%');
            }
            if(oldValue==100){
                $('.icr-content-inner-left, .icr-content-inner-right').addClass('smallscale');
                var newVal = parseFloat(oldValue) - 25;
                $('#text-value strong').text(newVal);
                $('.dec').attr('aria-label', 'Reduce font size ' + newVal + '%');
            }
            if(oldValue==75){
                $('.icr-content-inner-left, .icr-content-inner-right').addClass('smallestscale');
                $('.icr-content-inner-left, .icr-content-inner-right').removeClass('smallscale');
                var newVal = parseFloat(oldValue) - 25;
                $('.dec').addClass('readonly')
                $('#text-value strong').text(newVal);
                $('.dec').attr('aria-label', 'Reduce font size ' + newVal + '%');
            }
           
          } else {
            newVal = 0;
          }
        }
        $button.parent().find("input").val(newVal);
      });
      

        function messageEvent(e) {
            // Get the sent data
            if(e.data){                  
                let message = ""
                try{    
                    message = (e.type === "webpackInvalid" || e.data.type === "webpackWarnings" || e.data.type === "webpackClose") ? e.data:JSON.parse(e.data);
                }catch(err){
                    //silent out webpack related exceptions
                }     
                if(message.action === "EDIT_TU"){                        
                    let errorType = null        
                    let errorTypeName = null
                    let errorCategoryName = null;                             
                        errorType = getFeedbackErrorType(message.feedbackCategory)[0];
                        if(errorType){                            
                            errorTypeName = errorType.name;                              
                            errorCategoryName =errorType.errorCategory.name;                               
                        }else{
                            message.feedbackCategory = null;
                        }                            
                        if(message.feedbackSeverity == -1){
                            message.feedbackSeverity = null;
                        } 
                        postAxiosResponse(APIUrls.CUSTOMER_TRANSLATION_UNIT_NEW_TRANSLATION(message.tuId),
                        { content:message.content,
                            feedbackCategory: errorCategoryName,
                            feedbackSeverity: message.feedbackSeverity,                    
                            feedback : {
                                severity: message.feedbackSeverity,
                                categoryType: errorTypeName,
                                category: errorCategoryName
                            }                                
                        }).then((res)=>{
                            getAxiosResponse(APIUrls.CUSTOMER_TRANSLATION_UNIT_SEGMENT_STATUS(projectAssetFileIdRef.current))
                            .then(res=>{                                
                            var previewStatusCount = res?.data?.data;                                                           
                            if(previewStatusCount){    
                                setTmCount(previewStatusCount.LEVERAGED_TUS);                                                                                                            
                                setQACount(previewStatusCount.QA);
                                setEditCount(previewStatusCount.EDITED);
                                setfeedbackCount(previewStatusCount.COMMENTED);   
                                setCommentedThisRevisionCount(previewStatusCount.COMMENTED_THIS_REVISION);
                                setUncommittedEditsCount(previewStatusCount.UNCOMMITTED_EDITS);                            
                            }                                           
                            }).catch(err=>{
                                console.error(err)
                            })
                        }).catch(err=>{
                            console.error(err)
                        })                        

                }           
                if(message.action === "edit"){                      
                    let errorType = null        
                    let errorTypeName = null
                    let errorCategoryName = null;                             
                        errorType = getFeedbackErrorType(message.feedbackCategory)[0];
                        if(errorType){                            
                            errorTypeName = errorType.name;                              
                            errorCategoryName =errorType.errorCategory.name;                               
                        }else{
                            message.feedbackCategory = null;
                        }                            
                        if(message.feedbackSeverity == -1){
                            message.feedbackSeverity = null;
                        }                                    
                        getAxiosResponse(APIUrls.SHOW_TRANSLATION_HISTORY(message.projectId,translationUnitId.current,message.docSegPos))
                    .then(res=>{
                        const translations = res.data.data.translations;
                        let latestTranslation = translations[translations.length-1]                                                
                        const tokenizedText = InContextUtil.tokenizeSegmentContent(latestTranslation.rawText,targetAssetData.current?.assets[0]?.contentType)                                                                        
                        /**
                         *  Below check is introduced to handle the case where textNodes array is greater than filteredtextList
                         * e.g
                         *   textNodes = [
                                            "步骤",
                                            "4",
                                            "：1234",
                                         "绘制单位条：5678在这里，我们为每个人绘制长度相等的单位条，以表示他们拥有相同数量的钱。1011"
                                        ]

                         * filteredList = [
                                            "步骤4：",
                                            "绘制单位条：在这里，我们为每个人绘制长度相等的单位条，以表示他们拥有相同数量的钱。"
                                        ]

                                 In This case we need to restructure textNodes as follows so that it lenghts becomes equal to that of filteredList
                                 
                               textNodes =   [
                                      "步骤4：",
                                     "1234绘制单位条：5678在这里，我们为每个人绘制长度相等的单位条，以表示他们拥有相同数量的钱。1011"
                                    ]
                         * 
                         */
                        var filteredtextList = tokenizedText.filter(textObject=>!textObject.isTag).map(textObject=>textObject.text);
                        if(message.textNodes.length > filteredtextList.length){                            
                            var textNodesSentence = message.plainText.replace("\n", "\\n").replace("\t", "\\t").replace("\r", "\\r");
                            message.textNodes = balanceOutNodesForUpdate(textNodesSentence,filteredtextList)
                        }



            var textNodeIndex = 0;
            for(var i=0; i<tokenizedText.length; i++) {
                if(!tokenizedText[i].isTag && ((/\S/.test(tokenizedText[i].text)) || tokenizedText[i].text.trim() === "")) {
                    if(message.textNodes[textNodeIndex]) {

                        var decoded = message.textNodes[textNodeIndex];
                            tokenizedText[i].text = message.textNodes[textNodeIndex];
                            if(/\S/.test(decoded)){
                                tokenizedText[i].text = decoded;
                            }else if(decoded.trim() === ""){
                                tokenizedText[i].text = "-";
                             }
                            textNodeIndex++;
            }
        }
        else if(tokenizedText[i].isTag
            && tokenizedText[i].text.match(/equiv-text="{{.+?\..+?}}"/)
            && tokenizedText[i].projectContentType==="MARKETOREST") {
            textNodeIndex++;
        }
    }
    // If the user deleted the final text in a segment after a closing tag, the tokenizedText array will be shorter
    // than the array of text nodes so the last textNodes will still have the deleted text -- handle that here
    if(message.textNodes.length < textNodeIndex  ) {
    	for(let i = textNodeIndex; i < message.textNodes.length; i++) {
	    	tokenizedText[i].text = "";
    	}
    }
    latestTranslation.tokenizedText= tokenizedText;
    const translationList = [latestTranslation];

    var newText = "";
		    var newRawText = "";
            translationList.forEach(translation=>{
                translation.tokenizedText.forEach(snippet=>{                    
                    if(snippet.tokenizedSnippet.length>0) {                        
                        snippet.tokenizedSnippet.forEach(function(subSnippet) {
                          newRawText = newRawText + subSnippet.text;
                          newText = newText + subSnippet.text;
                        });
                    } else {                        
                        newRawText = newRawText + snippet.text;
                        if(!snippet.isTag) {
                            newText = newText + snippet.text;
                        }
                    }
                })
            })
		    

		    latestTranslation.text = newText;
            latestTranslation.rawText = newRawText;

            postAxiosResponse(APIUrls.ADD_FILE_TRANSLATION(message.projectId,translationUnitId.current,message.docSegPos),
                    { content:latestTranslation.rawText,                
                        feedbackCategory: message.feedbackCategory,
                        feedbackSeverity: message.feedbackSeverity,
                        feedback : {
                            severity: message.feedbackSeverity,
                            categoryType: errorTypeName,
                            category : errorCategoryName
                        }                        
                    }).then(res=>{                        
                        getAxiosResponse(APIUrls.CUSTOMER_TRANSLATION_UNIT_SEGMENT_STATUS(message.projectAssetFileId))
                        .then(res=>{
                        var previewStatusCount = res?.data?.data;                           
                        if(previewStatusCount){   
                            setTmCount(previewStatusCount.LEVERAGED_TUS);                                                                                
                            setQACount(previewStatusCount.QA);
                            setEditCount(previewStatusCount.EDITED);
                            setfeedbackCount(previewStatusCount.COMMENTED);           
                            setCommentedThisRevisionCount(previewStatusCount.COMMENTED_THIS_REVISION);
                            setUncommittedEditsCount(previewStatusCount.UNCOMMITTED_EDITS);                    
                        }                                           
                        });
                        
                    }).catch(err=>{
                        console.error(err)
                    })
                        
                    }).catch(err=>{
                        console.error(err)
                    })            
                    
                }

    if(message.action === "SAVE_EDITED_TRANSLATION"){
         let errorType = getFeedbackErrorType(message.feedbackCategory)[0];
         let errorTypeName = null;
         let errorCategoryName = null;
         if(errorType){
             errorTypeName = errorType.name;
             errorCategoryName =errorType.errorCategory.name;
         }else{
             message.feedbackCategory = null;
         }
         if(message.feedbackSeverity == -1){
             message.feedbackSeverity = null;
         }

        postAxiosResponse(APIUrls.ADD_FILE_TRANSLATION(message.projectId,translationUnitId.current,message.docSegPos),
        {
             content: message.rawText,
             feedbackCategory: message.feedbackCategory,
             feedbackSeverity: message.feedbackSeverity,
             feedback : {
                 severity: message.feedbackSeverity,
                 categoryType: errorTypeName,
                 category : errorCategoryName
             }
        }).then(res=>{
            getAxiosResponse(APIUrls.CUSTOMER_TRANSLATION_UNIT_SEGMENT_STATUS(message.projectAssetFileId))
                .then(res=>{
                     var previewStatusCount = res?.data?.data;
                     if(previewStatusCount){
                         setTmCount(previewStatusCount.LEVERAGED_TUS);
                         setQACount(previewStatusCount.QA);
                         setEditCount(previewStatusCount.EDITED);
                         setfeedbackCount(previewStatusCount.COMMENTED);
                         setUncommittedEditsCount(previewStatusCount.UNCOMMITTED_EDITS);
                         setCommentedThisRevisionCount(previewStatusCount.COMMENTED_THIS_REVISION);
                     }
                });

        }).catch(err=>{
            console.error(err)
        });
    }

                if(message.action === "comment"){    
                    let errorType = null        
                    let errorTypeName = null
                    let errorCategoryName = null;                                                           
                        errorType = getFeedbackErrorType(message.feedbackCategory)[0]
                        if(message.feedbackSeverity == -1){
                            message.feedbackSeverity = null;
                        }
                        if(errorType){                        
                        errorTypeName = errorType.name;                         
                        errorCategoryName =errorType.errorCategory.name;                          
                        }else{
                            message.feedbackCategory = null;
                        }    
                    
                    postAxiosResponse(APIUrls.SUBMIT_COMMENT_ON_TRANSLATION(message.projectId,translationUnitId.current,message.docSegPos),
                    { comment:message.comment,
                        feedbackCategory: message.feedbackCategory,
                        feedbackSeverity: message.feedbackSeverity,                    
                        feedback : {
                            severity: message.feedbackSeverity,
                            categoryType: errorTypeName,
                            category : errorCategoryName
                        }                                        
                    }).then(res=>{
                        getAxiosResponse(APIUrls.CUSTOMER_TRANSLATION_UNIT_SEGMENT_STATUS(message.projectAssetFileId))
                        .then(res=>{
                        var previewStatusCount = res?.data?.data;   
                        if(previewStatusCount){    
                            setTmCount(previewStatusCount.LEVERAGED_TUS);                                                                               
                            setQACount(previewStatusCount.QA);
                            setEditCount(previewStatusCount.EDITED);
                            setfeedbackCount(previewStatusCount.COMMENTED);
                            setCommentedThisRevisionCount(previewStatusCount.COMMENTED_THIS_REVISION);  
                            setUncommittedEditsCount(previewStatusCount.UNCOMMITTED_EDITS); 
                                if(isRevisionAllowed.current && previewStatusCount?.COMMENTED_THIS_REVISION > 0 && !actionList.current.find(action=>(  ["revision","moveback"].includes(action.id))) ){                                    
                                    actionList.current.push({text:"Request Revision", id:"revision"})    
                                }                                                
                        }                                           
                        }).catch(err=>{
                            console.error(err)
                        })
                    }).catch(err=>{
                        console.error(err)
                    })
                }
                if(message.action === "bookmark"){
                    postAxiosResponse(APIUrls.BOOKMARK_ON_TRANSLATION(message.projectId,translationUnitId.current,message.docSegPos))
                    .then(res=>{
                        let bookmarkTU = res?.data?.data                        
                        let docSegPos = bookmarkTU?.docSegPos;
                        if(docSegPos){                            
                            document.getElementById('target-preview')?.contentWindow
                            .postMessage(JSON.stringify({
                                        data : docSegPos,
                                        action: "SHOW_BOOMARK"            
                            })
                            ,parentHttpDomain);
                            jQuery('.bookmark').each(function(i, obj) {
                                jQuery(obj).removeClass("bookmark");
                            });
                            jQuery("span#"+bookmarkTU.idForUrl).addClass("bookmark");
                        }
                    }).catch(err=>{
                        console.error(err)
                    })
                }
                if(message.action === "REMOVE_BOOKMARK"){                    
                    postAxiosResponse(APIUrls.REMOVE_BOOKMARK(message.projectId,translationUnitId.current)).then((res)=>{
                        jQuery('.bookmark').each(function(i, obj) {
                            jQuery(obj).removeClass("bookmark");
                        });
                    });
                    document.getElementById('target-preview')?.contentWindow
                            .postMessage(JSON.stringify({                                        
                                        action: "REMOVE_BOOKMARK"            
                    })
                    ,parentHttpDomain);
                }
                if(message.action === "FETCH_TU"){                    
                    getAxiosResponse(APIUrls.SHOW_TRANSLATION_HISTORY(message.projectId,translationUnitId.current,message.docSegPos))
                    .then(res=>{                         
                        const tu = res?.data?.data;                                           
                        document.getElementById('target-preview')?.contentWindow
                            .postMessage(JSON.stringify({
                                        data : tu.translations[tu.translations.length-1].rawText,
                                        tuId : tu.id,
                                        action: "DISPLAY_EDITABLE_TEXT"            
                            })
                            ,parentHttpDomain);
                    }).catch(err=>{
                        console.error(err)
                    })                    
                }

               if(message.action === "FETCH_TU_TO_EDIT"){
                    getAxiosResponse(APIUrls.SHOW_TRANSLATION_HISTORY(message.projectId,translationUnitId.current,message.docSegPos))
                    .then(res=>{
                        const tu = res?.data?.data;
                        let isToken = false;
                        if(isMarketoRestProject()){
                            InContextUtil.annotateMarketoRestSegment(tu);
                            isToken = tu.isToken;
                        }
                        const tokenizedText = InContextUtil.tokenizeSegmentContent(tu.translations[tu.translations.length-1].rawText,targetAssetData.current?.assets[0]?.contentType,);
                        let syncedTuSnippets = null;
                        const syncedTranslations = tu.translations.filter(t => t.synced === true);
                        if(syncedTranslations.length > 0){
                            const latestSyncedTranslation = syncedTranslations[syncedTranslations.length - 1];
                            syncedTuSnippets = InContextUtil.tokenizeSegmentContent(latestSyncedTranslation.rawText,targetAssetData.current?.assets[0]?.contentType);
                            //set empty node for the blanked nodes
                            const initialTuSnippets = InContextUtil.tokenizeSegmentContent(tu.translations[0].rawText,targetAssetData.current?.assets[0]?.contentType);
                            if(syncedTuSnippets.length < initialTuSnippets.length){
                                for(let i=0;i<initialTuSnippets.length;i++){
                                    if(!initialTuSnippets[i].isTag && syncedTuSnippets[i].isTag){
                                        syncedTuSnippets.splice(i, 0, {text:'', isTag:false, tokenizedSnippet:[], isEmpty:true});
                                    }
                                }
                            }
                        }
                        document.getElementById('target-preview')?.contentWindow
                            .postMessage(JSON.stringify({
                                        data : tokenizedText,
                                        tuId : tu.docSegPos,
                                        syncedTuSnippets : syncedTuSnippets,
                                        isToken : isToken,
                                        action: "ADJUST_HTML_FOR_EDIT"
                            })
                            ,parentHttpDomain);
                    }).catch(err=>{
                        console.error(err)
                    });
                }
                if(message.action === "showHistory"){                    
                    setPopUpValue("showHistory");
                    getAxiosResponse(APIUrls.SHOW_TRANSLATION_HISTORY(message.projectId,translationUnitId.current,message.docSegPos))
                    .then(res=>{ 
                        setIsLineByLineTabStatus(false);
                        setTranslationUnitForHistory(transformBlankToNull(res.data.data));
                        jQuery("body").addClass("modal-open");                
                    }).catch(err=>{
                        console.error(err)
                    })
                    
                }
                if(message.action === "getBookmark"){

                    projectAssetFileIdForBookmark.current = message.projectAssetFileId;                    
                    getAxiosResponse(APIUrls.GET_BOOKMARK_ON_TRANSLATION(message.projectId,translationUnitId.current))
                    .then(res=>{
                        let docSegPos = res?.data?.data?.docSegPos;                        
                        if(docSegPos){                            
                            document.getElementById('target-preview')?.contentWindow
                            .postMessage(JSON.stringify({
                                        data : docSegPos,
                                        action: "SHOW_BOOMARK"            
                            })
                            ,parentHttpDomain);
                           
                        }
                        
                    }).catch(err=>{
                        console.error(err)
                    })
                }                

                if(message.action === "SHOW_MATCH_COUNT"){
                    setMatchCount(message.matchCount);
                }

                if(message.action === "GET_SOURCE_PREVIEW_URL"){                    
                    document.getElementById('source-preview')?.contentWindow
                                .postMessage(JSON.stringify({
                                            action: "SOURCE_PREVIEW_URL",
                                            data:jQuery("#source-preview").attr("src")
                                })
                                ,parentHttpDomain);
                }

                if(message.action === "SCROLL_SOURCE"){
                    if(message.sourceScrollPosition){
                        document.getElementById('source-preview')?.contentWindow
                                .postMessage(JSON.stringify({
                                            action: "SCROLL_IFRAME",
                                            scrollPosition:message.sourceScrollPosition
                                })
                                ,parentHttpDomain);
                    }

                }

            }

        }
        window.addEventListener('message', messageEvent);

        
        getAxiosResponse(`${APIUrls.ALL_TASKS}?phaseId=${param.phaseId}&onlyFollowed=false`).then((res)=>{
            let tasks = res.data.data.result;
            var latestTime = 0
            var latestTask = {}
            for (var i = 0; i < tasks.length; i++) {
                let task = tasks[i]; 
                let taskDate = task?.createdDate?.utcTimestamp;
                if(task?.type?.originalEnum === "REVISE_PROJECT_ASSETS" && taskDate >= latestTime){
                    latestTask = task
                    latestTime = taskDate
                    setPhaseRevisionTask(latestTask)
                }
                               
                if(task?.type?.originalEnum === "REVIEW_PROJECT_ASSETS"){
                    setDueDate(task?.relativeDateString)
                }
            }
        }).catch(err=>{
            console.error(err)
        })

        getAxiosResponse(APIUrls.TARGET_ASSET_DATA(param.id, param.lang))
      .then((res) => {        
        if (res.data.data !== "") {

            let targetAsset = null;
            res.data.data.forEach(element => {            
                var jsonObject = element.files;                
                for (var prop in jsonObject) {                                        
                    if(jsonObject[prop].documentFile.id === parseInt(param.docId)){
                        targetAsset = element;                                          
                    }
                }
            })

        if(targetAsset){ 
          targetAssetData.current = targetAsset;   
          targetAssetInfo = targetAsset;                         
          getAxiosResponse(APIUrls.PROJECT_TRANSLATED_FILE_SYNC(param.id,targetAssetData.current?.id)).then((response2)=>{                            
            if(response2.data.data.syncStatus === "SYNCING"){
                navigate(`/project/${param.id}`,{state:{langCode:param.lang}})                
            }                
        })
            var projectAssetFileId = (targetAsset.files.TRANSLATABLE && targetAsset.files.TRANSLATABLE.id) || (targetAsset.files.FINAL && targetAsset.files.FINAL.id) || (targetAsset.files.INTERMEDIATE && targetAsset.files.INTERMEDIATE.id);            
          //Commented out intentionally
          projectAssetFileIdRef.current = projectAssetFileId                      
          getAxiosResponse(APIUrls.CUSTOMER_TRANSLATION_UNIT_SEGMENT_STATUS(projectAssetFileId))
                    .then(res=>{                        
                        var previewStatusCount = res?.data?.data;                        
                        if(previewStatusCount){   
                            setAipeLeveragedCount(previewStatusCount.AIPE_LEVERAGED_TUS);    
                            setTmCount(previewStatusCount.LEVERAGED_TUS);                                                                            
                            setQACount(previewStatusCount.QA);
                            setEditCount(previewStatusCount.EDITED);
                            setfeedbackCount(previewStatusCount.COMMENTED);                         
                            setLockedTuCount(previewStatusCount.LOCKED);    
                            setCommentedThisRevisionCount(previewStatusCount.COMMENTED_THIS_REVISION); 
                            setUncommittedEditsCount(previewStatusCount.UNCOMMITTED_EDITS);                       
                        }  
                        getAxiosResponse(APIUrls.PROJECT(param.id)).then((res)=>{   
                            let project =  res?.data?.data?.resource?.projectResource;            
                            var wfStatus;
                            if(project?.status?.inCancellation || project?.status?.cancelled) {
                                wfStatus = "CANCELLED";
                            } else if (project?.status?.bidSelected) {			    
                                wfStatus = "OPEN,COMPLETED,CANCELLED";
                            } else {			   
                                wfStatus = "OPEN,COMPLETED";
                            }		
                            setWorkflowStatus(wfStatus);
                            
                            getAxiosResponse(APIUrls.EXISTING_PROJECT_WORKFLOW(param.id, wfStatus))
                            .then(async (res)=> {
                                let workflows = res?.data?.data;
                                let isAdvanceWorkflow = false;
                                if(workflows?.length>0){
                                    isAdvanceWorkflow = workflows[0].resource.templateType.originalEnum === "BUILTIN_SINGLE_STEP_THREE_PHASE";
                                    setIsAdvanceWorkflow(isAdvanceWorkflow);
                                }
                                workflowAssigneeFun(workflows)
                                let currentPhase = null;
                                for(let index=0; index<=workflows.length; index++){
                                    let lang = workflows[index]?.displayName[0]?.code;                       
                                    if(param.lang === lang){
                                        let steps = workflows[index].resource.steps;
                                        for(let j=0; j<steps.length;j++){
                                             let step = steps[j];   
                                             let phases = step.phases                                                         
                                             for(let i=0;i<phases.length;i++){                                    
                                                if(phases[i].id === parseInt(param.phaseId)) {
                                                    currentPhase = step.phases[i];
                                                }
                                             }
                                        }
                                    }
                                }
                                if(currentPhase){                                                                                                     
                                    setCurrentPhase(currentPhase)
                                    currentPhase.current = currentPhase;                                    
                                    let isAllowedToEditSegmentsFlag =  await isAllowedToEditSegmentAsync(project, currentPhase, targetAssetData.current);
                                    if(isAdvanceWorkflow && isAllowedToEditSegmentsFlag && currentPhase.phaseType.originalEnum !== Constants.POST_EDITING){                                                                                
                                            setCanEditLockedTus(true);  
                                            document.getElementById('target-preview')?.contentWindow
                                            .postMessage(            
                                                            JSON.stringify({                                                                                
                                                                                action: "CAN_EDIT_LOCKED_TUS"            
                                                                            })
                                                        ,parentHttpDomain);                                                                                                                                                          
                                    }                                                                        
                                    setAllowedToEditSegments(isAllowedToEditSegmentsFlag);
                                    document.getElementById('target-preview')?.contentWindow
                                        .postMessage(
                                            JSON.stringify({
                                                data : isAllowedToEditSegmentsFlag && !currentPhase?.isApprovalPhase && isFileInReviewableState,
                                                action: "CAN_EDIT_PROJECT"
                                            })
                                            ,parentHttpDomain);
                                    setAllowedToEditSegments(isAllowedToEditSegmentsFlag);
                                    isRevisionAllowed.current = currentPhase.allowRevision;
                                    let actions = [];
                                    actions.push({text:"Save and Exit", id:"saveAndExit", link:`/project/${param.id}/language/${param.lang}`})
                                    if(isAllowedToEditSegmentsFlag){
                                        actions.push({text:"Approve", id:"approve"})
                                    }
                                    if(isAllowedToEditSegmentsFlag && currentPhase.isApprovalPhase){
                                        actions.push({text:"Reject", id:"moveback"})
                                    } else if(currentPhase.allowRevision && previewStatusCount?.COMMENTED_THIS_REVISION > 0){
                                        actions.push({text:"Request Revision", id:"revision"})
                                    }
                                    actionList.current=actions;
                                    setActionLoaded(true);   


                                }
                                
                            });
                
                            sourceLanguage.current = res?.data?.data?.displayName[0].sourceLanguage.display        
                                let languages = res.data.data.displayName[0].targetLanguages;
                                for(let i=0;i<languages.length;i++){                     
                                     if(languages[i].code === param.lang){
                                        targetLanguage.current = languages[i];
                                     }
                                }
                             }).catch(err=>{
                                console.error(err)
                            })                                        
                    }).catch(err=>{
                        console.error(err)
                    })          
          getAxiosResponse(APIUrls.PHASE_ASIGNEE(param.id, targetAsset.id, param.phaseId)).then(res=>{
                let assignees = res.data.data;
                setUserAssigneeStatus(userAssigneeStatus(param.phaseId,targetAsset.id,currentUser?.userId,assignees))
                assignees.forEach(a=>{
                     if(a.status === "OPENED"){
                        a.statusToDisplay = "In Progress";   
                     }
                     else if(a.status === "NOT_STARTED"){
                        a.statusToDisplay = "Not Started";
                     }
                     else if(a.status === "COMPLETED"){
                        a.statusToDisplay = "Completed";
                     }
                     else{
                        a.statusToDisplay = a.status;
                     }
                    })
                setAssignees(assignees);
          }).catch(err=>{
            console.error(err)
        }) 
                                                     
          if(targetAsset.status === "IN_REVIEW"){
            isFileInReviewableState.current = true            
          }else{
            isFileInReviewableState.current = false;
          }
          
          getAxiosResponse(APIUrls.PROJECT_TRANSLATED_ASSETS_BY_LANG(param.id,param.lang,param.phaseId))
          .then((res) => {          
            let isVideoAsset = false;        
            if (res.status === 200) {  
                let result=res.data.data.result    
                let finalDocData;
                if(result && result.length > 0){
                    result.forEach(resData=>{
                        finalDocData=Object.values(resData.files).find(data=>data?.documentFile?.id===+param.docId)
                    })
                }    
               let date=utcDateTimeWithTimeZone(
                    finalDocData?.createdDate,
                    userTimeZone
                )._i
                setLastUpdatedTime(generateRelativeDateString(date))
              res.data.data.result.forEach(element => {                          
                    element.assets.forEach(function (asset){                        
                        if(Constants.IMAGE === asset?.assetType){                            
                            isImageProject.current = true;                                                            
                        }
                    });                    
                      var jsonObject = element.files;                        
                      for (var prop in jsonObject) {                    
                          if(jsonObject[prop].documentFile.id === parseInt(param.docId)){                        
                              let srcPreviewAssetFile = getSrcPreviewAssetFile(element.source); 
                              setAsset(element)                              
                              setAssetName(element.name)
                              let trgPreviewAssetFile = getTrgPreviewAssetFile(element); 
                              let tusUrl  = getProjectFileTranslationUnitsUrl(element.id,1 ,filterForTUs);
                              getAxiosResponse(tusUrl)
                              .then((res)=>{      
                                  setNumberOfTUPages(res?.data?.data?.numOfPages);                      
                                  prepSegmentDataAndSetTranslationUnits(res.data.data.result);                 
                                  translationUnitId.current = element.id;  
                                  getAxiosResponse(APIUrls.BOOKMARKED_TU_FOR_FOR_LINE_BY_LINE(param.id,element.id)).then((res)=>{
                                    const bookMarkTUId = res.data.data.idForUrl
                                    jQuery("span#"+bookMarkTUId).addClass("bookmark");
                                  });
                          }).catch(err=>{
                            console.error(err)
                        })
                           isVideoAsset = isVideoAssetType(targetAsset)                         
                              let isPreviewAvailable = false;                                                                   
                              if (trgPreviewAssetFile?.previewUUID ||targetAsset?.files?.FINAL?.previewUUID) {                                                                                              
                                    isPreviewAvailable = true;
                                    setLoaderState(true);   
                                    
                                } else {
                                    isPreviewAvailable = false;
                                }                                   
                                if(custBootstrapDataRedux.features.VIDEO_REVIEW && isVideoAsset){                                    
                                    setVideoPreview(true);
                                  }                                  
                            setPreviewAvailable(isPreviewAvailable);                            
                            if(isPreviewAvailable){                                   
                                if(element?.source?.files?.FINAL?.previewUUID || element?.source?.files?.TRANSLATABLE?.previewUUID){
                                    setSourcePreviewAvailable(true);
                                }else{
                                    setSourcePreviewAvailable(false);
                                }                             
                                let trgPreviewUrl = trgPreviewAssetFile ? APIUrls.PROJECT_ASSET_PREVIEW_BY_FILE_ID(param.id,trgPreviewAssetFile.asset.id,trgPreviewAssetFile.id,1):null;
                                let srcPreviewUrl = srcPreviewAssetFile ? APIUrls.PROJECT_ASSET_PREVIEW_BY_FILE_ID(param.id,srcPreviewAssetFile.asset.id,srcPreviewAssetFile.id,1):null;                                                                                
                                setTrgPreviewUrl(`${process.env.REACT_APP_BACKEND_SERVER}/html${trgPreviewUrl}`);   
                                setSrcPreviewUrl(`${process.env.REACT_APP_BACKEND_SERVER}/html${srcPreviewUrl}`);
                                //Commented out the code intentionally
                                // jQuery("#source-preview").attr("src",`${process.env.REACT_APP_BACKEND_SERVER}/html${srcPreviewUrl}`)
                                // jQuery("#target-preview").attr("src",`${process.env.REACT_APP_BACKEND_SERVER}/html${trgPreviewUrl}`)
                            }

                            if(targetAssetData.files && !targetAssetData.files.TRANSLATABLE){
                                setIsPreviewAvailable(false);
                            }
                               
                          }          
                          
      
                      }
                  })                                      
                    let isRefreshPreview = displayRefreshPreview(isVideoAsset,targetAssetData.current);                                 
                    showRefreshPreview.current =  isRefreshPreview;
                                       
                  
            }
          }).catch(err=>{
            console.error(err)
        });

            if(isEloquaProject()) {
                getAxiosResponse(APIUrls.ELOQUA_ASSET_BY_PROJECT_TRANSLATION_ASSET(param.id, targetAssetData.current.id))
                .then((res) => {
                    if(res.data.code === 200) {
                        setExternalAsset(res.data.data.body);
                    }
                }).catch(err=>{
                    console.error(err)
                });
            }
            if(isMarketoRestProject()) {
                getAxiosResponse(APIUrls.MARKETO_REST_ASSET_BY_PROJECT_TRANSLATION_ASSET(param.id, targetAssetData.current.id))
                .then((res) => {
                    if(res.data.code === 200) {
                        setExternalAsset(res.data.data);
                    }
                }).catch(err=>{
                    console.error(err)
                });
            }
            
      
        }
        }
      }).catch(err=>{
        console.error(err)
    });      

        
                                    

             getAxiosResponse(APIUrls.FEEDBACK_SEVERITY)
             .then((res)=>{if(res.status === 200){                     
                 feedbackSeverityList.current=res.data.data.body.data;                                  
             }}).catch(err=>{
                console.error(err)
            })
         
             getAxiosResponse(APIUrls.FEEDBACK_ERROR_TYPE)
             .then((res)=>{if(res.status === 200){                               
                 feedbackCategoryList.current = res.data.data.body.data;                 
             }}).catch(err=>{
                console.error(err)
            })

        return () => {
                 window.removeEventListener("message", messageEvent);
        }

    },[])


    // This could be used to control a loading spinner, stopping it when ICR and actions has loaded
    useEffect(() => {
        if (actionLoaded) {
            if((srcPreviewUrl!=null && trgPreviewUrl!=null && frameLoaded) || !previewAvailable){
                setLoaderState(false);
            }
        }
    }, [frameLoaded, actionLoaded, isPreviewAvailable]);

    const workflowAssigneeFun=(workflows)=>{
        if(workflows && workflows?.length > 0){
            workflows?.forEach(workflow=>{
                if(workflow?.resource?.steps && workflow?.resource?.steps.length > 0){
                    workflow?.resource?.steps?.forEach(step=>{
                        if(step.phases && step.phases.length > 0){
                            step.phases.forEach(phase=>{
                                if(phase.id===+param?.phaseId){
                                      if(phase?.assigneeType?.code !=="vendor"){
                                        setAssigneeStatus(true)
                                      }
                                    return
                                }
                            })
                        }
                    })
                }
            })
         }
    }
    const userAssigneeStatus = ( phaseId, assetId, userId, data ) => {
        // 'data' would represent the dataset that contains information about phases, assets, users, and their statuses
        // Assuming 'this.find()' represents a search operation within the 'data' array
        let record ={}
        data.forEach(pa =>
            {
                   if(
                    pa.phase.id === +phaseId &&
                    pa.asset.id === assetId){
                        record=pa
                    }
            }
        );
        return record ? record:[];
    }

    function insertAtIndex(str, index, char) {
        return str.slice(0, index) + char + str.slice(index);
    }

    function removeCharacterAtIndex(str, index) {
        if (index < 0 || index >= str.length) {
            // Index out of bounds, return the original string
            return str;
        }
    
        // Remove the character at the specified index
        return str.slice(0, index) + str.slice(index + 1);
    }

    function balanceOutNodesForUpdate(textNodesSentence,filteredtextList){
        var filteredTextSentence = filteredtextList.join("");
        var actions = findOperationsToMakeEqual(filteredTextSentence,textNodesSentence);        
        for(var i=0;i<actions.length;i++){            
            var action = actions[i];
                var startIndex =0;
                var endIndex =0;
            for(var j=0;j<filteredtextList.length;j++){	                
                endIndex+=filteredtextList[j].length;                        
                if(startIndex <= action.index && action.index <=endIndex){                        
                                if(action.action === "add"){
                                    filteredtextList[j]=insertAtIndex(filteredtextList[j],action.index,action.element);
                                }
                                if(action.action === "remove"){
                            filteredtextList[j]=removeCharacterAtIndex(filteredtextList[j],action.index);    
                                }
                                startIndex =0;
                                endIndex =0;
                        break;
                }                                
                startIndex=endIndex;
            }
        }        
        return filteredtextList;
    }

    function findOperationsToMakeEqual(str1, str2) {
        const m = str1.length;
        const n = str2.length;
        const dp = Array.from(Array(m + 1), () => Array(n + 1).fill(0));
    
        // Fill the DP matrix
        for (let i = 1; i <= m; i++) {
            for (let j = 1; j <= n; j++) {
                if (str1[i - 1] === str2[j - 1]) {
                    dp[i][j] = dp[i - 1][j - 1] + 1;
                } else {
                    dp[i][j] = Math.max(dp[i - 1][j], dp[i][j - 1]);
                }
            }
        }
    
        let i = m, j = n;
        const operations = [];
    
        // Traverse the DP matrix to find the sequence of operations
        while (i > 0 || j > 0) {
            if (i > 0 && dp[i][j] === dp[i - 1][j]) {
                operations.push({action:"remove",element: str1[i - 1],index: i - 1});
                i--;
            } else if (j > 0 && dp[i][j] === dp[i][j - 1]) {
                operations.push({action:"add",element: str2[j - 1],index: i});
                j--;
            } else {
                i--;
                j--;
            }
        }
    
        return operations;
    }

    function updatePreviewWithEditedSegment(translationId){
        getAxiosResponse(APIUrls.CUSTOMER_TRANSLATION_UNIT(translationId))
        .then(res=>{
            let segment = res?.data?.data;
            updatePreviewWithSegment(segment, true);

        }).catch(err=>{
            console.error(err)
        })
    }

    function updateICRWithEditSegements(){        
        getAxiosResponse(APIUrls.PROJECT_TRANSLATED_FILE_UNCOMMITTED_TRANSLATION_UNITS(targetAssetInfo.id,param.id)).then(res=>{
                        let uncommitedTus = res?.data?.data;                        
                        uncommitedTus.forEach((segment)=>{                            
                            updatePreviewWithSegment(segment, false);
                        })

        }).catch(err=>{
            console.error(err)
        })

    }

    function updatePreviewWithSegment(segment, lblEdit){

        segment.latestTranslation = segment.translations[segment.translations.length - 1];
        segment.latestTranslation.tokenizedText = InContextUtil.tokenizeSegmentContent(segment.latestTranslation.rawText,targetAssetData.current?.assets[0]?.contentType);
        let syncedTuSnippets = null;
        const syncedTranslations = lblEdit ? segment.translations.filter(t => t.isMostRecent === false): segment.translations.filter(t => t.synced === true);
        if(syncedTranslations.length > 0){
            const latestSyncedTranslation = syncedTranslations[syncedTranslations.length - 1];
            syncedTuSnippets = InContextUtil.tokenizeSegmentContent(latestSyncedTranslation.rawText,targetAssetData.current?.assets[0]?.contentType);
        }
        let isToken = false;
        if(targetAssetInfo?.assets[0]?.contentType === "MARKETOREST"){
            InContextUtil.rebuildTextForAllTokenizedSnippets(segment.latestTranslation.tokenizedText);
            InContextUtil.annotateMarketoRestSegment(segment);
            isToken = segment.isToken;
        }
        messageSegmentUpdateToInContext(segment.docSegPos, segment.latestTranslation, syncedTuSnippets,isToken);

    }

    function messageSegmentUpdateToInContext(docSegPos, translation, syncedTuSnippets,isToken) {

        document.getElementById('target-preview')?.contentWindow
    .postMessage(
        JSON.stringify({
            action: "replace",
            docSegPos: docSegPos,
            syncedTuSnippets : syncedTuSnippets,
            isToken:isToken,
            newRawText: translation.rawText,
            newTokenizedText: translation.tokenizedText
            }) , parentHttpDomain);
    }
    function showUploadTranslation(){
        jQuery("body").addClass("modal-open"); 
        setPopUpValue('uploadTranslation')
    }
    function closeUploadTranslation(){
        jQuery("body").removeClass("modal-open")
        setPopUpValue(null)
    }
    $('#target-preview').on("load", function() {        
    
        document.getElementById('target-preview')?.contentWindow
        .postMessage(            
            JSON.stringify({
            data : feedbackSeverityList.current,
            action: "GET_FEEDBACK_SEVERITY"            
        })
        , parentHttpDomain);
    

    
        document.getElementById('target-preview')?.contentWindow
        .postMessage(            
            JSON.stringify({
            data : feedbackCategoryList.current,
            action: "GET_FEEDBACK_CATEGORY"            
        })
        ,parentHttpDomain);
    

    document.getElementById('target-preview')?.contentWindow
        .postMessage(            
            JSON.stringify({
            data : isFileInReviewableState.current,
            action: "IS_FILE_IN_REVIEWABLE_STATE"            
        })
        ,parentHttpDomain);        

    document.getElementById('target-preview')?.contentWindow
                                                .postMessage(            
                                                    JSON.stringify({
                                                        data : allowedToEditSegments,
                                                        action: "CAN_EDIT_PROJECT"            
                                                    })
                                            ,parentHttpDomain);

    getAxiosResponse(APIUrls.PROJECT_TRANSLATED_FILE_LOCKED_TRANSLATION_UNITS(translationUnitId.current))
            .then((res)=>{                            
                            document.getElementById('target-preview')?.contentWindow
                            .postMessage(            
                                            JSON.stringify({
                                                                data : res.data.data,
                                                                action: "LOCKED_TUS"            
                                                            })
                                        ,parentHttpDomain);                                    
                        });
                        if(canEditLockedTus){
                            document.getElementById('target-preview')?.contentWindow
                                            .postMessage(            
                                                            JSON.stringify({                                                                                
                                                                                action: "CAN_EDIT_LOCKED_TUS"            
                                                                            })
                                                        ,parentHttpDomain);                                    
                        }                        

    getAxiosResponse(APIUrls.PROJECT_TRANSLATED_FILE_AIPE_LEVERAGED_TRANSLATION_UNITS(translationUnitId.current))
    .then((res)=>{                            
                    document.getElementById('target-preview')?.contentWindow
                    .postMessage(            
                                    JSON.stringify({
                                                        data : res.data.data,
                                                        action: "AIPE_LEVERAGED_TUS"            
                                                    })
                                ,parentHttpDomain);                                    
                });

            
    });
    

     function getSrcPreviewAssetFile(sourceAsset) {
             // intentionaly commented
            // if (!this.srcPreviewAvailable) { return null; }
            if(sourceAsset.files.TRANSLATABLE) { return sourceAsset.files.TRANSLATABLE; }
            else { return sourceAsset.files.FINAL; }
        }

     function getTrgPreviewAssetFile(targetAsset) {
        if (targetAsset.files.TRANSLATABLE) {
            return targetAsset.files.TRANSLATABLE;
        } else if (targetAsset.files.SYNTHETIC_XLIFF) {
            return targetAsset.files.SYNTHETIC_XLIFF;
        } else {
            return targetAsset.files.FINAL;
        }
    }

    function showChatBox(val){
        let popupValue = "";
        if(val === true){
            popupValue = "discussion";
        }
        setPopUpValue(popupValue);        
        jQuery("body").addClass("modal-open");                       
        getAxiosResponse(APIUrls.CUSTOMER_PROJECT_TRANSLATION_TRANSLATED_ASSETS_DISCUSSION(param.id,targetAssetData.current.id,"json")).then(res=>{
            let eventList = res.data?.data?.messageAndEventList;
            let data = eventList.sort((o1,o2)=>{
                return new Date(o2.date)-new Date(o1.date);
            });
            const commentId = eventList[eventList.length - 1]?.message?.id;
            setcommentId(commentId);
            setMessageAndEventList(data);
        }) ;
        setTimeout(() => {
            $(".cancelDiscussionPopup").trigger("focus");
            $(".discusstionTextarea").on("keydown", function (e) {
              if (e.key === Constants.TAB) {
               if (e.shiftKey === true) {
                   e.preventDefault();
                   $(".cancelDiscussionPopup").trigger("focus");
                 }
              }
            });
            $(".inner-lightbox-panel").on("keydown", function (e) {
                if (e.key === Constants.ESCAPE) {
                if (!$('.escCloseDropdown').length || $('.escCloseDropdown').find('input').attr('aria-expanded') === 'false') {
                    $("body").removeClass("modal-open");
                    $('.focusAdd').trigger('focus');
                    $('.chat-ClickBox').removeClass('focusAdd');
                    $('.cancelDiscussionPopup').removeClass('focusAdd');
                    }
                }
            });
            $(".cancelDiscussionPopup").on("keydown", function (e) {
              if (e.key === Constants.TAB) {
                if (e.shiftKey === false) {
                  e.preventDefault();
                  $(".discusstionTextarea").trigger("focus");
                }
              }
            });
          }, 500);
    }
    $(document).on("click",".chat-ClickBox",function() {
       $(this).addClass('focusAdd');
      });
      $(document).on("click",".modal-footer .cancelDiscussionPopup",function() {
       $('.focusAdd').trigger('focus');
       $('.focusAdd').removeClass('focusAdd');
       $('.cancelDiscussionPopup').removeClass('focusAdd');
     });
     
     function fetchData(selectedFilter, pageNumber = 1, accumulatedData = []) {
        return getAxiosResponse(getProjectFileTranslationUnitsUrl(translationUnitId.current, pageNumber, selectedFilter))
            .then((res) => {
                const resultCount = res?.data?.data?.resultCount || 0;
                const newData = res?.data?.data?.result || [];
                const combinedData = [...accumulatedData, ...newData];
                if (combinedData.length < resultCount) {
                    return fetchData(selectedFilter, pageNumber + 1, combinedData);
                } else {
                    return combinedData;
                }
            })
            .catch(err => {
                console.error(err);
                return [];
            });
    }
       
    function fetchFilteredTUs(selectedFilter) {
        fetchData(selectedFilter)
            .then((data) => {
                const postData = {
                    data: data,
                    action: "HIGHLIGHT_FILTERED_TUS",
                    selectedFilter: selectedFilter
                };
                document.getElementById('target-preview')?.contentWindow
                    .postMessage(JSON.stringify(postData), parentHttpDomain);
            });
    }

    function fetchFilteredTUsForLineByLine (selectedFilter){        
        var currentValue = $(document.activeElement).attr('aria-pressed');
        $(document.activeElement).parent().parent().find('button').attr('aria-pressed', 'false');
        $(document.activeElement).attr('aria-pressed', currentValue === 'true' ? 'false' : 'true');
        if(filterForTUs === selectedFilter){
            selectedFilter = "ALL";
            setFilterForTUs("ALL");   
        }else{
            setFilterForTUs(selectedFilter);        
        }        
        getAxiosResponse(getProjectFileTranslationUnitsUrl(translationUnitId.current, 1, selectedFilter))
        .then((res)=>{                              
            prepSegmentDataAndSetTranslationUnits(res?.data?.data?.result);
            setNumberOfTUPages(res?.data?.data?.numOfPages);                 
        }).catch(err=>{
            console.error(err)
        })       
    }

    function sameHeight(){        
        $("#line-by-line-view-content .video-translated-content li").height("");
          var lineHeight = 0;
        $("#line-by-line-view-content .video-translated-content li").each(function(){
          if ($(this).height() > lineHeight) { 
            lineHeight = $(this).height(); 
            }
          });          
        $("#line-by-line-view-content .video-translated-content li").height(lineHeight);
    }

    function onLoadIFrame() {
        iframeLoadCount++;
        if (iframeLoadCount >= 2) {
            setFrameLoaded(true);            
            jQuery("#source-preview").removeClass("hide");         
            jQuery("#target-preview").removeClass("hide");
            if(!sourcePreviewAvailable){               
                jQuery(".icr-content-inner-left").addClass("w-d0");
                jQuery(".icr-content-inner-right").addClass("w-d100");                               
            }                                 
            updateICRWithEditSegements();
        }
    }
    
    useEffect(()=>{  
        getAxiosResponse(APIUrls.OFFLINE_PREVIEW_WITHOUT_FILEID(param.id,"SOURCE_PREVIEW_BUNDLE"))
    .then((res) => {
      if (res.data.data) {
       setSourcePreviewBundle(res.data.data)
      }
    }).catch(err=>{
      console.error(err)
    })
    
    getAxiosResponse(APIUrls.OFFLINE_PREVIEW_WITHOUT_FILEID(param.id,"TARGET_PREVIEW_BUNDLE"))
    .then((res) => {
      if (res.data.data) {
       setTargetPreviewBundle(res.data.data)
      }
    }).catch(err=>{
      console.error(err)
    })          
            sameHeight();
            $(window).on('resize', function () {                            
                sameHeight();
            });        
        $('.tuby').parents('.icr-content-inner').addClass('heightAuto')
        $('.back-btn').trigger('focus');  
    },[]) 

    const checkTestEmailSent = (success) => {
        if(success) {
            setSuccessMessage(translate("icr.send_email_success_message"));
        }
    }

    const changeDate = (value, event) => {
        setRevisionDueDate(value);
        setDueDateCalendarExpanded(false);
        setShowCalendar(false);
    }

    const toggleCalendar = () => {
        setDueDateCalendarExpanded(!dueDateCalendarExpanded);
        setShowCalendar(!showCalendar);
        $('.popover-body-calendar').toggleClass('hide');
        $('.focusAdd').trigger('focus');
    };

    const showCustomNavigationLabel = (date, label, locale, view) =>{
        return <span aria-label={` date: ${dateFormat(date,'MMMM - YYYY')}`}>{dateFormat(date,'MMMM - YYYY')}</span>
    }
    const viewChange = (action, activeStartDate, value, view) =>{
        setViewType(view)
        if(view === 'month'){
            setNextAriaLabel(Constants.CALENDAR_NAVIGATION_ARIA_LABEL.NEXT_MONTH)
            setPrevAriaLabel(Constants.CALENDAR_NAVIGATION_ARIA_LABEL.PREV_MONTH)
            setNext2AriaLabel(Constants.CALENDAR_NAVIGATION_ARIA_LABEL.NEXT_YEAR)
            setPrev2AriaLabel(Constants.CALENDAR_NAVIGATION_ARIA_LABEL.PREV_YEAR)
        }
        if(view === 'year'){
            setNextAriaLabel(Constants.CALENDAR_NAVIGATION_ARIA_LABEL.NEXT_YEAR)
            setPrevAriaLabel(Constants.CALENDAR_NAVIGATION_ARIA_LABEL.PREV_YEAR)
            setNext2AriaLabel(Constants.CALENDAR_NAVIGATION_ARIA_LABEL.NEXT_DECADE)
            setPrev2AriaLabel(Constants.CALENDAR_NAVIGATION_ARIA_LABEL.PREV_DECADE)
        }
        if(view === 'decade'){
            $('.react-calendar__tile--hasActive').addClass("decade-active");
            $('.react-calendar__tile--hasActive').focus()
            setNextAriaLabel(Constants.CALENDAR_NAVIGATION_ARIA_LABEL.NEXT_DECADE)
            setPrevAriaLabel(Constants.CALENDAR_NAVIGATION_ARIA_LABEL.PREV_DECADE)
            setNext2AriaLabel(Constants.CALENDAR_NAVIGATION_ARIA_LABEL.NEXT_CENTURY)
            setPrev2AriaLabel(Constants.CALENDAR_NAVIGATION_ARIA_LABEL.PREV_CENTURY)
        }
        if(view === 'century'){
            $('.react-calendar__tile--hasActive').addClass("decade-active");
            $('.react-calendar__tile--hasActive').focus()
            setNextAriaLabel(Constants.CALENDAR_NAVIGATION_ARIA_LABEL.NEXT_CENTURY)
            setPrevAriaLabel(Constants.CALENDAR_NAVIGATION_ARIA_LABEL.PREV_CENTURY)
        }
    }
    
    //  for checking show or hide changes functionality.

    const [showDifferences, setShowDifferences] = useState(
        new Array(translationUnitForHistory?.translations?.length).fill(false)
      );
      const highlightDifferences = (updated, original) => {
        if (!original || !updated) {
          return null;
        }
        const dmp = new diff_match_patch();
        const diffs = dmp.diff_main(original, updated);
        dmp.diff_cleanupSemantic(diffs);
      
        return diffs.map((part, i) => {
          const color = part[0] === 0 ? 'normal' : part[0] === -1 ? 'deletion' : 'insertion';
          const textDecoration = part[0] === -1 ? 'line-through' : 'none';
          return (
            <span key={i} style={{ backgroundColor: color === 'normal' ? 'transparent' : color === 'deletion' ? '#FF9999' : '#99FF99', textDecoration }}>
              {part[1]}
            </span>
          );
        });
      };
      const reversedTranslations = Array.isArray(translationUnitForHistory?.translations) ? [...translationUnitForHistory.translations].reverse() : [];

      const isDifferenceShown = translationUnitForHistory?.translations?.reverse().map((translation, index) => {
        return index !== translationUnitForHistory?.translations.length - 1 && showDifferences[index];
      });
      
      const description = translationUnitForHistory?.translations?.reverse().map((translation, index) => {
        const length = translationUnitForHistory?.translations.length
        return isDifferenceShown[index]
          ? highlightDifferences(translationUnitForHistory?.translations[length-index - 1]?.text, translationUnitForHistory.translations[length-index - 2]?.text)
          : translationUnitForHistory?.translations[length-index -1]?.text;
      });
   

const handleToggleHighlight = (index) => {
    setShowDifferences((prevShowDifferences) => {
        const newShowDifferences = [...prevShowDifferences];
        newShowDifferences[index] = !newShowDifferences[index];
        return newShowDifferences;
      });
};

//  for handling delete comment funnctionality

const handleDeleteComment = (translationIndex, commentIndex) => {    
    const translationUnitId = translationUnitForHistory?.id;
    const translation = translationUnitForHistory?.translations[translationIndex];
    // the comments are rendered in reverse order so we need to calcuate the actual index
    let actualCommentIndex = (translation?.comments.length -1) - commentIndex;
    const comment = translation?.comments[actualCommentIndex];    

  if (!translationUnitId || !comment) {
    console.error('Invalid translationUnitId or commentToDelete');
    return;
  }

  
    postAxiosResponse(APIUrls.CUSTOMER_TRANSLATION_UNIT_COMMENT_DELETE(translationUnitId)+`?commentIndex=${actualCommentIndex}`)
      .then((res) => {
         getAxiosResponse(APIUrls.CUSTOMER_TRANSLATION_UNIT(translationUnitForHistory?.id))
                         .then(res=>{
                             setTranslationUnitForHistory(transformBlankToNull(res.data.data));
                         }).catch(err=>{
                             console.error(err)
                         })
      })
      .catch((error) => {
        console.error('Error during deletion:', error);
      });
  };

    return(
        <>                
  <div  id="container" className="dasboard-wrapper icr-wrapper">
    <ConditionalBlock condition={successMessage.length > 0}>
        <SuccessMessage message={successMessage} />
    </ConditionalBlock>
	<header id="openHeader-Menu" className="header flex-center">
		<div className="left-logo flex-center">
            {/* <div className="logo"><a href="#"><img src="assets/images/logo-small.png" alt="Logo" /></a></div> */}
            <div className="logo-text">
                <span>{assetName}</span>
                <div className="logo-text-inner flex-center">
                    <button aria-label="back" className="back-btn" onClick={navigateBack}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="13" viewBox="0 0 14 13" fill="none">
                            <path d="M0.46967 5.96967C0.176777 6.26256 0.176777 6.73744 0.46967 7.03033L5.24264 11.8033C5.53553 12.0962 6.01041 12.0962 6.3033 11.8033C6.59619 11.5104 6.59619 11.0355 6.3033 10.7426L2.06066 6.5L6.3033 2.25736C6.59619 1.96447 6.59619 1.48959 6.3033 1.1967C6.01041 0.903806 5.53553 0.903806 5.24264 1.1967L0.46967 5.96967ZM1 7.25H14V5.75H1V7.25Z" fill="#1D4ED8"/>
                        </svg>
                    </button>
                    <div className="alert">Due {dueDate}</div>
                </div>
            </div>
        </div>
		<button className="right-hamburger-menu hide mshow" onclick="menuClick()">
			<span></span>
			<span></span>
			<span></span>
		</button>
		<div className="right-logo flex-center relative">
			<div className="search-outer flex-center">
               <div className={showBulkSearch?"search-inner flex-center show-inner":"search-inner flex-center show-inner"}>
                <div className="search">
                    <input type="text" className="search-control" placeholder="" aria-label="search" onChange={e => setTextToBeSearched(e.target.value)}/>
                    <button id="textToSearch" type="submit" className="submit" aria-label="search" onClick={searchText} onKeyDown={(e)=>handlingSearch(e)}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
                            <path d="M10.6084 10.6086L13.9997 13.9999" stroke="#6D7080" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                            <path d="M6.36957 11.7391C9.33509 11.7391 11.7391 9.33509 11.7391 6.36957C11.7391 3.40404 9.33509 1 6.36957 1C3.40404 1 1 3.40404 1 6.36957C1 9.33509 3.40404 11.7391 6.36957 11.7391Z" stroke="#6D7080" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                    </button>
                </div>
                {/* <div> here i will show match {matchCount}</div> */}
                  <div id="matchFound" className= {matchCount>0 ?"search-results success flex-center inline-flex":"search-results success flex-center hide"}> 
                 {/* <div className= {"search-result success flex-center "}> */}
                    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                        <path d="M11.123 5.81055L7.4375 9.49941L5.84707 7.93555C5.53579 7.62427 5.0316 7.62427 4.72016 7.93555C4.40871 8.24683 4.40888 8.75102 4.72016 9.06246L6.84516 11.1875C7.0291 11.3455 7.23164 11.4219 7.4375 11.4219C7.64336 11.4219 7.84523 11.344 8.00096 11.1884L12.251 6.93842C12.5622 6.62714 12.5622 6.12296 12.251 5.81151C11.9397 5.50006 11.4352 5.50176 11.123 5.81055ZM8.5 0C3.80508 0 0 3.80508 0 8.5C0 13.1949 3.80508 17 8.5 17C13.1949 17 17 13.1949 17 8.5C17 3.80508 13.1949 0 8.5 0ZM8.5 15.4062C4.6916 15.4062 1.59375 12.3081 1.59375 8.5C1.59375 4.69193 4.6916 1.59375 8.5 1.59375C12.3084 1.59375 15.4062 4.69193 15.4062 8.5C15.4062 12.3081 12.3084 15.4062 8.5 15.4062Z" fill="#40AD18"/>
                    </svg>
                    <span>{matchCount} Matches Found</span>
                </div>
               {/* <div className={"search-result failed flex-center"}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                        <path d="M8.5 0C3.80508 0 0 3.80508 0 8.5C0 13.1949 3.80508 17 8.5 17C13.1949 17 17 13.1949 17 8.5C17 3.80508 13.1949 0 8.5 0ZM8.5 15.9375C4.39941 15.9375 1.0625 12.6006 1.0625 8.5C1.0625 4.39941 4.39941 1.0625 8.5 1.0625C12.6006 1.0625 15.9375 4.39941 15.9375 8.5C15.9375 12.6006 12.6006 15.9375 8.5 15.9375ZM8.5 10.0938C8.79365 10.0938 9.03125 9.85615 9.03125 9.5625V4.25C9.03125 3.95635 8.79365 3.71875 8.5 3.71875C8.20635 3.71875 7.96875 3.95781 7.96875 4.25V9.5625C7.96875 9.85469 8.20781 10.0938 8.5 10.0938ZM8.5 11.4219C8.06006 11.4219 7.70312 11.7788 7.70312 12.2188C7.70312 12.6587 8.06006 13.0156 8.5 13.0156C8.93994 13.0156 9.29688 12.6587 9.29688 12.2188C9.29688 11.7788 8.9416 11.4219 8.5 11.4219Z" fill="#FF313D"/>
                    </svg>
                    <span>No Matches Found</span>
                </div> */}
               </div>
               
			</div>
           
            {previewAvailable &&            
            <div className="zoom flex-center">                
               <button aria-label="zoom-out" className="button dec">
                    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                        <path d="M11.3334 8.5H5.66675" stroke="#64748B" strokeWidth="1.5" strokeLinecap="round"/>
                        <path d="M8.50008 15.5833C12.4121 15.5833 15.5834 12.412 15.5834 8.49996C15.5834 4.58794 12.4121 1.41663 8.50008 1.41663C4.58806 1.41663 1.41675 4.58794 1.41675 8.49996C1.41675 12.412 4.58806 15.5833 8.50008 15.5833Z" stroke="#64748B" strokeWidth="1.5"/>
                    </svg>
               </button>
               <span className="text-value" id="text-value"><strong>100</strong>%</span>
               <input type="hidden" value="100" />
               <button aria-label="zoom-in" className="button inc">
                    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                        <path d="M8.50008 5.66663V8.49996M8.50008 8.49996V11.3333M8.50008 8.49996H11.3334M8.50008 8.49996H5.66675" stroke="#64748B" strokeWidth="1.5" strokeLinecap="round"/>
                        <path d="M8.50008 15.5833C12.4121 15.5833 15.5834 12.412 15.5834 8.49996C15.5834 4.58794 12.4121 1.41663 8.50008 1.41663C4.58806 1.41663 1.41675 4.58794 1.41675 8.49996C1.41675 12.412 4.58806 15.5833 8.50008 15.5833Z" stroke="#64748B" strokeWidth="1.5"/>
                    </svg>
               </button>
            </div>
            }
            {targetAssetData.current?.files?.FINAL?.asset?.url !== '' &&
                <ExternalLinks targetAssetData={targetAssetData} currentUserEmail={currentUser?.email} projectId={param.id} phaseId={param.phaseId} externalAsset={externalAsset} func={checkTestEmailSent}/>
            }
            <ConditionalBlock condition={showRefreshPreview.current}>
             <div className="chat-box">
                <span style={{color:"#1D4ED8"}}>{`Last updated  ${lastUpdateTime}`}</span>
            </div>
            </ConditionalBlock>

            <div className="chat-box">
                <button aria-label="Discussions" className="chat-ClickBox" onClick={()=>showChatBox(true)}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="23" height="17" viewBox="0 0 23 17" fill="none">
                        <path d="M20.7 4.25H16.1V5.3125H20.7C21.3339 5.3125 21.85 5.7893 21.85 6.375V12.75C21.85 13.3357 21.3339 13.8125 20.7 13.8125H18.4V15.4584L15.2519 13.8125H11.5C10.8661 13.8125 10.35 13.3357 10.35 12.75V11.6875L9.2 11.6874V12.7492C9.2 13.9196 10.2332 14.8443 11.4677 14.8443L14.95 14.875L18.8636 16.9213C18.9427 16.9768 19.0325 17 19.1187 17C19.3452 17 19.55 16.8373 19.55 16.6016V14.874H20.7C21.9668 14.874 23 13.9194 23 12.7789V6.34512C23 5.20293 21.9686 4.25 20.7 4.25ZM14.95 8.5V2.09512C14.95 0.95459 13.9186 0 12.65 0H2.3C1.0332 0 0 0.95459 0 2.09512V8.47012C0 9.67207 1.0332 10.625 2.3 10.625L3.45 10.6254V12.3516C3.45 12.5873 3.65844 12.75 3.88125 12.75C3.9666 12.75 4.05645 12.7251 4.1373 12.6711L8.05 10.625L12.65 10.6225C13.9186 10.6217 14.95 9.67207 14.95 8.5ZM7.74813 9.5625L4.6 11.2094V9.5625H2.3C1.66606 9.5625 1.15 9.08438 1.15 8.5V2.125C1.15 1.5393 1.66606 1.0625 2.3 1.0625H12.65C13.2839 1.0625 13.8 1.5393 13.8 2.125V8.5C13.8 9.0857 13.2839 9.5625 12.65 9.5625H7.74813Z" fill="#64748B"/>
                    </svg>
                </button>
            </div>
            <div className="download-dropdown outsideClick">
                <button aria-label="downloads"
                  onClick={e=>setShowDowloadOptions(prev => !prev)}
                  onKeyDown={(e) => handleEscFocus(e)}
                  aria-expanded={showDowloadOptions?"true":"false"}
                  className="downloadLangdoc"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <g clipPath="url(#clip0_4179_18715)">
                        <path d="M17.2217 17.2217H2.77724C2.62989 17.2217 2.48859 17.2802 2.3844 17.3844C2.28021 17.4886 2.22168 17.6299 2.22168 17.7772C2.22168 17.9246 2.28021 18.0659 2.3844 18.1701C2.48859 18.2743 2.62989 18.3328 2.77724 18.3328H17.2217C17.369 18.3328 17.5103 18.2743 17.6145 18.1701C17.7187 18.0659 17.7772 17.9246 17.7772 17.7772C17.7772 17.6299 17.7187 17.4886 17.6145 17.3844C17.5103 17.2802 17.369 17.2217 17.2217 17.2217Z" fill="#64748B"/>
                        <path d="M10.0008 16.3772L15.8952 10.4828C15.9863 10.3765 16.0338 10.2398 16.0284 10.1C16.023 9.96016 15.9651 9.82753 15.8661 9.72859C15.7672 9.62965 15.6345 9.57169 15.4947 9.56629C15.3549 9.56088 15.2182 9.60844 15.1119 9.69946L10.5564 14.2495V2.77724C10.5564 2.62989 10.4978 2.48859 10.3936 2.3844C10.2895 2.28021 10.1481 2.22168 10.0008 2.22168C9.85346 2.22168 9.71215 2.28021 9.60797 2.3844C9.50378 2.48859 9.44525 2.62989 9.44525 2.77724V14.2495L4.89525 9.69946C4.84545 9.6413 4.78416 9.59407 4.71523 9.56072C4.64631 9.52737 4.57123 9.50864 4.49472 9.50568C4.41821 9.50273 4.34192 9.51562 4.27063 9.54355C4.19933 9.57148 4.13458 9.61384 4.08044 9.66798C4.0263 9.72213 3.98394 9.78688 3.95601 9.85817C3.92808 9.92946 3.91518 10.0058 3.91814 10.0823C3.92109 10.1588 3.93983 10.2339 3.97318 10.3028C4.00653 10.3717 4.05376 10.433 4.11192 10.4828L10.0008 16.3772Z" fill="#64748B"/>
                        </g>
                        <defs>
                        <clipPath id="clip0_4179_18715">
                        <rect width="20" height="20" fill="white"/>
                        </clipPath>
                        </defs>
                        </svg>
                </button>

                <div className={showDowloadOptions?"download-display":"download-display hide"}
                onKeyDown={(e) => handleModalFocus(e)}
                >
                    <h6>Choose a file to download</h6>
                    <ul>
                        {targetAssetData.current.id ? 
                        <FileDownloadMenuItems 
                        entry={targetAssetData.current} 
                        projectId={param.id} 
                        translatedAsset={[targetAssetData.current]} 
                        sourcePreviewBundle={sourcePreviewBundle}
                        targetPreviewBundle={targetPreviewBundle} /> : ''
                        }
                    </ul>
                </div>
            </div>
            <div className="discussion-box download-dropdown">
                <ConditionalBlock condition={assigneeStatus} >
                <button aria-label="Assignee" className="multipleUser"
                aria-expanded={showReviewers?"true":"false"}
                onClick={e=>{setShowReviewers(prev => !prev)
                    setTimeout(() => {
                        showReviewers ? $(document.activeElement).removeAttr("aria-labelledby") : $(document.activeElement).attr("aria-labelledby", "multipleTextVoice");
                    }, 300);
                }}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="19" viewBox="0 0 24 19" fill="none">
                        <path d="M13.8411 9.08675L13.8409 9.08696L13.8471 9.09025C14.4727 9.42293 15.1556 9.6 15.85 9.6C18.0263 9.6 19.8 7.89167 19.8 5.78125C19.8 3.67083 18.0263 1.9625 15.85 1.9625C15.3981 1.9625 14.9554 2.03587 14.5341 2.18009L14.534 2.1801C14.1973 2.29542 14.0161 2.65537 14.1379 2.98711C14.2591 3.31789 14.632 3.48429 14.966 3.37057C15.2496 3.27402 15.5446 3.225 15.85 3.225C17.314 3.225 18.5 4.37514 18.5 5.78125C18.5 7.18736 17.314 8.3375 15.85 8.3375C15.3828 8.3375 14.9242 8.21879 14.5245 7.99528C14.2154 7.82174 13.819 7.92287 13.6385 8.22462C13.4565 8.52684 13.5622 8.91243 13.8411 9.08675ZM6.95719 10.9938C3.61453 10.9938 0.9 13.6119 0.9 16.8479C0.9 17.5438 1.48153 18.1 2.19144 18.1H15.2072C15.9191 18.1 16.5 17.5438 16.5 16.8479C16.5 13.6118 13.7844 10.9938 10.4428 10.9938H6.95719ZM10.4428 12.2563C13.0651 12.2563 15.1942 14.3142 15.2 16.8375H2.20001C2.20582 14.3142 4.33489 12.2563 6.95719 12.2563H10.4428ZM8.7 9.6C11.1822 9.6 13.2 7.65559 13.2 5.25C13.2 2.84441 11.1822 0.9 8.7 0.9C6.21775 0.9 4.2 2.84441 4.2 5.25C4.2 7.65559 6.21775 9.6 8.7 9.6ZM8.7 2.1625C10.4679 2.1625 11.9 3.5507 11.9 5.25C11.9 6.94898 10.4679 8.3375 8.7 8.3375C6.93215 8.3375 5.5 6.948 5.5 5.25C5.5 3.55072 6.93347 2.1625 8.7 2.1625ZM17.8678 11.525H16.4C16.0441 11.525 15.75 11.8041 15.75 12.1563C15.75 12.5085 16.0458 12.7875 16.4 12.7875H17.8668C20.04 12.7875 21.8 14.4925 21.8 16.5822C21.8 16.7197 21.6831 16.8375 21.5322 16.8375H18.05C17.6941 16.8375 17.4 17.1166 17.4 17.4688C17.4 17.8209 17.6941 18.1 18.05 18.1H21.5322C22.3954 18.1 23.1 17.4243 23.1 16.5822C23.1 13.7609 20.7484 11.525 17.8678 11.525Z" fill="#64748B" stroke="#64748B" strokeWidth="0.2"/>
                    </svg>
                </button>
                </ConditionalBlock>
                <div className={showReviewers?"download-display":"download-display hide"}
                  id={showReviewers?"multipleTextVoice":""}
                >                    
                    <ul>
                     {assignees?.map((menuItem,index)=>{
                                                          return(
                                                            <li>
                                                                                                                        
                                                                <span>{menuItem?.user?.firstName} {menuItem?.user?.lastName} ({menuItem?.statusToDisplay})</span>                                                                
                                                            
                                                        </li>
                                                          )
                                                      })}
                        
                        
                    </ul>
                </div>
            </div>
			<div className="flex-center right-side">

				<div className="discussion-box download-dropdown">
				<ConditionalBlock condition={showRefreshPreview.current}>
				    <ConditionalBlock condition={inProgressStatus}>
                    <button type="button" disabled className="flex-center btn-blue-light" value="75" >In Progress</button>
                    </ConditionalBlock>
                    <ConditionalBlock condition={!inProgressStatus}>
                        <ConditionalBlock condition={showRefreshPreview.current && refreshInProgress } >
                            <button type="button" disabled className="flex-center btn-blue-light" value="75" >Refreshing Preview....</button>
                        </ConditionalBlock>
                        <ConditionalBlock condition={!(showRefreshPreview.current && refreshInProgress)} >
                            <button type="button" className="flex-center btn-blue-light" value="75" id="refresh-preview" onClick={refreshPreview}>Refresh Preview</button>
                    </ConditionalBlock>
                </ConditionalBlock>
                </ConditionalBlock>
                </div>
				<div className="form-switch" style={{paddingLeft:"8px"}}>
					<input type="checkbox"
                       className="switch head-switch"
                       role="switch"
                       aria-label="Dark mode"
                     />
				</div>
			</div>
            <ConditionalBlock condition={((userAssigneeStatusData  && Object.keys(userAssigneeStatusData)?.length > 0 && (!userAssigneeStatusData?.phase?.allowMultiAssignee)) || (userAssigneeStatusData?.status === "NOT_STARTED") || (userAssigneeStatusData?.status === "OPENED"))
        && allowedToEditSegments  && (targetAssetData.current.status !== "IN_REVISION")  }>
            <div className="action-dropdown">
                <div className="global-dropdown-select button-dropdown">
                    <button className="drop-down-btn gb-dropBtn clickActionDropdown"
                     onClick={e=>setShowActionDropdown((current) => !current)}
                     onKeyDown={(e) => actionEscFocus(e)}
                     aria-expanded={showActionDropdown ?  "true" :"false"}
                     >
                      <span>Actions</span>
                      <svg xmlns="http://www.w3.org/2000/svg" width="10" height="6" viewBox="0 0 10 6" fill="none">
                        <path d="M1 1L5 5L9 1" stroke="#ABB5BE" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path>
                      </svg>
                   </button>
                        <div className={showActionDropdown ? "global-dropdown show" : "global-dropdown"}>
                            <ul onKeyDown={(e) => actionModalFocus(e)}>
                                {actionList.current?.map(action => {
                                    if (action.id === "saveAndExit") {
                                        return <li><Link id={action.id} to={action.link} >{action.text}</Link></li>
                                    } else {
                                        return <li><Link id={action.id} >{action.text}</Link></li>
                                    }
                                })}
                            </ul>
                        </div>
                 </div>
            </div>
            </ConditionalBlock>
        {targetAssetData.current.status === "APPROVED" &&
            `Review Completed on ${dateFormat(targetAssetData.current.lastModifiedDate, "MM/DD/YY hh:mm")}`
        } 
        {targetAssetData.current.status === "IN_REVISION" ? !isRevisionPhaseAssignedToCustomer(phaseRevisionTask) ?
            'In Revision' : <button className="flex-center btn-blue-light" onClick={showUploadTranslation}>Upload Revision</button> : ''
        } 
        
		</div>
	</header>
    <section>
        <div id="content" className="main-content">
            <div className="icr-menu flex-center">
                <div className="icr-menu-left">
                    <ul className="flex-center">
                        <li>
                            <div className="hide-show">
                                <ConditionalBlock condition={sourcePreviewAvailable}>
                                <button aria-label="Hide Source Preview" className="flex-center btn-blue-light" onClick={toggleSourceViewHideAndShow}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                                        <g clipPath="url(#clip0_4136_12453)">
                                        <path d="M16.8101 8.76501C15.1251 5.65001 12.1701 3.76501 8.90011 3.76501C5.63011 3.76501 2.67011 5.65001 1.00011 8.76501L0.860107 9.00001L0.990107 9.24001C2.67511 12.355 5.63011 14.24 8.90011 14.24C12.1701 14.24 15.1301 12.38 16.8101 9.24001L16.9401 9.00001L16.8101 8.76501ZM8.90011 13.215C6.08511 13.215 3.50011 11.645 2.00011 9.00001C3.50011 6.35501 6.08511 4.78501 8.90011 4.78501C11.7151 4.78501 14.2701 6.36001 15.7951 9.00001C14.2701 11.645 11.7101 13.215 8.90011 13.215Z" fill="#1D4ED8"/>
                                        <path d="M9.04511 5.58499C8.36717 5.58994 7.70589 5.79568 7.14482 6.17623C6.58374 6.55678 6.14802 7.09507 5.89269 7.72311C5.63736 8.35115 5.57387 9.04077 5.71025 9.70487C5.84663 10.369 6.17675 10.9778 6.65892 11.4544C7.1411 11.9309 7.75369 12.254 8.41933 12.3826C9.08498 12.5112 9.77381 12.4397 10.3988 12.1771C11.0239 11.9145 11.557 11.4725 11.931 10.907C12.305 10.3416 12.5031 9.67794 12.5001 8.99999C12.4981 8.54871 12.4071 8.10225 12.2323 7.6862C12.0575 7.27015 11.8023 6.89269 11.4814 6.57544C11.1604 6.2582 10.78 6.00741 10.3619 5.83745C9.94387 5.66749 9.49638 5.5817 9.04511 5.58499ZM9.04511 11.445C8.56623 11.4401 8.0995 11.2937 7.70351 11.0244C7.30753 10.7551 6.99996 10.3747 6.81943 9.93116C6.6389 9.48759 6.59346 9.00057 6.68881 8.53126C6.78417 8.06196 7.01607 7.63129 7.35539 7.29335C7.69472 6.95541 8.12633 6.72526 8.59602 6.63182C9.06572 6.53838 9.55255 6.58581 9.99537 6.76815C10.4382 6.95049 10.8173 7.25961 11.085 7.65669C11.3527 8.05377 11.4971 8.5211 11.5001 8.99999C11.5014 9.32229 11.4388 9.64165 11.3157 9.93955C11.1927 10.2374 11.0118 10.508 10.7834 10.7354C10.555 10.9628 10.2838 11.1427 9.9854 11.2645C9.68701 11.3863 9.3674 11.4476 9.04511 11.445Z" fill="#1D4ED8"/>
                                        </g>
                                        <defs>
                                        <clipPath id="clip0_4136_12453">
                                        <rect width="18" height="18" fill="white"/>
                                        </clipPath>
                                        </defs>
                                    </svg>
                                    {sourcePreviewToggleButtonText}                                    
                                </button>
                                </ConditionalBlock> 
                            </div>
                            {/* <div className="ref-btn">
                                <button aria-label="reference section" className="flex-center btn-blue-light" onclick="showLeftModel()">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="18" viewBox="0 0 14 18" fill="none">
                                        <path d="M6.41625 0.9L6.4163 0.9L11 0.902278C11 0.902278 11 0.902278 11 0.902278C12.1599 0.902305 13.1 1.84224 13.1 3.00199L13.0998 15.0003C13.0998 16.1601 12.1597 17.1 10.9998 17.1H3C1.8401 17.1 0.9 16.1601 0.9 15.0003V6.41713C0.9 6.12502 1.01679 5.84337 1.22304 5.63714L5.63866 1.22216C5.84491 1.01586 6.12473 0.9 6.41625 0.9ZM5.9 5.25261V1.95076L1.9477 5.90251H5.25C5.60794 5.90251 5.9 5.61072 5.9 5.25261ZM1.6 14.9722C1.6 15.744 2.22803 16.372 3 16.372H11C11.772 16.372 12.4 15.744 12.4 14.9722V2.97388C12.4 2.20205 11.772 1.57409 11 1.57409H6.6V5.19543C6.6 5.93995 5.99459 6.54526 5.25 6.54526H1.6V14.9722ZM10.1 9.22299C10.1 9.4159 9.9429 9.57295 9.75 9.57295H4.25C4.0571 9.57295 3.9 9.4159 3.9 9.22299C3.9 9.03008 4.0571 8.87302 4.25 8.87302H9.75C9.85366 8.87302 9.94109 8.92547 10 8.989C10.0579 9.05147 10.1 9.13718 10.1 9.22299ZM4.25 10.8727H9.75C9.9429 10.8727 10.1 11.0298 10.1 11.2227C10.1 11.4156 9.9429 11.5727 9.75 11.5727H4.25C4.0571 11.5727 3.9 11.4156 3.9 11.2227C3.9 11.0297 4.05733 10.8727 4.25 10.8727ZM4.25 12.8724H9.75C9.9429 12.8724 10.1 13.0295 10.1 13.2224C10.1 13.4153 9.9429 13.5724 9.75 13.5724H4.25C4.0571 13.5724 3.9 13.4153 3.9 13.2224C3.9 13.0295 4.05733 12.8724 4.25 12.8724Z" fill="#1D4ED8" stroke="#1D4ED8" strokeWidth="0.2"/>
                                    </svg>
                                    Reference Material
                                </button>
                            </div> */}
                        </li>
                        <li className="m-hide">
                            <div className="source flex-center">
                                <span>Source - {sourceLanguage.current}</span>
                            </div>
                        </li>
                        { (previewAvailable || videoPreview) &&
                        <li>
                            <div className="preview-outer">
                                <button aria-label="preview" className="preview active flex-center" id="preview-btn" onClick={showPreview}>
                                    Preview
                                </button>
                            </div>
                        </li>
                        }
                    </ul>
                </div>
                <div className="icr-menu-right">
                 <ul className="flex-center">
                    <li>
                        <div className="preview-outer">                        
                            <button aria-label="line by line" className={(previewAvailable || videoPreview)? "preview flex-center" : "preview flex-center active" }  id="line-by-line" onClick={showLineByLineView}>
                                Line-By-Line
                            </button>
                        </div>
                    </li>
                    <li className="m-hide">
                        <div className="source flex-center">
                            <span>Target - {targetLanguage.current?.display}</span>
                        </div>
                    </li>
                    { previewAvailable &&
                    <li>                        
                       <div className="final-preview flex-center">
                        <div className="form-switch flex-center">
                            <label htmlFor="final-preview">Final Preview</label>
                            <input type="checkbox" id="final-preview" value="final preview" className="switch"/>
                        </div>
                       </div>
                    </li>
                    }
                 </ul>

                </div>
            </div>

            {videoPreview && 
            // showVideo &&
            <div className="icr-content-inner line-text flex-center resizable-x" id="preview-content">
                <div className="video-content">
                
<Player
  src={[
    {
      quality: "Full HD",
      url:videoStreamUrl
    }
  ]}
  subtitles={[    
    {      
      language: targetLanguage.current?.display,
      url: URL.createObjectURL(new Blob([subtitleData]))    
    },
  ]}  
  keyboardShortcut={false}
/>


                    <div className="video-date">
                        Last Updated: <strong>{targetAssetData.current?.assets[0]?.createdDateTimePeriod}</strong>
                        </div>     
                            { (targetAssetData.current?.assets[0]?.contentType === "BRIGHTCOVE" && refreshVideoStatus) && <button className="btn btn-bold active" label="Refreshing Video" disabled>Refreshing Video...</button>}
                            { (targetAssetData.current?.assets[0]?.contentType === "BRIGHTCOVE" && !refreshVideoStatus) && <button className="btn btn-bold active" aria-label="Refresh Video" onClick={refreshVideo}>Refresh Video</button>}
                    
                    </div>                                                 
                </div>
            
            }
            { previewAvailable &&
            <div className="icr-content-inner line-text flex-center resizable-x" id="preview-content">
                <div className="icr-content-inner-left relative">

                    <h6 className="hide m-show">Source - English</h6>
                    <div className="min-height52"></div>
                    <ConditionalBlock condition={srcPreviewUrl !== null}>
                        <iframe src={srcPreviewUrl} className="hide" id="source-preview" title="src" allow="fullscreen" width="1000" height="1000" onLoad={onLoadIFrame}/>
                    </ConditionalBlock>
                     <div className="footer-text">
                        <ul className="flex-center">
                            {/*<li>
                                <span>Characters</span>
                                <strong>2306</strong>
                            </li>*/}
                            {targetAssetData.current?.source?.wordCount ?<li>
                                <span>Source Word Count</span>
                                <strong>{targetAssetData.current?.source?.wordCount}</strong>
                            </li>:""}
                            {/*<li>
                                <span>Sentences</span>
                                <strong>31</strong>
                            </li>*/}
                        </ul>
                    </div> 
                </div>
                <div className="splitter resizer-x">
                   <button aria-label="drag content" className="splitter-icon" tabIndex="-1">
                    <svg xmlns="http://www.w3.org/2000/svg" width="27" height="29" viewBox="0 0 27 29" fill="none">
                        <path fillRule="evenodd" clipRule="evenodd" d="M12.2344 7.00634C12.2344 7.40036 12.3677 7.77824 12.6051 8.05686C12.8424 8.33547 13.1643 8.492 13.5 8.492C13.8357 8.492 14.1576 8.33547 14.3949 8.05686C14.6323 7.77824 14.7656 7.40036 14.7656 7.00634V2.05414C14.7656 1.66012 14.6323 1.28224 14.3949 1.00362C14.1576 0.725006 13.8357 0.568481 13.5 0.568481C13.1643 0.568481 12.8424 0.725006 12.6051 1.00362C12.3677 1.28224 12.2344 1.66012 12.2344 2.05414V7.00634ZM20.52 8.92779C20.7573 8.64958 21.079 8.49331 21.4144 8.49331C21.7498 8.49331 22.0714 8.64958 22.3088 8.92779L26.1056 13.3848L27 14.4346L26.1056 15.4845L22.3088 19.9415C22.0688 20.2039 21.7515 20.3468 21.4236 20.34C21.0957 20.3332 20.7829 20.1773 20.551 19.9051C20.3191 19.6329 20.1863 19.2657 20.1805 18.8808C20.1747 18.4959 20.2964 18.1234 20.52 17.8418L23.4225 14.4346L20.52 11.0275C20.283 10.749 20.1499 10.3714 20.1499 9.97766C20.1499 9.58396 20.283 9.20635 20.52 8.92779ZM13.5 18.3964C13.1643 18.3964 12.8424 18.2399 12.6051 17.9613C12.3677 17.6826 12.2344 17.3048 12.2344 16.9107V11.9585C12.2344 11.5645 12.3677 11.1866 12.6051 10.908C12.8424 10.6294 13.1643 10.4729 13.5 10.4729C13.8357 10.4729 14.1576 10.6294 14.3949 10.908C14.6323 11.1866 14.7656 11.5645 14.7656 11.9585V16.9107C14.7656 17.3048 14.6323 17.6826 14.3949 17.9613C14.1576 18.2399 13.8357 18.3964 13.5 18.3964ZM13.5 28.3008C13.1643 28.3008 12.8424 28.1443 12.6051 27.8657C12.3677 27.587 12.2344 27.2092 12.2344 26.8151V21.8629C12.2344 21.4689 12.3677 21.091 12.6051 20.8124C12.8424 20.5338 13.1643 20.3773 13.5 20.3773C13.8357 20.3773 14.1576 20.5338 14.3949 20.8124C14.6323 21.091 14.7656 21.4689 14.7656 21.8629V26.8151C14.7656 27.2092 14.6323 27.587 14.3949 27.8657C14.1576 28.1443 13.8357 28.3008 13.5 28.3008ZM4.69125 8.92779C4.93117 8.66537 5.2485 8.5225 5.57638 8.52929C5.90426 8.53608 6.2171 8.692 6.44899 8.9642C6.68087 9.2364 6.8137 9.60362 6.81948 9.98851C6.82527 10.3734 6.70356 10.7459 6.48 11.0275L3.5775 14.4346L6.48 17.8418C6.60435 17.9778 6.70408 18.1418 6.77326 18.324C6.84243 18.5063 6.87962 18.703 6.88262 18.9025C6.88562 19.1019 6.85436 19.3001 6.79071 19.4851C6.72705 19.6701 6.63231 19.8381 6.51213 19.9792C6.39195 20.1203 6.24879 20.2315 6.0912 20.3062C5.9336 20.3809 5.7648 20.4176 5.59487 20.4141C5.42493 20.4106 5.25734 20.3669 5.10209 20.2857C4.94684 20.2045 4.80712 20.0874 4.69125 19.9415L0.894375 15.4845L0 14.4346L0.894375 13.3848L4.69125 8.92779Z" fill="#1D4ED8"/>
                    </svg>
                   </button>
                </div>
                
                <div className="icr-content-inner-right relative">
                    <h6 className="hide m-show">Target -German</h6>
                    <div className="translate-content new-content relative">
                        <div className="filter-text flex-center">
                            <ConditionalBlock condition={isAdvanceWorkflow && accountPermission?.features?.QUALITY_ESTIMATION_SCORING}>
                            <div className="filter-box flex-center glossary">
                                <button aria-label="locked" className="flex-center" onClick={(e)=>{fetchFilteredTUs("LOCKED")}}>
                                    <p className="number"> {lockedTuCount}</p>
                                    <p className="text">Locked</p>
                                </button>
                            </div>                            
                            </ConditionalBlock>
                            <ConditionalBlock condition={accountPermission?.features?.ENABLE_AIPE}>
                                <div className="filter-box flex-center aipe">
                                    <button aria-label={aipeLeveragedCount + " AIPE"} className="flex-center" onClick={(e)=>{fetchFilteredTUs("AIPE_LEVERAGED_TUS")}}>
                                        <p className="number" id="AIPE-leveraged-count"> {aipeLeveragedCount}</p>
                                        <p className="text">AIPE</p>
                                    </button>
                                </div> 
                            </ConditionalBlock>
                            <div className="filter-box flex-center edit">
                                <button  aria-label="edit" className="flex-center" onClick={(e)=>{fetchFilteredTUs("EDITED")}}>
                                    <p className="number" id="edit-count">{editCount} </p>
                                    <p className="text">Edit</p>
                                </button>
                            </div>
                            <div className="filter-box flex-center feedback">
                                <button aria-label="feedback" className="flex-center" onClick={(e)=>{fetchFilteredTUs("COMMENTED")}}>
                                    <p className="number" id="feedback-count">{feedbackCount} </p>
                                    <p className="text">Feedback</p>
                                </button>
                            </div>
                            <div className="filter-box flex-center qa">
                                <button aria-label="QA" className="flex-center" onClick={(e)=>{fetchFilteredTUs("QA")}}>
                                    <p className="number" id="QA-count">{QACount} </p>
                                    <p className="text">QA</p>
                                </button>
                            </div>
                            <div className="filter-box flex-center tm">
                                <button aria-label="tm" className="flex-center" onClick={(e)=>{fetchFilteredTUs("LEVERAGED_TUS")}}>
                                    <p className="number" id="TM-count"> {TmCount}</p>
                                    <p className="text">TM</p>
                                </button>
                            </div>                            
                        </div>
                        <ConditionalBlock condition={trgPreviewUrl !== null}>
                            <iframe src={trgPreviewUrl} id="target-preview" className="hide" title="target" allow="fullscreen" width="1000" height="1000" onLoad={onLoadIFrame}/>
                        </ConditionalBlock>
                     
                        <aside className="country-list icr-side-section">
                            <ul>

                                {[...Array(numberOfTUPages)].map((e,i)=> {return(
                                    <li onClick={e=>paginateICR({i})}>
                                        <a className= {(currentPage.current - 1) == i ? "active": "" } href="#">
                                            <small role="link" className="feedback-link" aria-label="feedback-link">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                                                    <path d="M6.00993 0C9.32986 0 11.9994 2.49472 11.9994 5.5718C11.9994 6.901 11.4981 8.11608 10.6618 9.07293C10.9553 10.4225 11.936 11.625 11.9478 11.6384C12.0006 11.6986 12.0153 11.792 11.983 11.8723C11.9536 11.9527 11.8886 12 11.8123 12C10.2568 12 9.10983 11.1492 8.51112 10.6234C7.745 10.9515 6.8906 11.1428 5.98948 11.1428C2.66956 11.1428 0 8.64808 0 5.59511C0 2.54213 2.69001 0 6.00993 0ZM5.8221 7.73891H8.45174C8.76167 7.73891 9.01524 7.45228 9.01524 7.09601C9.01524 6.73974 8.76167 6.45311 8.45174 6.45311H5.8221C5.50983 6.45311 5.25861 6.74242 5.25861 7.09601C5.25861 7.44961 5.50983 7.73891 5.8221 7.73891ZM3.56812 5.16731H8.45174C8.76167 5.16731 9.01524 4.88068 9.01524 4.52441C9.01524 4.16814 8.76167 3.88151 8.45174 3.88151H3.56812C3.25585 3.88151 3.00463 4.17081 3.00463 4.52441C3.00463 4.87801 3.25585 5.16731 3.56812 5.16731Z" fill="#428CC2"></path>
                                                </svg>
                                            </small>
                                            <small role="link" className="default-link edit-link" aria-label="edit"></small>
                                            <small role="link" className="default-link qa-link" aria-label="QA"></small>
                                            <small className="bookmark-link" aria-label="bookmark">
                                                <em>Page</em>
                                                <em className="mar-left6">{i+1}</em>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="9" height="12" viewBox="0 0 9 12" fill="none">
                                                    <path d="M9 1.125V12L4.5 9.375L0 12V1.125C0 0.503906 0.503906 0 1.125 0H7.875C8.49609 0 9 0.503906 9 1.125Z" fill="#EBB027"></path>
                                                </svg>
                                            </small>
                                            {/* <p>Page {i+1}</p> */}
                                        </a>

                                  </li>
                                  )} )}


                            </ul>
                          </aside>
                    </div>

                    <div className="footer-text">
                        <ul className="flex-center">
                            {/*<li>
                                <span>Characters</span>
                                <strong>2306</strong>
                            </li>*/}
                            {targetAssetData.current?.wordCount ?<li>
                                <span>Target Word Count </span>
                                <strong>{targetAssetData.current?.wordCount}</strong>
                            </li>:""}
                            {/*<li>
                                <span>Sentences</span>
                                <strong>31</strong>                                
                            </li>*/}

                        </ul>
                    </div> 
                </div>
            </div>}
            
            <div id="line-by-line-view-content" className={ (previewAvailable || videoPreview) ?"icr-content-inner line-text flex-center resizable-x hide":"icr-content-inner line-text flex-center resizable-x"}>
                <h6 className="hide m-show">Source - English</h6>
                <div className="icr-content-inner-left relative">
                <div className="translate-content new-content video-main line-content">
                    <ul className="video-translated-content">                        
                        {translationUnits?.map((translationUnit)=>
                            <li>
                                <strong className="mr-15">{translationUnit.docSegPos}</strong>
                                <ConditionalBlock condition={translationUnit.timecodes && translationUnit.timecodes.startDisplay && translationUnit.timecodes.endDisplay}>
                                    <TimeCode
                                        tuId={translationUnit.id}
                                        startTime={translationUnit.timecodes.startDisplay}
                                        endTime={translationUnit.timecodes.endDisplay}
                                    />
                                </ConditionalBlock>
                                    {translationUnit.isAltText &&                                        
                                    <button class="date-inner" aria-label="Plain text">
                                    <span>Plain text</span>                                        
                                    </button>
                                        }
                                    { translationUnit.isText &&
                                    <button class="date-inner" aria-label="Text Content">
                                    <span>Text Content</span>                                        
                                    </button>
                                    }
                                    { translationUnit.isHtmlText &&
                                    <button class="date-inner" aria-label="HTML Content">
                                    <span>HTML Content</span>                                        
                                    </button>
                                    }
                                    { translationUnit.isSubject &&
                                    <button class="date-inner" aria-label="Subject">
                                    <span>Subject</span>                                        
                                    </button>
                                    }
                                    { translationUnit.isFromName &&                                        
                                        <button class="date-inner" aria-label="From Name">
                                        <span>From Name</span>                                        
                                        </button>
                                        }
                                    { translationUnit.isFromEmail &&
                                     <button class="date-inner" aria-label="From Email">
                                     <span>From Email</span>                                        
                                     </button>
                                    }
                                    { translationUnit.isReplyTo &&
                                    <button class="date-inner" aria-label="Reply To">
                                    <span>Reply To</span>                                        
                                    </button>
                                    }
                                    { translationUnit.isLPTitle &&
                                    <button class="date-inner" aria-label="Landing Page Title">
                                    <span>Landing Page Title</span>                                        
                                    </button>
                                    }
                                    { translationUnit.isLPKeyword &&
                                    <button class="date-inner" aria-label="Landing Page Keyword">
                                    <span>Landing Page Keyword</span>                                        
                                    </button>
                                    }
                                    { translationUnit.isLPMeta &&
                                    <button class="date-inner" aria-label="Landing Page Meta">
                                    <span>Landing Page Meta</span>                                        
                                    </button>
                                    }
                                    { translationUnit.isLPSubmit &&
                                    <button class="date-inner" aria-label="Landing Page Submit">
                                    <span>Landing Page Submit</span>                                        
                                    </button>
                                    }
                                    {translationUnit.isLPReset &&
                                    <button class="date-inner" aria-label="Landing Page Reset">
                                    <span>Landing Page Reset</span>                                        
                                    </button>
                                    }
                                    { translationUnit.isHeader &&
                                    <button class="date-inner" aria-label="Header">
                                    <span>Header</span>                                        
                                    </button>
                                    }
                                    { translationUnit.isFooter &&
                                    <button class="date-inner" aria-label="Footer">
                                    <span>Footer</span>                                        
                                    </button>
                                    }
                                    { translationUnit.isSnippet &&
                                    <button class="date-inner" aria-label="Snippet">
                                    <span>Snippet</span>                                        
                                    </button>
                                    }
                                    { translationUnit.isToken &&
                                    <button class="date-inner" aria-label="Token">
                                    <span>Token</span>                                        
                                    </button>
                                    }
                                    { translationUnit.isLPVariable &&
                                    <button class="date-inner" aria-label="Landing Page Variable">
                                    <span>Landing Page Variable</span>                                        
                                    </button>
                                    }
                                    { translationUnit.isEmailVariable &&
                                    <button class="date-inner" aria-label="Email Variable">
                                    <span>Email Variable</span>                                        
                                    </button>
                                    }
                                    { translationUnit.isFormLabel &&
                                    <button class="date-inner" aria-label="Form Label">
                                    <span>Form Label</span>                                        
                                    </button>
                                    }
                                    { translationUnit.isFormValidationMessage &&
                                    <button class="date-inner" aria-label="Form Validation Message">
                                    <span>Form Validation Message</span>                                        
                                    </button>
                                    }
                                    { translationUnit.isFormButtonLabel && 
                                    <button class="date-inner" aria-label="Form Button Label">
                                    <span>Form Button Label</span>                                        
                                    </button>                                   
                                    }
                                    { translationUnit.isFormWaitingLabel &&
                                    <button class="date-inner" aria-label="Form Waiting Label">
                                    <span>Form Waiting Label</span>                                        
                                    </button>                                   
                                    }
                                    { translationUnit.isFormHintText &&
                                    <button class="date-inner" aria-label="Form Hint Text">
                                    <span>Form Hint Text</span>                                        
                                    </button>                                   
                                    }
                                    { translationUnit.isFormFiledLabel &&
                                    <button class="date-inner" aria-label="Form Field Label">
                                    <span>Form Field Label</span>                                        
                                    </button>                                   
                                    }
                                    { translationUnit.isFormFieldValue &&
                                    <button class="date-inner" aria-label="Form Field Value">
                                    <span>Form Field Value</span>                                        
                                    </button>                                   
                                    }                                    
                                <span dangerouslySetInnerHTML={{__html: translationUnit.rawSrcText}} ></span>                                
                            </li>                            
                        )}
                                            
                    </ul>
                </div>
                </div>
                <div className="footer-text line-footer-left">
                    <ul className="flex-center">
                        {targetAssetData.current?.source?.wordCount ?<li>
                            <span>Source Word Count</span>
                            <strong>{targetAssetData.current?.source?.wordCount}</strong>
                        </li>:""}
                    </ul>
                </div>
                <div className="splitter resizer-x">
                   <button aria-label="drag content" className="splitter-icon" tabindex="-1">
                    <svg xmlns="http://www.w3.org/2000/svg" width="27" height="29" viewBox="0 0 27 29" fill="none">
                        <path fillRule="evenodd" clipRule="evenodd" d="M12.2344 7.00634C12.2344 7.40036 12.3677 7.77824 12.6051 8.05686C12.8424 8.33547 13.1643 8.492 13.5 8.492C13.8357 8.492 14.1576 8.33547 14.3949 8.05686C14.6323 7.77824 14.7656 7.40036 14.7656 7.00634V2.05414C14.7656 1.66012 14.6323 1.28224 14.3949 1.00362C14.1576 0.725006 13.8357 0.568481 13.5 0.568481C13.1643 0.568481 12.8424 0.725006 12.6051 1.00362C12.3677 1.28224 12.2344 1.66012 12.2344 2.05414V7.00634ZM20.52 8.92779C20.7573 8.64958 21.079 8.49331 21.4144 8.49331C21.7498 8.49331 22.0714 8.64958 22.3088 8.92779L26.1056 13.3848L27 14.4346L26.1056 15.4845L22.3088 19.9415C22.0688 20.2039 21.7515 20.3468 21.4236 20.34C21.0957 20.3332 20.7829 20.1773 20.551 19.9051C20.3191 19.6329 20.1863 19.2657 20.1805 18.8808C20.1747 18.4959 20.2964 18.1234 20.52 17.8418L23.4225 14.4346L20.52 11.0275C20.283 10.749 20.1499 10.3714 20.1499 9.97766C20.1499 9.58396 20.283 9.20635 20.52 8.92779ZM13.5 18.3964C13.1643 18.3964 12.8424 18.2399 12.6051 17.9613C12.3677 17.6826 12.2344 17.3048 12.2344 16.9107V11.9585C12.2344 11.5645 12.3677 11.1866 12.6051 10.908C12.8424 10.6294 13.1643 10.4729 13.5 10.4729C13.8357 10.4729 14.1576 10.6294 14.3949 10.908C14.6323 11.1866 14.7656 11.5645 14.7656 11.9585V16.9107C14.7656 17.3048 14.6323 17.6826 14.3949 17.9613C14.1576 18.2399 13.8357 18.3964 13.5 18.3964ZM13.5 28.3008C13.1643 28.3008 12.8424 28.1443 12.6051 27.8657C12.3677 27.587 12.2344 27.2092 12.2344 26.8151V21.8629C12.2344 21.4689 12.3677 21.091 12.6051 20.8124C12.8424 20.5338 13.1643 20.3773 13.5 20.3773C13.8357 20.3773 14.1576 20.5338 14.3949 20.8124C14.6323 21.091 14.7656 21.4689 14.7656 21.8629V26.8151C14.7656 27.2092 14.6323 27.587 14.3949 27.8657C14.1576 28.1443 13.8357 28.3008 13.5 28.3008ZM4.69125 8.92779C4.93117 8.66537 5.2485 8.5225 5.57638 8.52929C5.90426 8.53608 6.2171 8.692 6.44899 8.9642C6.68087 9.2364 6.8137 9.60362 6.81948 9.98851C6.82527 10.3734 6.70356 10.7459 6.48 11.0275L3.5775 14.4346L6.48 17.8418C6.60435 17.9778 6.70408 18.1418 6.77326 18.324C6.84243 18.5063 6.87962 18.703 6.88262 18.9025C6.88562 19.1019 6.85436 19.3001 6.79071 19.4851C6.72705 19.6701 6.63231 19.8381 6.51213 19.9792C6.39195 20.1203 6.24879 20.2315 6.0912 20.3062C5.9336 20.3809 5.7648 20.4176 5.59487 20.4141C5.42493 20.4106 5.25734 20.3669 5.10209 20.2857C4.94684 20.2045 4.80712 20.0874 4.69125 19.9415L0.894375 15.4845L0 14.4346L0.894375 13.3848L4.69125 8.92779Z" fill="#1D4ED8"></path>
                    </svg>
                   </button>
                </div>
                <h6 className="hide m-show">Target -German</h6>
                <div className="icr-content-inner-right relative">
                    <div className="translate-content new-content video-main line-content">
                        <div className="filter-text flex-center">
                            <ConditionalBlock condition={isAdvanceWorkflow && accountPermission?.features?.QUALITY_ESTIMATION_SCORING}>
                            <div className="filter-box flex-center glossary">
                                <button aria-label={lockedTuCount+" locked"} className="flex-center" onClick={(e)=>{fetchFilteredTUsForLineByLine("LOCKED")}} aria-pressed="false">
                                    <p className="number"> {lockedTuCount}</p>
                                    <p className="text">Locked</p>
                                </button>
                            </div>
                            </ConditionalBlock>
                            <ConditionalBlock condition={accountPermission?.features?.ENABLE_AIPE}>
                                <div className="filter-box flex-center aipe">
                                    <button aria-label={aipeLeveragedCount + " AIPE"} className="flex-center" onClick={(e)=>{fetchFilteredTUsForLineByLine("AIPE_LEVERAGED_TUS")}} aria-pressed="false">
                                        <p className="number"> {aipeLeveragedCount}</p>
                                        <p className="text">AIPE</p>
                                    </button>
                                </div>
                            </ConditionalBlock>
                            <div className="filter-box flex-center edit">
                                <button aria-label={editCount + " edit"} className="flex-center" onClick={(e)=>{fetchFilteredTUsForLineByLine("EDITED")}} aria-pressed="false">
                                    <p className="number"> {editCount}</p>
                                    <p className="text">Edit</p>
                                </button>
                            </div>
                            <div className="filter-box flex-center feedback">
                                <button aria-label={feedbackCount + " feedback"} className="flex-center" onClick={(e)=>{fetchFilteredTUsForLineByLine("COMMENTED")}} aria-pressed="false">
                                    <p className="number"> {feedbackCount}</p>
                                    <p className="text">Feedback</p>
                                </button>
                            </div>
                            <div className="filter-box flex-center qa">
                                <button aria-label={QACount + " QA"} className="flex-center" onClick={(e)=>{fetchFilteredTUsForLineByLine("QA")}} aria-pressed="false">
                                    <p className="number"> {QACount}</p>
                                    <p className="text">QA</p>
                                </button>
                            </div>
                            <div className="filter-box flex-center tm">
                                <button aria-label={TmCount + " TM"} className="flex-center" onClick={(e)=>{fetchFilteredTUsForLineByLine("LEVERAGED_TUS")}} aria-pressed="false">
                                    <p className="number"> {TmCount}</p>
                                    <p className="text">TM</p>
                                </button>
                            </div>                             
                        </div>
                        <ul className="video-translated-content">


                        {translationUnits?.map((translationUnit)=>

                            <li className="translation-unit-list-view">                                
                                <span className="mr-15">                        
                                <ConditionalBlock condition={isAdvanceWorkflow && accountPermission?.features?.QUALITY_ESTIMATION_SCORING}>
                                    {translationUnit.locked ? 
                                    <>
                                    <button data-tip="Locked" data-for="lockToolTip">{LockIcon}</button>
                                    <ReactTooltip  id="lockToolTip" >                                      
                                    </ReactTooltip>
                                    </>
                                    : 
                                    <>
                                    <button data-tip= {targetAssetData.current.status === "APPROVED" ? "Approved" : currentPhase?.phaseType?.originalEnum === "POST_EDITING" ? "Post-Edit Required" : "Pending Review"}  data-for="unlockTooltip">{UnlockIcon}</button>                                    
                                    <ReactTooltip className="" id="unlockTooltip" >                                    
                                    </ReactTooltip>
                                    </>
                                    }
                                    
                                </ConditionalBlock>
                                </span>
                             <span className="outsideContext">                                                             

                              <span role="link" aria-expanded="false" tabIndex="0" id={translationUnit.id} className={translationUnit.locked?"linebykeydown locked-tu-text":"linebykeydown"} locked={translationUnit.locked.toString()} onClick={handleClick} onKeyDown={(e)=>handleClickKeydown(e)} >                                                            
                              <span name="tu-start"></span>
                              <span class="tu-html" dangerouslySetInnerHTML={{
                                        __html: `${translationUnit.translations[translationUnit.translations.length - 1].rawText}`,
                                    }}
                                ></span>
                                <span name="tu-end"></span>
                              </span>

                              <div id={translationUnit.id+"-error"} style={{color: "red"}}></div>
                              </span>
                                
                            </li>                            
                        )}
    
                        </ul>
                        <aside className="country-list icr-side-section">
                            <ul>

                                {[...Array(numberOfTUPages)].map((e,i)=> {return(
                                    <li onClick={e=>paginateForTus({i})}>
                                    
                                        <a aria-label={"Page " + (i+1)} className= {(currentPage.current - 1) == i ? "active": "" } href="#">
                                            <small role="link" className="2feedback-link" aria-label="feedback-link">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                                                    <path d="M6.00993 0C9.32986 0 11.9994 2.49472 11.9994 5.5718C11.9994 6.901 11.4981 8.11608 10.6618 9.07293C10.9553 10.4225 11.936 11.625 11.9478 11.6384C12.0006 11.6986 12.0153 11.792 11.983 11.8723C11.9536 11.9527 11.8886 12 11.8123 12C10.2568 12 9.10983 11.1492 8.51112 10.6234C7.745 10.9515 6.8906 11.1428 5.98948 11.1428C2.66956 11.1428 0 8.64808 0 5.59511C0 2.54213 2.69001 0 6.00993 0ZM5.8221 7.73891H8.45174C8.76167 7.73891 9.01524 7.45228 9.01524 7.09601C9.01524 6.73974 8.76167 6.45311 8.45174 6.45311H5.8221C5.50983 6.45311 5.25861 6.74242 5.25861 7.09601C5.25861 7.44961 5.50983 7.73891 5.8221 7.73891ZM3.56812 5.16731H8.45174C8.76167 5.16731 9.01524 4.88068 9.01524 4.52441C9.01524 4.16814 8.76167 3.88151 8.45174 3.88151H3.56812C3.25585 3.88151 3.00463 4.17081 3.00463 4.52441C3.00463 4.87801 3.25585 5.16731 3.56812 5.16731Z" fill="#428CC2"></path>
                                                </svg>
                                            </small>
                                            <small role="link" className="default-link edit-link" aria-label="edit"></small>
                                            <small role="link" className="default-link qa-link" aria-label="QA"></small>
                                            <small className="bookmark-link" aria-label="bookmark">
                                                <em>Page</em>
                                                <em className="mar-left6">{i+1}</em>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="9" height="12" viewBox="0 0 9 12" fill="none">
                                                    <path d="M9 1.125V12L4.5 9.375L0 12V1.125C0 0.503906 0.503906 0 1.125 0H7.875C8.49609 0 9 0.503906 9 1.125Z" fill="#EBB027"></path>
                                                </svg>
                                            </small>
                                            {/* <p>Page {i+1}</p> */}
                                        </a>
                                    
                                  </li>                              
                                  )} )}
                                
                              
                            </ul>
                          </aside>
                    </div>                  
                </div>
                <div className="footer-text line-footer-right">
                    <ul className="flex-center">
                            {targetAssetData.current?.wordCount ?<li>
                                <span>Target Word Count </span>
                                <strong>{targetAssetData.current?.wordCount}</strong>
                            </li>:""}
                    </ul>
                </div>
            </div>
        </div>
    </section>
  
  </div>
  { popUpValue === "showHistory" &&
  <div className="right-modal icr-right-modal" aria-label="history" aria-modal="true" role="dialog">
    <div className="modal-header flex">
       <div className="left flex-center">
        <div className="group-btn flex-center" role="tablist">
            <button role="tab" aria-label="edit history" className="active dashboard-btn edit-history-btn" onClick={showEditView}>Edit History</button>
            <button role="tab" aria-label="feedbacks" className="dashboard-btn feedback-btn" onClick={showFeedbackView}>Feedbacks</button>
        </div>
       </div>
       <button className="close flex-center rightClose" aria-label="close" onClick={(e)=>{jQuery("body").removeClass("modal-open");jQuery(".showingHistory").trigger('focus');jQuery(".showingHistory").removeClass('showingHistory')}}>
        <svg xmlns="http://www.w3.org/2000/svg" width="8" height="13" viewBox="0 0 8 13" fill="none">
            <path fillRule="evenodd" clipRule="evenodd" d="M1.08754 11.8956C0.817175 11.6027 0.817175 11.1278 1.08754 10.8349L5.44416 6.11523L1.08754 1.39556C0.817175 1.10267 0.817175 0.627797 1.08754 0.334905C1.3579 0.0420113 1.79625 0.0420113 2.06661 0.334905L6.91276 5.5849C7.18313 5.8778 7.18313 6.35267 6.91276 6.64556L2.06661 11.8956C1.79625 12.1885 1.3579 12.1885 1.08754 11.8956Z" fill="#1D4ED8"/>
        </svg>
       </button>
    </div>
    
    <div className="modal-content">
        <ul  className="edit-history">            
         {reversedTranslations.map((translation,index)=> 
                            <li><div role="button" className="date">
                                    <div className='relative'>
                                        <span className='font-zero setFastpass'>{translation.createdDate.date}</span>
                                        <span aria-hidden="true">{translation.createdDate.date}</span>
                                    </div>
                                </div>
                            <div className="edit-history-text">
                                <div className="text flex-center">
                                    <div className="text-left ">
                                    
          <div key ={index}>
            {index !== translationUnitForHistory?.translations.length-1 &&
            <button onClick={() => handleToggleHighlight(index)}
            title = {translate("icr.review_linebyline_translation_diff_show")}>
            
            {showDifferences[index] ? (
             <svg
             xmlns="http://www.w3.org/2000/svg"
             width="16"
             height="16"
             fill="currentColor"
             className="bi-eye"
             viewBox="0 0 16 16"
                 >
             <path d="M1 8s4-5.5 7.5-5.5C14 2.5 16 8 16 8s-2 5.5-7.5 5.5C5 13.5 1 8 1 8zm7-3.5c-1.63 0-3 1.86-3 4s1.37 4 3 4 3-1.86 3-4-1.37-4-3-4zm-1.5 4a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0z" />
                 </svg>
                ) : (
                    <svg width="16px" height="16px" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" fill="none">
                    <path fill="#535358" d="M22 16a1 1 0 10-2 0h2zm-6 4a1 1 0 100 2v-2zm-6-4a1 1 0 102 0h-2zm6-4a1 1 0 100-2v2zm-2.776 11.68a1 1 0 00-.448 1.95l.448-1.95zm-7.9-2.007a1 1 0 001.351-1.475l-1.35 1.475zM19.242 8.436a1 1 0 00.518-1.932l-.518 1.932zm7.358 1.822a1 1 0 10-1.34 1.484l1.34-1.484zM28 16c0 .464-.243 1.203-.853 2.116-.593.888-1.471 1.845-2.578 2.727C22.351 22.611 19.314 24 16 24v2c3.866 0 7.329-1.611 9.816-3.593 1.246-.993 2.271-2.099 2.994-3.18C29.515 18.172 30 17.037 30 16h-2zM4 16c0-.464.243-1.203.853-2.116.593-.888 1.471-1.845 2.578-2.727C9.649 9.389 12.686 8 16 8V6c-3.866 0-7.329 1.611-9.816 3.593-1.246.993-2.271 2.098-2.994 3.18C2.485 13.828 2 14.963 2 16h2zm16 0a4 4 0 01-4 4v2a6 6 0 006-6h-2zm-8 0a4 4 0 014-4v-2a6 6 0 00-6 6h2zm4 8c-.952 0-1.881-.114-2.776-.32l-.448 1.95c1.031.236 2.111.37 3.224.37v-2zm0-16c1.118 0 2.205.158 3.24.436l.52-1.932A14.489 14.489 0 0016 6v2zm9.258 3.742c.899.812 1.6 1.655 2.071 2.427.482.79.671 1.423.671 1.831h2c0-.928-.389-1.93-.963-2.872-.586-.962-1.42-1.95-2.438-2.87l-1.34 1.484zM6.675 20.198c-.878-.804-1.563-1.636-2.021-2.395C4.184 17.024 4 16.403 4 16H2c0 .917.38 1.906.941 2.836.573.95 1.389 1.926 2.384 2.837l1.35-1.475z"/>
                    <path stroke="#535358" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 25L25 7"/>
                  </svg>
                )}
                    </button> }

                    <div className="text-left text-order-wrap">
            <p className="para-order-number">{translationUnitForHistory?.translations.length - index}</p>
            <p className="order-description">{description[index]}</p>
          </div>

                                        </div>
                                    </div>
                                    <div className="text-right">
                             {((translationUnitForHistory?.status !=="APPROVED" && index !== 0) || !translation?.isMostRecent && isFileInReviewableState && allowedToEditSegments) && (targetAssetData.current.status !=="IN_REVISION") &&
                            <button className="activeClass" aria-label="Revert to this Revision" title="Revert to this Revision" onClick={()=>revertTranslation(translationUnitForHistory?.id,translationUnitForHistory?.translations?.length - index)}>
                                <svg style={{"height" : "24px"}} xmlns="http://www.w3.org/2000/svg" className="aaa-change-icon"  viewBox="0 0 1024 1024" version="1.1">
                                    <path d="M338.7 174.6L135.3 378.3c-12.5 12.5-12.5 32.8 0 45.3l180.1 180.3c6.2 6.2 14.4 9.4 22.6 9.4 8.2 0 16.4-3.1 22.6-9.4l22.6-22.6L203 400.9l158.2-158.4c12.5-12.5 12.5-32.8 0-45.3l-22.5-22.6z" fill="#1D4ED8"/>
                                    <path d="M654.5 369.4h-496c-17.7 0-32 14.3-32 32s14.3 32 32 32h496c97.2 0 176 78.8 176 176s-78.8 176-176 176h-496c-17.7 0-32 14.3-32 32s14.3 32 32 32h496c132.5 0 240-107.5 240-240s-107.5-240-240-240z" fill="#1D4ED8"/>
                                </svg>
                            </button>}
                        </div>
                    </div>
                    {translationUnitForHistory?.translations.length - index === 1 ?
                        <div className="message flex-center">
                            <p>{translate("icr.review_linebyline_translation_delivered_initial")} </p>
                        </div>:
                        translation?.customerUser ?
                            <div className="message flex-center">
                                <div className="left">
                                <p>Edited By: <span className="name"> {translation?.customerUser?.firstName} {translation?.customerUser?.lastName}</span></p>
                                </div>                                
                                    <div className="right">
                                    <ConditionalBlock condition={translation?.feedback?.severity}>
                                        <p>{translation?.feedback?.severity} {">"} </p>
                                    </ConditionalBlock>
                                    <ConditionalBlock condition={translation?.feedback?.category}>                                          
                                        <p>{translation?.feedback?.categoryType}: {translation?.feedback?.category}</p>
                                    </ConditionalBlock>
                                    </div>
                                
                            </div>:
                            (
                                isAdvanceWorkflow ?
                                    <div className="message flex-center">
                                        <p>{translate("icr.review_linebyline_translation_pe")}</p>
                                    </div>
                                :
                                <div className="message flex-center">
                                    <p>{translate("icr.review_linebyline_translation_delivered")}</p>
                                </div>
                            )
                        }
                </div>
            </li>
            )}
        </ul>
        <ul className="feedback-content hide">
         {translationUnitForHistory?.translations?.map((translation, index) => (
  <li key={index}>
    {translation?.comments?.reverse().map((comment, commentIndex) => (
      <div key={commentIndex}>
        <div role="button" aria-label="date" className="date">
          {comment.createdDate.date} {comment.createdDate.timeOfDay}
        </div>
        <div className="edit-history-text">
          <h4>{comment.text}</h4>
          <div className="text flex-center">
            <div className="text-left feedback-text">
              <p>{translation.text}</p>
            </div>
          </div>
          <div className="message flex-center">
            <div className="left">
              <p>
                Feedback By: <span className="name"> {comment?.userDisplayName}</span>
              </p>
            </div>
            <div className="right">
              <p>
                {comment?.feedback?.severity} {comment?.feedback?.categoryType}: {comment?.feedback?.category}
              </p>
            </div>
          </div>
          { translation.isMostRecent && comment.userId == currentUser.userId &&
          <div className="multiselect-output flex">
          <button aria-label={`remove comment at index ${commentIndex}`} onClick={() => handleDeleteComment(index, commentIndex)}>
										<strong> Delete</strong>
									</button>
                                    </div>
        }
        </div>
      </div>
    ))}
  </li>
))}
        </ul> 
    </div>
    
  </div>
  }
                
  <div className="left-modal reference-modal">
    <div className="modal-header flex">
       <div className="left flex-center">
        <div className="group-btn flex-center">
            <h4>Reference Material</h4>
        </div>
       </div>
       <button className="close flex-center" aria-label="close" onclick="hideLeftModel()">
        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
            <path d="M17.9242 17.9242C15.94 19.9085 13.3062 21 10.5 21C7.69381 21 5.05997 19.9085 3.07576 17.9242C1.09154 15.94 0 13.3062 0 10.5C0 7.69381 1.09154 5.05997 3.07576 3.07576C5.05997 1.09154 7.69381 -5.75215e-07 10.5 -5.75215e-07C13.3062 -5.75215e-07 15.94 1.09154 17.9242 3.07576C19.9085 5.05997 21 7.69381 21 10.5C21 13.3062 19.9085 15.94 17.9242 17.9242ZM17.0802 3.91982C15.3213 2.16098 12.9836 1.19318 10.5 1.19318C8.01641 1.19318 5.67866 2.16098 3.91982 3.91982C0.291667 7.54798 0.291667 13.452 3.91982 17.0802C5.67866 18.839 8.01641 19.8068 10.5 19.8068C12.9836 19.8068 15.3213 18.839 17.0802 17.0802C20.7083 13.452 20.7083 7.54798 17.0802 3.91982Z" fill="#1D4ED8"/>
            <path d="M15.1268 15.1271C14.8926 15.3613 14.517 15.3613 14.2828 15.1271L10.4999 11.3442L6.71712 15.1271C6.4829 15.3613 6.10727 15.3613 5.87305 15.1271C5.63883 14.8929 5.63883 14.5172 5.87305 14.283L9.65588 10.5002L5.87305 6.71735C5.63883 6.48313 5.63883 6.1075 5.87305 5.87328C5.98795 5.75838 6.14262 5.69652 6.29287 5.69652C6.44313 5.69652 6.5978 5.75397 6.7127 5.87328L10.4955 9.65611L14.2784 5.87328C14.3933 5.75838 14.5479 5.69652 14.6982 5.69652C14.8528 5.69652 15.0031 5.75397 15.118 5.87328C15.3522 6.1075 15.3522 6.48313 15.118 6.71735L11.344 10.5002L15.1268 14.283C15.3611 14.5172 15.3611 14.8929 15.1268 15.1271Z" fill="#1D4ED8"/>
        </svg>
       </button>
    </div>
    <div className="modal-content">
        <ul className="reference-list">
            <li>
                <button aria-label="reference document" className="reference-doc flex-center">
                    <span className="img-main pdf flex-center"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="22" viewBox="0 0 18 22" fill="none">
                        <path d="M15.1223 21.6845H2.93761C2.23033 21.6837 1.55226 21.4023 1.05214 20.9022C0.552021 20.4021 0.270682 19.724 0.269836 19.0168V2.95049C0.270682 2.24321 0.552021 1.56514 1.05214 1.06502C1.55226 0.5649 2.23033 0.28356 2.93761 0.282715H10.9287C11.1403 0.28276 11.3433 0.366822 11.493 0.516431L17.5558 6.57921C17.63 6.65336 17.6889 6.74141 17.7291 6.83833C17.7693 6.93526 17.79 7.03915 17.79 7.14407V19.0162C17.7893 19.7236 17.5081 20.4018 17.0079 20.902C16.5078 21.4023 15.8296 21.6837 15.1223 21.6845ZM2.93761 1.87987C2.65375 1.88015 2.3816 1.99303 2.18088 2.19375C1.98016 2.39447 1.86727 2.66663 1.86699 2.95049V19.0168C1.86727 19.3006 1.98016 19.5728 2.18088 19.7735C2.3816 19.9742 2.65375 20.0871 2.93761 20.0874H15.1223C15.4061 20.0871 15.6783 19.9742 15.879 19.7735C16.0797 19.5728 16.1926 19.3006 16.1929 19.0168V7.47468L10.5975 1.87987H2.93761Z" fill="#FD6161"/>
                        <path d="M16.992 7.94265H12.7979C12.0906 7.9418 11.4126 7.66046 10.9124 7.16034C10.4123 6.66022 10.131 5.98215 10.1301 5.27487V1.08129C10.1301 0.869495 10.2143 0.666374 10.364 0.516612C10.5138 0.36685 10.7169 0.282715 10.9287 0.282715C11.1405 0.282715 11.3436 0.36685 11.4934 0.516612C11.6431 0.666374 11.7273 0.869495 11.7273 1.08129V5.27487C11.7276 5.55873 11.8404 5.83089 12.0412 6.03161C12.2419 6.23233 12.514 6.34522 12.7979 6.3455H16.9915C17.2033 6.3455 17.4064 6.42963 17.5562 6.57939C17.7059 6.72916 17.7901 6.93228 17.7901 7.14407C17.7901 7.35587 17.7059 7.55899 17.5562 7.70875C17.4064 7.85851 17.2033 7.94265 16.9915 7.94265H16.992Z" fill="#FD6161"/>
                        <path d="M3.32104 11.9605C3.32104 11.7843 3.48076 11.6294 3.72992 11.6294H5.18439C6.11446 11.6294 6.84755 12.0665 6.84755 13.2505V13.2856C6.84755 14.4697 6.08625 14.9206 5.11358 14.9206H4.41776V16.4427C4.41776 16.6684 4.14305 16.7807 3.8678 16.7807C3.59256 16.7807 3.32104 16.6684 3.32104 16.4427V11.9605ZM4.42042 12.5877V14.0746H5.11784C5.51234 14.0746 5.75244 13.8494 5.75244 13.3703V13.2926C5.75244 12.8134 5.51234 12.5877 5.11784 12.5877H4.42042Z" fill="#FD6161"/>
                        <path d="M9.05538 11.6294C10.028 11.6294 10.7894 12.0803 10.7894 13.2926V15.1181C10.7894 16.3298 10.028 16.7807 9.05538 16.7807H7.808C7.51945 16.7807 7.32886 16.6258 7.32886 16.4496V11.9605C7.32886 11.7843 7.51945 11.6294 7.808 11.6294H9.05538ZM8.42823 12.5877V15.8224H9.05538C9.45041 15.8224 9.68998 15.5972 9.68998 15.1181V13.2926C9.68998 12.8134 9.45041 12.5877 9.05538 12.5877H8.42823Z" fill="#FD6161"/>
                        <path d="M11.486 11.968C11.486 11.7423 11.7256 11.6294 11.9652 11.6294H14.4104C14.643 11.6294 14.7421 11.8764 14.7421 12.1016C14.7421 12.3625 14.6223 12.5877 14.4104 12.5877H12.5848V13.7792H13.6496C13.8626 13.7792 13.9808 13.9831 13.9808 14.2088C13.9808 14.3989 13.8823 14.6246 13.6496 14.6246H12.5848V16.4427C12.5848 16.6684 12.3101 16.7807 12.0354 16.7807C11.7607 16.7807 11.4855 16.6684 11.4855 16.4427L11.486 11.968Z" fill="#FD6161"/>
                        </svg>
                    </span>
                    <a className="text flex-center">
                        pigments_design_automotive_expertise-page.pdf (German)
                            <svg xmlns="http://www.w3.org/2000/svg" width="11" height="6" viewBox="0 0 11 6" fill="none">
                                <path d="M1.27734 1L5.27734 5L9.27734 1" stroke="#1D4ED8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                    </a>
                </button>
                <div className="preview-content hide">
                    <div className="pdf-extend flex-center">
                        <svg xmlns="http://www.w3.org/2000/svg" width="45" height="55" viewBox="0 0 45 55" fill="none">
                            <path d="M37.9191 54.6401H6.81098C5.00526 54.6379 3.27411 53.9196 1.99727 52.6428C0.720434 51.3659 0.00215823 49.6348 0 47.8291V6.81098C0.00215823 5.00526 0.720434 3.27411 1.99727 1.99727C3.27411 0.720434 5.00526 0.00215824 6.81098 0H27.2127C27.753 0.000115371 28.2712 0.21473 28.6534 0.596691L44.132 16.0753C44.3216 16.2646 44.472 16.4894 44.5746 16.7369C44.6772 16.9843 44.73 17.2496 44.7301 17.5174V47.8277C44.7283 49.6337 44.0102 51.3652 42.7333 52.6423C41.4564 53.9194 39.7251 54.6379 37.9191 54.6401ZM6.81098 4.07762C6.08627 4.07834 5.39144 4.36655 4.87899 4.87899C4.36655 5.39144 4.07834 6.08627 4.07762 6.81098V47.8291C4.07834 48.5538 4.36655 49.2486 4.87899 49.7611C5.39144 50.2735 6.08627 50.5617 6.81098 50.5624H37.9191C38.6438 50.5617 39.3386 50.2735 39.8511 49.7611C40.3635 49.2486 40.6518 48.5538 40.6525 47.8291V18.3615L26.3672 4.07762H6.81098Z" fill="#A59F9F"/>
                            <path d="M42.6926 19.5562H31.9848C30.1791 19.5541 28.4479 18.8358 27.1711 17.559C25.8943 16.2821 25.176 14.551 25.1738 12.7453V2.03881C25.1738 1.49808 25.3886 0.979504 25.771 0.597153C26.1533 0.214802 26.6719 0 27.2126 0C27.7534 0 28.2719 0.214802 28.6543 0.597153C29.0366 0.979504 29.2514 1.49808 29.2514 2.03881V12.7453C29.2522 13.47 29.5404 14.1648 30.0528 14.6773C30.5653 15.1897 31.2601 15.4779 31.9848 15.4786H42.6913C43.232 15.4786 43.7506 15.6934 44.1329 16.0758C44.5153 16.4581 44.7301 16.9767 44.7301 17.5174C44.7301 18.0582 44.5153 18.5767 44.1329 18.9591C43.7506 19.3414 43.232 19.5562 42.6913 19.5562H42.6926Z" fill="#A59F9F"/>
                            <path d="M7.78979 29.8137C7.78979 29.3638 8.19756 28.9683 8.83366 28.9683H12.547C14.9215 28.9683 16.7932 30.0842 16.7932 33.107V33.1967C16.7932 36.2196 14.8495 37.3709 12.3662 37.3709H10.5898V41.2568C10.5898 41.8331 9.88841 42.1199 9.1857 42.1199C8.48299 42.1199 7.78979 41.8331 7.78979 41.2568V29.8137ZM10.5966 31.4148V35.2111H12.3771C13.3843 35.2111 13.9973 34.6361 13.9973 33.4129V33.2144C13.9973 31.9911 13.3843 31.4148 12.3771 31.4148H10.5966Z" fill="#A59F9F"/>
                            <path d="M22.4299 28.9683C24.9131 28.9683 26.8568 30.1195 26.8568 33.2144V37.8751C26.8568 40.9687 24.9131 42.1199 22.4299 42.1199H19.2453C18.5086 42.1199 18.022 41.7244 18.022 41.2745V29.8137C18.022 29.3638 18.5086 28.9683 19.2453 28.9683H22.4299ZM20.8287 31.4148V39.6734H22.4299C23.4384 39.6734 24.05 39.0984 24.05 37.8751V33.2144C24.05 31.9911 23.4384 31.4148 22.4299 31.4148H20.8287Z" fill="#A59F9F"/>
                            <path d="M28.6356 29.8327C28.6356 29.2564 29.2473 28.9683 29.8589 28.9683H36.1018C36.6957 28.9683 36.9485 29.5989 36.9485 30.1739C36.9485 30.8399 36.6427 31.4148 36.1018 31.4148H31.441V34.4567H34.1594C34.7031 34.4567 35.0049 34.9773 35.0049 35.5536C35.0049 36.0388 34.7534 36.6151 34.1594 36.6151H31.441V41.2568C31.441 41.8331 30.7397 42.1199 30.0383 42.1199C29.337 42.1199 28.6343 41.8331 28.6343 41.2568L28.6356 29.8327Z" fill="#A59F9F"/>
                        </svg>
                    </div>
                </div>
            </li>
            <li>
                <button aria-label="reference document" className="reference-doc flex-center">
                    <span className="img-main pdf flex-center"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="22" viewBox="0 0 18 22" fill="none">
                        <path d="M15.1223 21.6845H2.93761C2.23033 21.6837 1.55226 21.4023 1.05214 20.9022C0.552021 20.4021 0.270682 19.724 0.269836 19.0168V2.95049C0.270682 2.24321 0.552021 1.56514 1.05214 1.06502C1.55226 0.5649 2.23033 0.28356 2.93761 0.282715H10.9287C11.1403 0.28276 11.3433 0.366822 11.493 0.516431L17.5558 6.57921C17.63 6.65336 17.6889 6.74141 17.7291 6.83833C17.7693 6.93526 17.79 7.03915 17.79 7.14407V19.0162C17.7893 19.7236 17.5081 20.4018 17.0079 20.902C16.5078 21.4023 15.8296 21.6837 15.1223 21.6845ZM2.93761 1.87987C2.65375 1.88015 2.3816 1.99303 2.18088 2.19375C1.98016 2.39447 1.86727 2.66663 1.86699 2.95049V19.0168C1.86727 19.3006 1.98016 19.5728 2.18088 19.7735C2.3816 19.9742 2.65375 20.0871 2.93761 20.0874H15.1223C15.4061 20.0871 15.6783 19.9742 15.879 19.7735C16.0797 19.5728 16.1926 19.3006 16.1929 19.0168V7.47468L10.5975 1.87987H2.93761Z" fill="#FD6161"/>
                        <path d="M16.992 7.94265H12.7979C12.0906 7.9418 11.4126 7.66046 10.9124 7.16034C10.4123 6.66022 10.131 5.98215 10.1301 5.27487V1.08129C10.1301 0.869495 10.2143 0.666374 10.364 0.516612C10.5138 0.36685 10.7169 0.282715 10.9287 0.282715C11.1405 0.282715 11.3436 0.36685 11.4934 0.516612C11.6431 0.666374 11.7273 0.869495 11.7273 1.08129V5.27487C11.7276 5.55873 11.8404 5.83089 12.0412 6.03161C12.2419 6.23233 12.514 6.34522 12.7979 6.3455H16.9915C17.2033 6.3455 17.4064 6.42963 17.5562 6.57939C17.7059 6.72916 17.7901 6.93228 17.7901 7.14407C17.7901 7.35587 17.7059 7.55899 17.5562 7.70875C17.4064 7.85851 17.2033 7.94265 16.9915 7.94265H16.992Z" fill="#FD6161"/>
                        <path d="M3.32104 11.9605C3.32104 11.7843 3.48076 11.6294 3.72992 11.6294H5.18439C6.11446 11.6294 6.84755 12.0665 6.84755 13.2505V13.2856C6.84755 14.4697 6.08625 14.9206 5.11358 14.9206H4.41776V16.4427C4.41776 16.6684 4.14305 16.7807 3.8678 16.7807C3.59256 16.7807 3.32104 16.6684 3.32104 16.4427V11.9605ZM4.42042 12.5877V14.0746H5.11784C5.51234 14.0746 5.75244 13.8494 5.75244 13.3703V13.2926C5.75244 12.8134 5.51234 12.5877 5.11784 12.5877H4.42042Z" fill="#FD6161"/>
                        <path d="M9.05538 11.6294C10.028 11.6294 10.7894 12.0803 10.7894 13.2926V15.1181C10.7894 16.3298 10.028 16.7807 9.05538 16.7807H7.808C7.51945 16.7807 7.32886 16.6258 7.32886 16.4496V11.9605C7.32886 11.7843 7.51945 11.6294 7.808 11.6294H9.05538ZM8.42823 12.5877V15.8224H9.05538C9.45041 15.8224 9.68998 15.5972 9.68998 15.1181V13.2926C9.68998 12.8134 9.45041 12.5877 9.05538 12.5877H8.42823Z" fill="#FD6161"/>
                        <path d="M11.486 11.968C11.486 11.7423 11.7256 11.6294 11.9652 11.6294H14.4104C14.643 11.6294 14.7421 11.8764 14.7421 12.1016C14.7421 12.3625 14.6223 12.5877 14.4104 12.5877H12.5848V13.7792H13.6496C13.8626 13.7792 13.9808 13.9831 13.9808 14.2088C13.9808 14.3989 13.8823 14.6246 13.6496 14.6246H12.5848V16.4427C12.5848 16.6684 12.3101 16.7807 12.0354 16.7807C11.7607 16.7807 11.4855 16.6684 11.4855 16.4427L11.486 11.968Z" fill="#FD6161"/>
                        </svg>
                    </span>
                    <a className="text flex-center">
                        sampleFiletemp.pdf (Danish)
                            <svg xmlns="http://www.w3.org/2000/svg" width="11" height="6" viewBox="0 0 11 6" fill="none">
                                <path d="M1.27734 1L5.27734 5L9.27734 1" stroke="#1D4ED8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                    </a>
                </button>
            </li>
            <li>
                <button aria-label="reference document" className="reference-doc flex-center">
                    <span className="img-main pdf flex-center"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="22" viewBox="0 0 18 22" fill="none">
                        <path d="M15.1223 21.6845H2.93761C2.23033 21.6837 1.55226 21.4023 1.05214 20.9022C0.552021 20.4021 0.270682 19.724 0.269836 19.0168V2.95049C0.270682 2.24321 0.552021 1.56514 1.05214 1.06502C1.55226 0.5649 2.23033 0.28356 2.93761 0.282715H10.9287C11.1403 0.28276 11.3433 0.366822 11.493 0.516431L17.5558 6.57921C17.63 6.65336 17.6889 6.74141 17.7291 6.83833C17.7693 6.93526 17.79 7.03915 17.79 7.14407V19.0162C17.7893 19.7236 17.5081 20.4018 17.0079 20.902C16.5078 21.4023 15.8296 21.6837 15.1223 21.6845ZM2.93761 1.87987C2.65375 1.88015 2.3816 1.99303 2.18088 2.19375C1.98016 2.39447 1.86727 2.66663 1.86699 2.95049V19.0168C1.86727 19.3006 1.98016 19.5728 2.18088 19.7735C2.3816 19.9742 2.65375 20.0871 2.93761 20.0874H15.1223C15.4061 20.0871 15.6783 19.9742 15.879 19.7735C16.0797 19.5728 16.1926 19.3006 16.1929 19.0168V7.47468L10.5975 1.87987H2.93761Z" fill="#FD6161"/>
                        <path d="M16.992 7.94265H12.7979C12.0906 7.9418 11.4126 7.66046 10.9124 7.16034C10.4123 6.66022 10.131 5.98215 10.1301 5.27487V1.08129C10.1301 0.869495 10.2143 0.666374 10.364 0.516612C10.5138 0.36685 10.7169 0.282715 10.9287 0.282715C11.1405 0.282715 11.3436 0.36685 11.4934 0.516612C11.6431 0.666374 11.7273 0.869495 11.7273 1.08129V5.27487C11.7276 5.55873 11.8404 5.83089 12.0412 6.03161C12.2419 6.23233 12.514 6.34522 12.7979 6.3455H16.9915C17.2033 6.3455 17.4064 6.42963 17.5562 6.57939C17.7059 6.72916 17.7901 6.93228 17.7901 7.14407C17.7901 7.35587 17.7059 7.55899 17.5562 7.70875C17.4064 7.85851 17.2033 7.94265 16.9915 7.94265H16.992Z" fill="#FD6161"/>
                        <path d="M3.32104 11.9605C3.32104 11.7843 3.48076 11.6294 3.72992 11.6294H5.18439C6.11446 11.6294 6.84755 12.0665 6.84755 13.2505V13.2856C6.84755 14.4697 6.08625 14.9206 5.11358 14.9206H4.41776V16.4427C4.41776 16.6684 4.14305 16.7807 3.8678 16.7807C3.59256 16.7807 3.32104 16.6684 3.32104 16.4427V11.9605ZM4.42042 12.5877V14.0746H5.11784C5.51234 14.0746 5.75244 13.8494 5.75244 13.3703V13.2926C5.75244 12.8134 5.51234 12.5877 5.11784 12.5877H4.42042Z" fill="#FD6161"/>
                        <path d="M9.05538 11.6294C10.028 11.6294 10.7894 12.0803 10.7894 13.2926V15.1181C10.7894 16.3298 10.028 16.7807 9.05538 16.7807H7.808C7.51945 16.7807 7.32886 16.6258 7.32886 16.4496V11.9605C7.32886 11.7843 7.51945 11.6294 7.808 11.6294H9.05538ZM8.42823 12.5877V15.8224H9.05538C9.45041 15.8224 9.68998 15.5972 9.68998 15.1181V13.2926C9.68998 12.8134 9.45041 12.5877 9.05538 12.5877H8.42823Z" fill="#FD6161"/>
                        <path d="M11.486 11.968C11.486 11.7423 11.7256 11.6294 11.9652 11.6294H14.4104C14.643 11.6294 14.7421 11.8764 14.7421 12.1016C14.7421 12.3625 14.6223 12.5877 14.4104 12.5877H12.5848V13.7792H13.6496C13.8626 13.7792 13.9808 13.9831 13.9808 14.2088C13.9808 14.3989 13.8823 14.6246 13.6496 14.6246H12.5848V16.4427C12.5848 16.6684 12.3101 16.7807 12.0354 16.7807C11.7607 16.7807 11.4855 16.6684 11.4855 16.4427L11.486 11.968Z" fill="#FD6161"/>
                        </svg>
                    </span>
                    <a className="text flex-center">
                        sampleFiletemp.pdf (Danish)
                            <svg xmlns="http://www.w3.org/2000/svg" width="11" height="6" viewBox="0 0 11 6" fill="none">
                                <path d="M1.27734 1L5.27734 5L9.27734 1" stroke="#1D4ED8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                    </a>
                </button>
            </li>
            <li>
                <button aria-label="reference document" className="reference-doc flex-center">
                    <span className="img-main img flex-center">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="19" viewBox="0 0 20 19" fill="none">
                        <path d="M12.7141 5.21755C12.2688 4.51925 11.1532 4.52206 10.7094 5.21504L7.84618 9.66532L7.20443 8.75728C6.75833 8.08228 5.70961 8.11442 5.2596 8.75728L2.73485 12.3396C2.46887 12.7175 2.43158 13.2123 2.63518 13.6253C2.83855 14.0448 3.25021 14.3059 3.70805 14.3059H16.3279C16.7744 14.3059 17.1809 14.0536 17.3899 13.6478C17.5978 13.246 17.5752 12.7603 17.3306 12.3798L12.7141 5.21755ZM3.74913 13.0202L6.19053 9.50943L7.36095 11.1704C7.48226 11.3408 7.68574 11.4613 7.8814 11.4372C8.08684 11.4322 8.2774 11.3255 8.39089 11.1484L11.6713 5.92919L16.2398 13.0202H3.74913ZM17.496 0.163086H2.46954C1.12147 0.163086 0 1.3142 0 2.73451V15.5917C0 17.012 1.12111 18.1631 2.46918 18.1631H17.4956C18.8789 18.1631 20 17.012 20 15.5917V2.73451C20.0004 1.3142 18.9125 0.163086 17.496 0.163086ZM18.7834 15.5917C18.7834 16.3004 18.2214 16.8774 17.5312 16.8774H2.50476C1.81448 16.8774 1.25256 16.3004 1.25256 15.5917V2.73451C1.25256 2.02576 1.81448 1.4488 2.50476 1.4488H17.5312C18.2214 1.4488 18.7834 2.02576 18.7834 2.73451V15.5917ZM5.63526 6.59166C6.67224 6.59166 7.51356 5.72782 7.51356 4.66309C7.51356 3.59835 6.67224 2.73451 5.63526 2.73451C4.59828 2.73451 3.75696 3.59835 3.75696 4.66309C3.75696 5.72782 4.59828 6.59166 5.63526 6.59166ZM5.63526 4.02023C5.98048 4.02023 6.22614 4.30863 6.22614 4.66309C6.22614 5.01754 5.97962 5.30594 5.63526 5.30594C5.29091 5.30594 5.00916 5.01666 5.00916 4.66309C5.00916 4.30951 5.29091 4.02023 5.63526 4.02023Z" fill="#128FEB"/>
                        </svg>
                    </span>
                    <a className="text text-img flex-center">
                        sampleFiletemp.pdf (Danish)
                            <svg xmlns="http://www.w3.org/2000/svg" width="11" height="6" viewBox="0 0 11 6" fill="none">
                                <path d="M1.27734 1L5.27734 5L9.27734 1" stroke="#1D4ED8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                    </a>
                </button>
            </li>
            <li>
                <button aria-label="reference document" className="reference-doc flex-center">
                    <span className="img-main img flex-center">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="19" viewBox="0 0 20 19" fill="none">
                        <path d="M12.7141 5.21755C12.2688 4.51925 11.1532 4.52206 10.7094 5.21504L7.84618 9.66532L7.20443 8.75728C6.75833 8.08228 5.70961 8.11442 5.2596 8.75728L2.73485 12.3396C2.46887 12.7175 2.43158 13.2123 2.63518 13.6253C2.83855 14.0448 3.25021 14.3059 3.70805 14.3059H16.3279C16.7744 14.3059 17.1809 14.0536 17.3899 13.6478C17.5978 13.246 17.5752 12.7603 17.3306 12.3798L12.7141 5.21755ZM3.74913 13.0202L6.19053 9.50943L7.36095 11.1704C7.48226 11.3408 7.68574 11.4613 7.8814 11.4372C8.08684 11.4322 8.2774 11.3255 8.39089 11.1484L11.6713 5.92919L16.2398 13.0202H3.74913ZM17.496 0.163086H2.46954C1.12147 0.163086 0 1.3142 0 2.73451V15.5917C0 17.012 1.12111 18.1631 2.46918 18.1631H17.4956C18.8789 18.1631 20 17.012 20 15.5917V2.73451C20.0004 1.3142 18.9125 0.163086 17.496 0.163086ZM18.7834 15.5917C18.7834 16.3004 18.2214 16.8774 17.5312 16.8774H2.50476C1.81448 16.8774 1.25256 16.3004 1.25256 15.5917V2.73451C1.25256 2.02576 1.81448 1.4488 2.50476 1.4488H17.5312C18.2214 1.4488 18.7834 2.02576 18.7834 2.73451V15.5917ZM5.63526 6.59166C6.67224 6.59166 7.51356 5.72782 7.51356 4.66309C7.51356 3.59835 6.67224 2.73451 5.63526 2.73451C4.59828 2.73451 3.75696 3.59835 3.75696 4.66309C3.75696 5.72782 4.59828 6.59166 5.63526 6.59166ZM5.63526 4.02023C5.98048 4.02023 6.22614 4.30863 6.22614 4.66309C6.22614 5.01754 5.97962 5.30594 5.63526 5.30594C5.29091 5.30594 5.00916 5.01666 5.00916 4.66309C5.00916 4.30951 5.29091 4.02023 5.63526 4.02023Z" fill="#128FEB"/>
                        </svg>
                    </span>
                    <a className="text text-img flex-center">
                        sampleFiletemp.pdf (Danish)
                            <svg xmlns="http://www.w3.org/2000/svg" width="11" height="6" viewBox="0 0 11 6" fill="none">
                                <path d="M1.27734 1L5.27734 5L9.27734 1" stroke="#1D4ED8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                    </a>
                </button>
            </li>
        </ul>
    </div>
  </div>
  { popUpValue === "discussion" &&
        <DiscussionOverviewPopup id={param.id} targetAssetId={targetAssetData?.current.id} userGroupId={""} showChatBox={showChatBox}/>
    }

   { popUpValue === "approval" && <ApproveAssetPopup targetLanguage={targetLanguage.current} commentedThisRevisionCount={commentedThisRevisionCount} uncommittedEditsCount={uncommittedEditsCount}
        targetAssetData={targetAssetData} projectId={param.id} languageCode={param.lang} showActionDropdown={setShowActionDropdown} workflowStatus={workflowStatus} />
    }       	    

{ popUpValue === "revision" &&
    <div className='lightbox-panel' aria-labelledby="requestRevision" aria-modal="true" role="dialog">
        <div className="inner-lightbox-panel pb-0">
            <div className="modal-header flex padd-lr">
                <h5 id="requestRevision">Request Revision</h5>
            </div>
            <div className="lightbox-content padd-22">
                <p className="f16-para">
                    Request Revision for {targetAssetData.current.name} {targetLanguage.current?.display} language.
                </p>
                <div className="flex wrap-dropdown mar-bot10">
                    <div className="global-dropdown-block" style={{width: "100%"}}>
                        <label htmlFor="description">{translate("icr.label_revision_description")}</label>
                        <textarea id="description" className="textarea"
                                  title={translate("icr.label_revision_description")}
                                  onChange={(event) => setRevisionDescription(event.target.value)}></textarea>

                    </div>
                </div>
                <div className="flex wrap-dropdown mar-bot10">
                    <div className="global-dropdown-block">
                        <button className="step-cal 1" aria-label="Due date calendar"
                                aria-expanded={dueDateCalendarExpanded}
                                onClick={(e) => {
                                    toggleCalendar(e);
                                }}>
                            <h5 id="dueDateHeader">{translate("icr.label_revision_due_date")}
                                {calenderIcon}
                            </h5>
                            <span className="due-date">
                                {revisionDueDate ? dateFormat(revisionDueDate, Constants.DATE_FORMAT_TASKS) : ""}
                            </span>
                        </button>
                        <div className={showCalendar
                            ? `popover-body-calendar global-dropdown-block m-0 show-assignee-dropdown`
                            : `popover-body popover-body-calendar global-dropdown-block m-0`}>
                            <div className="triangle-with-shadow"></div>
                            <div className="inner-popover">
                                <Calendar calendarType="US" locale="en"
                                          onChange={(value, event) => changeDate(value, event)}
                                          navigationLabel={({date, label, locale, view}) => showCustomNavigationLabel(date, label, locale, view)}
                                          onViewChange={({action,activeStartDate,value,view}) => viewChange(action, activeStartDate, value, view)}
                                          nextAriaLabel={nextAriaLabel}
                                          prevAriaLabel={prevAriaLabel}
                                          next2AriaLabel={next2AriaLabel}
                                          prev2AriaLabel={prev2AriaLabel}
                                          dropdownMode="select"
                                          popperClassName="date-picker-reports"
                                          minDate={new Date()}
                                          className="dashCalendar dashCalendarICR">
                                </Calendar>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="flex wrap-dropdown mar-bot10">
                    <div style={{width: "100%"}}>
                        <FileDragUpload ref={revisionFileRef}
                                        onChange={handleRevisionFileChange}
                                        getUploadParams={getRequestRevisionParams}
                                        uploadUrl={APIUrls.REVISE_TRANSLATION(param.id,targetAssetData.current.id,"htm")}
                                        uploadEndHandler={uploadEndHandler}>
                            <p id="descriptionHeader">{translate("icr.label_revision_file")}</p>
                        </FileDragUpload>
                    </div>
                </div>
            </div>
            <div className="modal-footer modal-footer-border flex px-22">
                <button className="btn btn-bold first-focusEvent" onKeyDown={hideKeyFinishEnterflow}
                        disabled={isSubmittingRevisionRequest}
                        onClick={(e) => jQuery("body").removeClass("modal-open")}>Cancel
                </button>
                <button className="btn btn-bold active finshBtn"
                        onKeyDown={handleKeyFinishflow}
                        disabled={isSubmittingRevisionRequest}
                        onClick={requestRevision}>Finish Review
                </button>
            </div>
        </div>
    </div>
          }
{ popUpValue === "uploadTranslation" && <UploadReviseTranslation
                closeUploadTranslation={closeUploadTranslation}
                option={options}
                projectId={param.id}
                 targetLangDisplay={phaseRevisionTask.language.displayName}
                 revisionOrReviewData={{'current': [asset]}}
                langCode={phaseRevisionTask.language.code}
                refresh={navigateBack}
              />}
{ popUpValue === "moveback" &&
   <div className='lightbox-panel' aria-labelledby="removelabel" aria-modal="true" role="dialog">
            <div className="inner-lightbox-panel pb-0">
            <div className="modal-header flex padd-lr">
              <h5 id="removelabel">Reject</h5>
             </div>
             <div className="lightbox-content padd-22">
               <p className="f16-para">
               {assetMovebackMessage}
               </p>
             </div>	
             <div className="modal-footer modal-footer-border flex px-22">
                    <button className="btn btn-bold first-focus" onClick={movebackAsset}>Submit</button>
                    <button className="btn btn-bold active" onClick={(e)=>jQuery("body").removeClass("modal-open")}>Cancel</button>
            </div>
            </div>		
          </div> 
          }  
          <div className={loaderState ? "gb-overlay show" : "gb-overlay hide"}>
      <div className="gb-loader">
          <RotatingLines
            strokeColor="#0096FF"
            strokeWidth="5"
            width="196"
            visible={true}
          />
        </div>
      </div>     	    
        </>
    )


}